/* Dati della modale "Generale" - generati il 2026-09-14 dal Pannello Modali ADC.
   Per aggiornare testi, prezzi o link: rigenerare questo file dal pannello
   e ricaricarlo in Assets con lo stesso nome. */
window.MODALE_SELEZIONE_CORSO_DATI = {
  "variante": "Generale",
  "percorso": {
    "passoIniziale": "level",
    "livelloFisso": null,
    "tierFisso": null,
    "upgrade": false
  },
  "config": {
    "show_civil_exam_commitment": false,
    "add_faculty_mailto": "amministrazione@alessandrodeconcini.com",
    "show_counter": false,
    "show_button_price": true,
    "show_result_price": true,
    "show_buy_installments": true,
    "fade_result_info": true,
    "show_result_border": true,
    "show_result_border_mobile": true,
    "result_border_width": 5,
    "result_border_color": "#FFFFFF",
    "clickable_course_cover": true,
    "buy_full_to_new_tab": false,
    "buy_installments_to_new_tab": false,
    "course_cover_to_new_tab": false,
    "buy_full_before_installments": true
  },
  "questions": {
    "guidingQuestions": {
      "level": {
        "label": "Per cosa studi?",
        "counter": "Domanda 1"
      },
      "tier": {
        "label": "Quale versione di Sistema ADC preferisci?",
        "counter": "Domanda 2"
      },
      "commitment": {
        "label": "Lo studio è la tua occupazione principale?",
        "counter": "Domanda 3"
      },
      "macro": {
        "label": "Quale facoltà o corso di studi frequenti?",
        "counter": "Domanda 4"
      }
    },
    "selectOptions": {
      "school": {
        "label": "Scuole superiori",
        "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/ICONA-SCUOLA-scaled.png"
      },
      "university": {
        "label": "Università",
        "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/ICONA-UNI-scaled.png"
      },
      "civil-service-exam": {
        "label": "Concorsi o abilitazioni",
        "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/ICONA-CONCORSI-scaled.png"
      },
      "base": {
        "label": "BASE",
        "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/ICONA-BASE-SENZA-SCRITTA.png"
      },
      "pro": {
        "label": "PRO",
        "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/ICONA-PRO-SENZA-SCRITTA.png"
      },
      "master": {
        "label": "MASTER",
        "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/ICONA-MASTER-SENZA-SCRITTA.png"
      },
      "full": {
        "label": "Sì, posso dedicare interamente le mie giornate allo studio",
        "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/07/icona-orologio-full-time-studio-scaled.png"
      },
      "part": {
        "label": "No, ho almeno mezza giornata occupata da altri impegni",
        "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/07/icona-orologio-part-time-studio-scaled.png"
      }
    },
    "guide": {
      "tier": "Se non sai cosa scegliere, guarda il video qui sopra"
    },
    "tierDescriptions": {
      "base": "Percorso teorico",
      "pro": "Percorso pratico e personalizzato",
      "master": "Percorso con tutor personale"
    },
    "placeholder": {
      "macro": "Digita il nome del tuo corso di studi..."
    },
    "mailto": {
      "macro": "Se non trovi la tua facoltà, scrivici"
    },
    "shortLabels": {
      "base": "Base",
      "pro": "Pro",
      "master": "Master",
      "school": "Scuola",
      "civil-service-exam": "Concorsi",
      "university": "Università",
      "full": "Tempo pieno",
      "part": "Ho impegni"
    }
  },
  "catalog": [
    {
      "corso": "Scuola",
      "tier": "base",
      "level": "school",
      "commitment": "",
      "macro": "",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/07/WhatsApp-Image-2026-07-20-at-12.49.24-scaled.jpeg",
      "name": "Sistema ADC",
      "payoff": "Scuola",
      "commitmentText": "",
      "description": "Il supporto giusto per il tuo percorso scolastico",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/xBuHXQhL/checkout",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-scuola/",
      "priceFull": 300,
      "priceDiscounted": null
    },
    {
      "corso": "Base - Concorso",
      "tier": "base",
      "level": "civil-service-exam",
      "commitment": "",
      "macro": "",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_base_logo-scaled.png",
      "name": "Sistema ADC BASE",
      "payoff": "Concorsi e abilitazioni",
      "commitmentText": "",
      "description": "Il miglior percorso per concorsi e abilitazioni",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/2t2vMUHm",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-base-concorsi/",
      "priceFull": 390,
      "priceDiscounted": null
    },
    {
      "corso": "Base - Uni",
      "tier": "base",
      "level": "university",
      "commitment": "",
      "macro": "",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_base_logo-scaled.png",
      "name": "Sistema ADC BASE",
      "payoff": "Università",
      "commitmentText": "",
      "description": "Il percorso giusto per la tua laurea",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/VWqqK8yF",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-universita-base/",
      "priceFull": 390,
      "priceDiscounted": null
    },
    {
      "corso": "Pro - Concorso - Full time",
      "tier": "pro",
      "level": "civil-service-exam",
      "commitment": "full",
      "macro": "",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_pro_logo-scaled.png",
      "name": "Sistema ADC PRO",
      "payoff": "Concorsi e abilitazioni",
      "commitmentText": "",
      "description": "Il miglior percorso per concorsi e abilitazioni",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/zkRZdzAj",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-pro-concorsi-e-abilitazioni/",
      "priceFull": 690,
      "priceDiscounted": null
    },
    {
      "corso": "Pro - Concorso - Part time",
      "tier": "pro",
      "level": "civil-service-exam",
      "commitment": "part",
      "macro": "",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_pro_logo-scaled.png",
      "name": "Sistema ADC PRO",
      "payoff": "Concorsi e abilitazioni",
      "commitmentText": "",
      "description": "Studio e impegni finalmente in equilibrio",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/zkRZdzAj",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-pro-concorsi-e-abilitazioni/",
      "priceFull": 690,
      "priceDiscounted": null
    },
    {
      "corso": "Pro - Uni - Full time - Medicina",
      "tier": "pro",
      "level": "university",
      "commitment": "full",
      "macro": "MED",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_pro_logo-scaled.png",
      "name": "Sistema ADC PRO",
      "payoff": "",
      "commitmentText": "",
      "description": "Il percorso giusto per la tua laurea",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/oLjeCrTo",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-pro-13/",
      "priceFull": 690,
      "priceDiscounted": null
    },
    {
      "corso": "Pro - Uni - Full time - Ingegneria",
      "tier": "pro",
      "level": "university",
      "commitment": "full",
      "macro": "ING",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_pro_logo-scaled.png",
      "name": "Sistema ADC PRO",
      "payoff": "",
      "commitmentText": "",
      "description": "Il percorso giusto per la tua laurea",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/Lsd9HxDe",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-pro-11/",
      "priceFull": 690,
      "priceDiscounted": null
    },
    {
      "corso": "Pro - Uni - Full time - Giurisprudenza",
      "tier": "pro",
      "level": "university",
      "commitment": "full",
      "macro": "GIU",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_pro_logo-scaled.png",
      "name": "Sistema ADC PRO",
      "payoff": "",
      "commitmentText": "",
      "description": "Il percorso giusto per la tua laurea",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/HRb8roKB",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-pro-10/",
      "priceFull": 690,
      "priceDiscounted": null
    },
    {
      "corso": "Pro - Uni - Full time - Matematica",
      "tier": "pro",
      "level": "university",
      "commitment": "full",
      "macro": "MAT",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_pro_logo-scaled.png",
      "name": "Sistema ADC PRO",
      "payoff": "",
      "commitmentText": "",
      "description": "Il percorso giusto per la tua laurea",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/2KXn2uC6",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-pro-12/",
      "priceFull": 690,
      "priceDiscounted": null
    },
    {
      "corso": "Pro - Uni - Full time - Scienze",
      "tier": "pro",
      "level": "university",
      "commitment": "full",
      "macro": "SCI",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_pro_logo-scaled.png",
      "name": "Sistema ADC PRO",
      "payoff": "",
      "commitmentText": "",
      "description": "Il percorso giusto per la tua laurea",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/wcfashuV",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-pro-15/",
      "priceFull": 690,
      "priceDiscounted": null
    },
    {
      "corso": "Pro - Uni - Full time - Studi Umanistici",
      "tier": "pro",
      "level": "university",
      "commitment": "full",
      "macro": "UMA",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_pro_logo-scaled.png",
      "name": "Sistema ADC PRO",
      "payoff": "",
      "commitmentText": "",
      "description": "Il percorso giusto per la tua laurea",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/aK2xMvRM",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-pro-16/",
      "priceFull": 690,
      "priceDiscounted": null
    },
    {
      "corso": "Pro - Uni - Full time - Psicologia",
      "tier": "pro",
      "level": "university",
      "commitment": "full",
      "macro": "PSI",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_pro_logo-scaled.png",
      "name": "Sistema ADC PRO",
      "payoff": "",
      "commitmentText": "",
      "description": "Il percorso giusto per la tua laurea",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/z78Z3MaK",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-pro-14/",
      "priceFull": 690,
      "priceDiscounted": null
    },
    {
      "corso": "Pro - Uni - Full time - Economia",
      "tier": "pro",
      "level": "university",
      "commitment": "full",
      "macro": "ECO",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_pro_logo-scaled.png",
      "name": "Sistema ADC PRO",
      "payoff": "",
      "commitmentText": "",
      "description": "Il percorso giusto per la tua laurea",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/4qCpfr56",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-pro-9/",
      "priceFull": 690,
      "priceDiscounted": null
    },
    {
      "corso": "Pro - Uni - Part time - Medicina",
      "tier": "pro",
      "level": "university",
      "commitment": "part",
      "macro": "MED",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_pro_logo-scaled.png",
      "name": "Sistema ADC PRO",
      "payoff": "",
      "commitmentText": "",
      "description": "Il percorso giusto per la tua laurea",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/MrGTTKSQ",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-pro-5/",
      "priceFull": 690,
      "priceDiscounted": null
    },
    {
      "corso": "Pro - Uni - Part time - Ingegneria",
      "tier": "pro",
      "level": "university",
      "commitment": "part",
      "macro": "ING",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_pro_logo-scaled.png",
      "name": "Sistema ADC PRO",
      "payoff": "",
      "commitmentText": "",
      "description": "Il percorso giusto per la tua laurea",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/a7iLXPiC",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-pro-3/",
      "priceFull": 690,
      "priceDiscounted": null
    },
    {
      "corso": "Pro - Uni - Part time - Giurisprudenza",
      "tier": "pro",
      "level": "university",
      "commitment": "part",
      "macro": "GIU",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_pro_logo-scaled.png",
      "name": "Sistema ADC PRO",
      "payoff": "",
      "commitmentText": "",
      "description": "Il percorso giusto per la tua laurea",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/hetaJ2ut",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-pro-2/",
      "priceFull": 690,
      "priceDiscounted": null
    },
    {
      "corso": "Pro - Uni - Part time - Matematica",
      "tier": "pro",
      "level": "university",
      "commitment": "part",
      "macro": "MAT",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_pro_logo-scaled.png",
      "name": "Sistema ADC PRO",
      "payoff": "",
      "commitmentText": "",
      "description": "Il percorso giusto per la tua laurea",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/MAV2M46i",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-pro-4/",
      "priceFull": 690,
      "priceDiscounted": null
    },
    {
      "corso": "Pro - Uni - Part time - Scienze",
      "tier": "pro",
      "level": "university",
      "commitment": "part",
      "macro": "SCI",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_pro_logo-scaled.png",
      "name": "Sistema ADC PRO",
      "payoff": "",
      "commitmentText": "",
      "description": "Il percorso giusto per la tua laurea",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/yEFmLpFE",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-pro-7/",
      "priceFull": 690,
      "priceDiscounted": null
    },
    {
      "corso": "Pro - Uni - Part time - Studi Umanistici",
      "tier": "pro",
      "level": "university",
      "commitment": "part",
      "macro": "UMA",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_pro_logo-scaled.png",
      "name": "Sistema ADC PRO",
      "payoff": "",
      "commitmentText": "",
      "description": "Il percorso giusto per la tua laurea",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/oVg6cHmC",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-pro-8/",
      "priceFull": 690,
      "priceDiscounted": null
    },
    {
      "corso": "Pro - Uni - Part time - Psicologia",
      "tier": "pro",
      "level": "university",
      "commitment": "part",
      "macro": "PSI",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_pro_logo-scaled.png",
      "name": "Sistema ADC PRO",
      "payoff": "",
      "commitmentText": "",
      "description": "Il percorso giusto per la tua laurea",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/SrnVYreB",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-pro-6/",
      "priceFull": 690,
      "priceDiscounted": null
    },
    {
      "corso": "Pro - Uni - Part time - Economia",
      "tier": "pro",
      "level": "university",
      "commitment": "part",
      "macro": "ECO",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_pro_logo-scaled.png",
      "name": "Sistema ADC PRO",
      "payoff": "",
      "commitmentText": "",
      "description": "Il percorso giusto per la tua laurea",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/rJLgwoyY",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-pro-1/",
      "priceFull": 690,
      "priceDiscounted": null
    },
    {
      "corso": "Master - Concorso - Full time",
      "tier": "master",
      "level": "civil-service-exam",
      "commitment": "full",
      "macro": "",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_master_logo-scaled.png",
      "name": "Sistema ADC MASTER",
      "payoff": "Concorsi e abilitazioni",
      "commitmentText": "",
      "description": "Il miglior percorso per concorsi e abilitazioni",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/2WLzkY4u",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-master-concorsi-e-abilitazioni/",
      "priceFull": 990,
      "priceDiscounted": null
    },
    {
      "corso": "Master - Concorso - Part time",
      "tier": "master",
      "level": "civil-service-exam",
      "commitment": "part",
      "macro": "",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_master_logo-scaled.png",
      "name": "Sistema ADC MASTER",
      "payoff": "Concorsi e abilitazioni",
      "commitmentText": "",
      "description": "Studio e impegni finalmente in equilibrio",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/2WLzkY4u",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-master-concorsi-e-abilitazioni/",
      "priceFull": 990,
      "priceDiscounted": null
    },
    {
      "corso": "Master - Uni - Full time - Medicina",
      "tier": "master",
      "level": "university",
      "commitment": "full",
      "macro": "MED",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_master_logo-scaled.png",
      "name": "Sistema ADC MASTER",
      "payoff": "",
      "commitmentText": "",
      "description": "Il percorso giusto per la tua laurea",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/X9F9YtFy",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-master-13/",
      "priceFull": 990,
      "priceDiscounted": null
    },
    {
      "corso": "Master - Uni - Full time - Ingegneria",
      "tier": "master",
      "level": "university",
      "commitment": "full",
      "macro": "ING",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_master_logo-scaled.png",
      "name": "Sistema ADC MASTER",
      "payoff": "",
      "commitmentText": "",
      "description": "Il percorso giusto per la tua laurea",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/RLFRfPLx",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-master-11/",
      "priceFull": 990,
      "priceDiscounted": null
    },
    {
      "corso": "Master - Uni - Full time - Giurisprudenza",
      "tier": "master",
      "level": "university",
      "commitment": "full",
      "macro": "GIU",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_master_logo-scaled.png",
      "name": "Sistema ADC MASTER",
      "payoff": "",
      "commitmentText": "",
      "description": "Il percorso giusto per la tua laurea",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/gKZsjSa7",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-master-10/",
      "priceFull": 990,
      "priceDiscounted": null
    },
    {
      "corso": "Master - Uni - Full time - Matematica",
      "tier": "master",
      "level": "university",
      "commitment": "full",
      "macro": "MAT",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_master_logo-scaled.png",
      "name": "Sistema ADC MASTER",
      "payoff": "",
      "commitmentText": "",
      "description": "Il percorso giusto per la tua laurea",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/YzeUBuQ4",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-master-12/",
      "priceFull": 990,
      "priceDiscounted": null
    },
    {
      "corso": "Master - Uni - Full time - Scienze",
      "tier": "master",
      "level": "university",
      "commitment": "full",
      "macro": "SCI",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_master_logo-scaled.png",
      "name": "Sistema ADC MASTER",
      "payoff": "",
      "commitmentText": "",
      "description": "Il percorso giusto per la tua laurea",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/E23wiH3d",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-master-15/",
      "priceFull": 990,
      "priceDiscounted": null
    },
    {
      "corso": "Master - Uni - Full time - Studi Umanistici",
      "tier": "master",
      "level": "university",
      "commitment": "full",
      "macro": "UMA",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_master_logo-scaled.png",
      "name": "Sistema ADC MASTER",
      "payoff": "",
      "commitmentText": "",
      "description": "Il percorso giusto per la tua laurea",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/apgrDh37",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-master-16/",
      "priceFull": 990,
      "priceDiscounted": null
    },
    {
      "corso": "Master - Uni - Full time - Psicologia",
      "tier": "master",
      "level": "university",
      "commitment": "full",
      "macro": "PSI",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_master_logo-scaled.png",
      "name": "Sistema ADC MASTER",
      "payoff": "",
      "commitmentText": "",
      "description": "Il percorso giusto per la tua laurea",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/59mRWtSX",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-master-14/",
      "priceFull": 990,
      "priceDiscounted": null
    },
    {
      "corso": "Master - Uni - Full time - Economia",
      "tier": "master",
      "level": "university",
      "commitment": "full",
      "macro": "ECO",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_master_logo-scaled.png",
      "name": "Sistema ADC MASTER",
      "payoff": "",
      "commitmentText": "",
      "description": "Il percorso giusto per la tua laurea",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/TiuHfbJ3",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-master-9/",
      "priceFull": 990,
      "priceDiscounted": null
    },
    {
      "corso": "Master - Uni - Part time - Medicina",
      "tier": "master",
      "level": "university",
      "commitment": "part",
      "macro": "MED",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_master_logo-scaled.png",
      "name": "Sistema ADC MASTER",
      "payoff": "",
      "commitmentText": "",
      "description": "Studio e impegni finalmente in equilibrio",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/d4VLdYyj",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-master-5/",
      "priceFull": 990,
      "priceDiscounted": null
    },
    {
      "corso": "Master - Uni - Part time - Ingegneria",
      "tier": "master",
      "level": "university",
      "commitment": "part",
      "macro": "ING",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_master_logo-scaled.png",
      "name": "Sistema ADC MASTER",
      "payoff": "",
      "commitmentText": "",
      "description": "Studio e impegni finalmente in equilibrio",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/RFhbPv5U",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-master-3/",
      "priceFull": 990,
      "priceDiscounted": null
    },
    {
      "corso": "Master - Uni - Part time - Giurisprudenza",
      "tier": "master",
      "level": "university",
      "commitment": "part",
      "macro": "GIU",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_master_logo-scaled.png",
      "name": "Sistema ADC MASTER",
      "payoff": "",
      "commitmentText": "",
      "description": "Studio e impegni finalmente in equilibrio",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/Q2sor6qV",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-master-2/",
      "priceFull": 990,
      "priceDiscounted": null
    },
    {
      "corso": "Master - Uni - Part time - Matematica",
      "tier": "master",
      "level": "university",
      "commitment": "part",
      "macro": "MAT",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_master_logo-scaled.png",
      "name": "Sistema ADC MASTER",
      "payoff": "",
      "commitmentText": "",
      "description": "Studio e impegni finalmente in equilibrio",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/zCCFQaiL",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-master-4/",
      "priceFull": 990,
      "priceDiscounted": null
    },
    {
      "corso": "Master - Uni - Part time - Scienze",
      "tier": "master",
      "level": "university",
      "commitment": "part",
      "macro": "SCI",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_master_logo-scaled.png",
      "name": "Sistema ADC MASTER",
      "payoff": "",
      "commitmentText": "",
      "description": "Studio e impegni finalmente in equilibrio",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/caQoPi8N",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-master-7/",
      "priceFull": 990,
      "priceDiscounted": null
    },
    {
      "corso": "Master - Uni - Part time - Studi Umanistici",
      "tier": "master",
      "level": "university",
      "commitment": "part",
      "macro": "UMA",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_master_logo-scaled.png",
      "name": "Sistema ADC MASTER",
      "payoff": "",
      "commitmentText": "",
      "description": "Studio e impegni finalmente in equilibrio",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/2Eh7MCH2",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-master-8/",
      "priceFull": 990,
      "priceDiscounted": null
    },
    {
      "corso": "Master - Uni - Part time - Psicologia",
      "tier": "master",
      "level": "university",
      "commitment": "part",
      "macro": "PSI",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_master_logo-scaled.png",
      "name": "Sistema ADC MASTER",
      "payoff": "",
      "commitmentText": "",
      "description": "Studio e impegni finalmente in equilibrio",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/AhBUWx9C",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-master-6/",
      "priceFull": 990,
      "priceDiscounted": null
    },
    {
      "corso": "Master - Uni - Part time - Economia",
      "tier": "master",
      "level": "university",
      "commitment": "part",
      "macro": "ECO",
      "picture": "https://www.alessandrodeconcini.com/wp-content/uploads/2026/06/e01_adc_sistema_logo_master_logo-scaled.png",
      "name": "Sistema ADC MASTER",
      "payoff": "",
      "commitmentText": "",
      "description": "Studio e impegni finalmente in equilibrio",
      "buyFullLink": "https://corsi.alessandrodeconcini.com/offers/adznDcgm",
      "buyInstallmentsLink": "https://rate.alessandrodeconcini.com/product/sistema-adc-3-0-master-1/",
      "priceFull": 990,
      "priceDiscounted": null
    }
  ],
  "courses": [
    {
      "name": "Advanced molecular sciences",
      "macro": "SCI"
    },
    {
      "name": "Agricoltura sostenibile",
      "macro": "SCI"
    },
    {
      "name": "Agricultural and environmental biotechnology",
      "macro": "SCI"
    },
    {
      "name": "Amministrazione e controllo aziendale",
      "macro": "ECO"
    },
    {
      "name": "Amministrazione e gestione digitale delle aziende",
      "macro": "ECO"
    },
    {
      "name": "Amministrazione, professione e persone",
      "macro": "ECO"
    },
    {
      "name": "Antropologia culturale ed etnologia",
      "macro": "UMA"
    },
    {
      "name": "Applied economics and markets",
      "macro": "ECO"
    },
    {
      "name": "Archeologia",
      "macro": "UMA"
    },
    {
      "name": "Archeologia e storia antica",
      "macro": "UMA"
    },
    {
      "name": "Archeologie: professioni e saperi",
      "macro": "UMA"
    },
    {
      "name": "Architecture and heritage",
      "macro": "ING"
    },
    {
      "name": "Architettura",
      "macro": "ING"
    },
    {
      "name": "Area & global studies for international cooperation",
      "macro": "UMA"
    },
    {
      "name": "Arti visive",
      "macro": "UMA"
    },
    {
      "name": "Artificial intelligence and computer science",
      "macro": "MAT"
    },
    {
      "name": "Artificial intelligence and data engineering",
      "macro": "ING"
    },
    {
      "name": "Artificial intelligence for biomedicine and healthcare",
      "macro": "MED"
    },
    {
      "name": "Artificial intelligence for science and technology",
      "macro": "MAT"
    },
    {
      "name": "Astrophysics and space physics",
      "macro": "MAT"
    },
    {
      "name": "Accounting e finanza",
      "macro": "ECO"
    },
    {
      "name": "Accounting, auditing e controllo",
      "macro": "ECO"
    },
    {
      "name": "Accounting, finance and business consulting",
      "macro": "ECO"
    },
    {
      "name": "Accounting, governance and sustainability",
      "macro": "ECO"
    },
    {
      "name": "Advanced automotive engineering",
      "macro": "ING"
    },
    {
      "name": "Advanced biotechnology",
      "macro": "SCI"
    },
    {
      "name": "Advanced cosmetic science",
      "macro": "SCI"
    },
    {
      "name": "Advanced materials science and technology",
      "macro": "SCI"
    },
    {
      "name": "Advanced methods in particle physics",
      "macro": "MAT"
    },
    {
      "name": "Advanced molecular sciences for health products",
      "macro": "SCI"
    },
    {
      "name": "Advanced design",
      "macro": "ING"
    },
    {
      "name": "Advanced spectroscopy in chemistry",
      "macro": "SCI"
    },
    {
      "name": "Aerospace engineering",
      "macro": "ING"
    },
    {
      "name": "Agri-food sustainabily",
      "macro": "SCI"
    },
    {
      "name": "Agritech engineering",
      "macro": "ING"
    },
    {
      "name": "Agricoltura di precisione",
      "macro": "SCI"
    },
    {
      "name": "Agricultural science and technology",
      "macro": "SCI"
    },
    {
      "name": "Agrifood innovation management",
      "macro": "ECO"
    },
    {
      "name": "Alimentazione e nutrizione umana",
      "macro": "SCI"
    },
    {
      "name": "Amministrazione aziendale e diritto",
      "macro": "GIU"
    },
    {
      "name": "Amministrazione e Direzione Aziendale",
      "macro": "ECO"
    },
    {
      "name": "Amministrazione e gestione d'impresa",
      "macro": "ECO"
    },
    {
      "name": "Amministrazione e politiche pubbliche",
      "macro": "UMA"
    },
    {
      "name": "Amministrazione, Economia e Finanza",
      "macro": "ECO"
    },
    {
      "name": "Amministrazione, Finanza e Consulenza Aziendale",
      "macro": "ECO"
    },
    {
      "name": "Amministrazione, Innovazione e Sostenibilità Ambientale",
      "macro": "SCI"
    },
    {
      "name": "Amministrazione, Servizi e Territorio",
      "macro": "ECO"
    },
    {
      "name": "Amministrazioni Pubbliche e Società",
      "macro": "UMA"
    },
    {
      "name": "Amministrazioni e Politiche Pubbliche",
      "macro": "UMA"
    },
    {
      "name": "Analisi dei dati per l'economia e il management",
      "macro": "ECO"
    },
    {
      "name": "Analisi dei processi sociali",
      "macro": "PSI"
    },
    {
      "name": "Analisi, pianificazione e gestione sostenibile del territorio",
      "macro": "ING"
    },
    {
      "name": "Analytics and Data Science for Economics and Management",
      "macro": "ECO"
    },
    {
      "name": "Antichità classiche e orientali",
      "macro": "UMA"
    },
    {
      "name": "Antropologia culturale e sociale",
      "macro": "UMA"
    },
    {
      "name": "Antropologia culturale, etnologia, etnolinguistica",
      "macro": "UMA"
    },
    {
      "name": "Antropologia della Contemporaneità",
      "macro": "UMA"
    },
    {
      "name": "Antropologia e storia del mondo contemporaneo",
      "macro": "UMA"
    },
    {
      "name": "Applied Child and Adolescent Psychology",
      "macro": "PSI"
    },
    {
      "name": "Applied Dynamic and Clinical Psychology",
      "macro": "PSI"
    },
    {
      "name": "Applied Economics",
      "macro": "ECO"
    },
    {
      "name": "Applied Mathematics",
      "macro": "MAT"
    },
    {
      "name": "Applied experimental psychological sciences",
      "macro": "PSI"
    },
    {
      "name": "Archaeological Materials Science",
      "macro": "SCI"
    },
    {
      "name": "Archeologia del Mediterraneo",
      "macro": "UMA"
    },
    {
      "name": "Archeologia del Mediterraneo Classico",
      "macro": "UMA"
    },
    {
      "name": "Archeologia e Storia dell'Arte",
      "macro": "UMA"
    },
    {
      "name": "Archeologia e Storia dell'arte. Tutela e valorizzazione",
      "macro": "UMA"
    },
    {
      "name": "Archeologia e culture antiche",
      "macro": "UMA"
    },
    {
      "name": "Archeologia e culture del mondo antico",
      "macro": "UMA"
    },
    {
      "name": "Archeologia e sviluppo dei territori",
      "macro": "UMA"
    },
    {
      "name": "Archeologia, Filologia, Letterature e Storia dell'Antichità",
      "macro": "UMA"
    },
    {
      "name": "Archeologia: Asia, Africa e Mediterraneo",
      "macro": "UMA"
    },
    {
      "name": "Architectural composition",
      "macro": "ING"
    },
    {
      "name": "Architecture and creative practices for the city and landscape",
      "macro": "ING"
    },
    {
      "name": "Architettura - Progettazione architettonica",
      "macro": "ING"
    },
    {
      "name": "Architettura - Progettazione urbana",
      "macro": "ING"
    },
    {
      "name": "Architettura - Restauro",
      "macro": "ING"
    },
    {
      "name": "Architettura - Rigenerazione dell'ambiente costruito",
      "macro": "ING"
    },
    {
      "name": "Architettura - Rigenerazione urbana",
      "macro": "ING"
    },
    {
      "name": "Architettura Costruzione Città",
      "macro": "ING"
    },
    {
      "name": "Architettura Rigenerazione Sostenibilità",
      "macro": "ING"
    },
    {
      "name": "Architettura del Paesaggio",
      "macro": "ING"
    },
    {
      "name": "Architettura e Città Sostenibili",
      "macro": "ING"
    },
    {
      "name": "Architettura e progetto nel costruito",
      "macro": "ING"
    },
    {
      "name": "Architettura per Comunità, Territori e Ambiente",
      "macro": "ING"
    },
    {
      "name": "Architettura per il Patrimonio",
      "macro": "ING"
    },
    {
      "name": "Architettura per il Progetto Sostenibile dell'Esistente",
      "macro": "ING"
    },
    {
      "name": "Architettura per la Sostenibilità",
      "macro": "ING"
    },
    {
      "name": "Architettura – Interni e Allestimenti",
      "macro": "ING"
    },
    {
      "name": "Architettura-Ingegneria",
      "macro": "ING"
    },
    {
      "name": "Archival science and AI",
      "macro": "UMA"
    },
    {
      "name": "Archivistica e biblioteconomia",
      "macro": "ECO"
    },
    {
      "name": "Art History in Rome, from Late Antiquity to the Present",
      "macro": "UMA"
    },
    {
      "name": "Arte e Patrimonio Culturale",
      "macro": "UMA"
    },
    {
      "name": "Arte, valorizzazione e mercato",
      "macro": "UMA"
    },
    {
      "name": "Arti ed eventi culturali",
      "macro": "UMA"
    },
    {
      "name": "Arti visive e Cinema espanso",
      "macro": "UMA"
    },
    {
      "name": "Artificial Intelligence",
      "macro": "MAT"
    },
    {
      "name": "Artificial Intelligence & Cybersecurity",
      "macro": "MAT"
    },
    {
      "name": "Artificial Intelligence Engineering",
      "macro": "ING"
    },
    {
      "name": "Artificial Intelligence Systems",
      "macro": "MAT"
    },
    {
      "name": "Artificial Intelligence and Automation Engineering",
      "macro": "ING"
    },
    {
      "name": "Artificial Intelligence and Robotics",
      "macro": "MAT"
    },
    {
      "name": "Assistenza sanitaria",
      "macro": "MED"
    },
    {
      "name": "Astronomia",
      "macro": "MAT"
    },
    {
      "name": "Astrophysics and Cosmology",
      "macro": "MAT"
    },
    {
      "name": "Astrophysics and Space Science",
      "macro": "MAT"
    },
    {
      "name": "Atmospheric Science and Technology for Meteorology and Climate",
      "macro": "SCI"
    },
    {
      "name": "Attività Fisica e Salute",
      "macro": "SCI"
    },
    {
      "name": "Attività Motorie Preventive e Adattate",
      "macro": "SCI"
    },
    {
      "name": "Automation Engineering",
      "macro": "ING"
    },
    {
      "name": "Automation Engineering and Control of Complex Systems",
      "macro": "ING"
    },
    {
      "name": "Automation and Robotics Engineering",
      "macro": "ING"
    },
    {
      "name": "Automation and Systems Engineering",
      "macro": "ING"
    },
    {
      "name": "Automotive Engineering",
      "macro": "ING"
    },
    {
      "name": "Autonomous Vehicle Engineering",
      "macro": "ING"
    },
    {
      "name": "Banca e finanza",
      "macro": "ECO"
    },
    {
      "name": "Banca, finanza aziendale e mercati finanziari",
      "macro": "ECO"
    },
    {
      "name": "Beni culturali",
      "macro": "UMA"
    },
    {
      "name": "Bioinformatica",
      "macro": "SCI"
    },
    {
      "name": "Biologia",
      "macro": "SCI"
    },
    {
      "name": "Biologia ambientale",
      "macro": "SCI"
    },
    {
      "name": "Biologia applicata alla biomedicina",
      "macro": "MED"
    },
    {
      "name": "Biologia cellulare e molecolare",
      "macro": "SCI"
    },
    {
      "name": "Biologia dell'ambiente e del comportamento",
      "macro": "SCI"
    },
    {
      "name": "Biologia molecolare e applicata",
      "macro": "SCI"
    },
    {
      "name": "Biologia marina",
      "macro": "SCI"
    },
    {
      "name": "Biologia molecolare e cellulare",
      "macro": "SCI"
    },
    {
      "name": "Biologia sperimentale ed applicata",
      "macro": "SCI"
    },
    {
      "name": "Biology of extreme environments",
      "macro": "SCI"
    },
    {
      "name": "Bionics engineering",
      "macro": "ING"
    },
    {
      "name": "Bioscienze",
      "macro": "SCI"
    },
    {
      "name": "Biosicurezza e qualità degli alimenti",
      "macro": "SCI"
    },
    {
      "name": "Biostatistica",
      "macro": "MAT"
    },
    {
      "name": "Biotechnologies and applied artificial intelligence for health",
      "macro": "MED"
    },
    {
      "name": "Biotecnologie",
      "macro": "SCI"
    },
    {
      "name": "Biotecnologie farmaceutiche",
      "macro": "SCI"
    },
    {
      "name": "Biotecnologie industriali",
      "macro": "SCI"
    },
    {
      "name": "Biotecnologie industriali e farmaceutiche",
      "macro": "SCI"
    },
    {
      "name": "Biotecnologie industriali biomolecolari",
      "macro": "SCI"
    },
    {
      "name": "Biotecnologie mediche",
      "macro": "MED"
    },
    {
      "name": "Biotecnologie mediche e nanobiotecnologie",
      "macro": "MED"
    },
    {
      "name": "Biotecnologie mediche per la diagnostica e la terapia",
      "macro": "MED"
    },
    {
      "name": "Biotecnologie molecolari",
      "macro": "SCI"
    },
    {
      "name": "Biotecnologie vegetali e microbiche",
      "macro": "SCI"
    },
    {
      "name": "Biotecnologie per la salute",
      "macro": "MED"
    },
    {
      "name": "Business & management",
      "macro": "ECO"
    },
    {
      "name": "Business administration",
      "macro": "ECO"
    },
    {
      "name": "Business administration and sustainability",
      "macro": "ECO"
    },
    {
      "name": "Behavioural and Applied Economics",
      "macro": "ECO"
    },
    {
      "name": "Beni Archeologici: territorio, insediamenti, cultura materiale",
      "macro": "UMA"
    },
    {
      "name": "Beni Artistici, Librari e dello Spettacolo",
      "macro": "UMA"
    },
    {
      "name": "Beni Culturali: Conoscenza, Gestione, Valorizzazione",
      "macro": "UMA"
    },
    {
      "name": "Beni archeologici e storico-artistici",
      "macro": "UMA"
    },
    {
      "name": "Beni archeologici, artistici e del paesaggio: storia, tutela e valorizzazione",
      "macro": "ING"
    },
    {
      "name": "Beni culturali archeologici, storico-artistici e archivistici",
      "macro": "UMA"
    },
    {
      "name": "Beni culturali e turismo",
      "macro": "UMA"
    },
    {
      "name": "Beni culturali: scienze, tecnologie e diagnostica",
      "macro": "UMA"
    },
    {
      "name": "Bio-Ecologia Marina",
      "macro": "SCI"
    },
    {
      "name": "BioGeoscienze: Analisi degli ecosistemi e comunicazione delle scienze",
      "macro": "SCI"
    },
    {
      "name": "Biochemistry",
      "macro": "SCI"
    },
    {
      "name": "Biodiversity, Conservation and Environmental Quality",
      "macro": "SCI"
    },
    {
      "name": "Biodiversità e Biologia ambientale",
      "macro": "SCI"
    },
    {
      "name": "Biodiversità e Tutela dell'Ambiente",
      "macro": "SCI"
    },
    {
      "name": "Biodiversità e Conservazione dei Sistemi Naturali",
      "macro": "SCI"
    },
    {
      "name": "Biodiversità e innovazione tecnologica",
      "macro": "SCI"
    },
    {
      "name": "Biodiversità ed Evoluzione",
      "macro": "SCI"
    },
    {
      "name": "Bioengineering",
      "macro": "ING"
    },
    {
      "name": "Bioengineering for Personalized Medicine",
      "macro": "ING"
    },
    {
      "name": "Bioinformatics for Computational Genomics",
      "macro": "SCI"
    },
    {
      "name": "Bioingegneria per l'innovazione in medicina",
      "macro": "ING"
    },
    {
      "name": "Biologia Ambientale e Gestione degli Ecosistemi",
      "macro": "SCI"
    },
    {
      "name": "Biologia Applicata e Sperimentale",
      "macro": "SCI"
    },
    {
      "name": "Biologia Cellulare, Molecolare e Ricerca Biomedica",
      "macro": "SCI"
    },
    {
      "name": "Biologia Molecolare e della Salute",
      "macro": "SCI"
    },
    {
      "name": "Biologia Molecolare, Cellulare e della Salute",
      "macro": "SCI"
    },
    {
      "name": "Biologia Sperimentale e Applicata",
      "macro": "SCI"
    },
    {
      "name": "Biologia applicata alla ricerca biomedica",
      "macro": "SCI"
    },
    {
      "name": "Biologia applicata alle scienze della nutrizione",
      "macro": "SCI"
    },
    {
      "name": "Biologia dell'Ambiente",
      "macro": "SCI"
    },
    {
      "name": "Biologia della Salute delle Tecnologie applicate e della Nutrizione",
      "macro": "SCI"
    },
    {
      "name": "Biologia della Nutrizione",
      "macro": "SCI"
    },
    {
      "name": "Biologia e Tecnologie Cellulari",
      "macro": "SCI"
    },
    {
      "name": "Biologia e sostenibilità",
      "macro": "SCI"
    },
    {
      "name": "Biologia ed Ecologia dell'Ambiente Marino Costiero",
      "macro": "SCI"
    },
    {
      "name": "Biologia ed ecologia marina",
      "macro": "SCI"
    },
    {
      "name": "Biologia molecolare, Genomica e Biodiversità",
      "macro": "SCI"
    },
    {
      "name": "Biologia per la Sostenibilità",
      "macro": "SCI"
    },
    {
      "name": "Biologia sanitaria",
      "macro": "MED"
    },
    {
      "name": "Biologia sperimentale e bioinformatica",
      "macro": "SCI"
    },
    {
      "name": "Biological Sciences",
      "macro": "SCI"
    },
    {
      "name": "Biology for One-health",
      "macro": "SCI"
    },
    {
      "name": "Biology for Translational Research and Precision Medicine",
      "macro": "MED"
    },
    {
      "name": "Biomedical Engineering",
      "macro": "ING"
    },
    {
      "name": "Biology of Human and Environmental Health",
      "macro": "SCI"
    },
    {
      "name": "Biomedical Omics",
      "macro": "MED"
    },
    {
      "name": "Biomedical Sciences",
      "macro": "MED"
    },
    {
      "name": "Bioscienze e Biotecnologia - Biosciences and Biotechnology",
      "macro": "SCI"
    },
    {
      "name": "Biotech Engineering For Health",
      "macro": "ING"
    },
    {
      "name": "Biotechnological and Chemical Sciences in Diagnostics",
      "macro": "SCI"
    },
    {
      "name": "Biotechnologies for food science",
      "macro": "SCI"
    },
    {
      "name": "Biotechnologies of Human Reproduction",
      "macro": "SCI"
    },
    {
      "name": "Biotechnology and Medical Biology",
      "macro": "MED"
    },
    {
      "name": "Biotechnology for Industry and Health",
      "macro": "MED"
    },
    {
      "name": "Biotechnology for Innovative Therapeutics",
      "macro": "SCI"
    },
    {
      "name": "Biotechnology for Neuroscience",
      "macro": "PSI"
    },
    {
      "name": "Biotechnology for human and animal health",
      "macro": "MED"
    },
    {
      "name": "Biotechnology for the Bio-based and Health Industry",
      "macro": "MED"
    },
    {
      "name": "Biotechnology for the bioeconomy",
      "macro": "SCI"
    },
    {
      "name": "Biotecnologie Agrarie",
      "macro": "SCI"
    },
    {
      "name": "Biotecnologie Agrarie Vegetali",
      "macro": "SCI"
    },
    {
      "name": "Biotecnologie Agro-Alimentari e Industriali",
      "macro": "SCI"
    },
    {
      "name": "Biotecnologie Animali",
      "macro": "SCI"
    },
    {
      "name": "Biotecnologie Agro-ambientali e alimentari",
      "macro": "SCI"
    },
    {
      "name": "Biotecnologie Avanzate",
      "macro": "SCI"
    },
    {
      "name": "Biotecnologie Genomiche, Molecolari e Industriali",
      "macro": "SCI"
    },
    {
      "name": "Biotecnologie Industriali per lo Sviluppo Sostenibile",
      "macro": "SCI"
    },
    {
      "name": "Biotecnologie Innovative per la Salute",
      "macro": "MED"
    },
    {
      "name": "Biotecnologie Marine e degli Ecosistemi Acquatici",
      "macro": "SCI"
    },
    {
      "name": "Biotecnologie Mediche e Farmaceutiche",
      "macro": "SCI"
    },
    {
      "name": "Biotecnologie Mediche, Veterinarie e Farmaceutiche",
      "macro": "MED"
    },
    {
      "name": "Biotecnologie Mediche e Medicina Molecolare",
      "macro": "MED"
    },
    {
      "name": "Biotecnologie Molecolari e Industriali",
      "macro": "SCI"
    },
    {
      "name": "Biotecnologie agrarie per la filiera agro-alimentare",
      "macro": "SCI"
    },
    {
      "name": "Biotecnologie agro-alimentari",
      "macro": "SCI"
    },
    {
      "name": "Biotecnologie del Farmaco",
      "macro": "SCI"
    },
    {
      "name": "Biotecnologie e Genomica per l'industria e l'ambiente",
      "macro": "SCI"
    },
    {
      "name": "Biotecnologie e Analisi Bioinformatiche",
      "macro": "SCI"
    },
    {
      "name": "Biotecnologie industriali dei biofarmaci, cosmetici e nutraceutici",
      "macro": "SCI"
    },
    {
      "name": "Biotecnologie industriali per la salute e il benessere",
      "macro": "MED"
    },
    {
      "name": "Biotecnologie mediche e diagnostiche",
      "macro": "MED"
    },
    {
      "name": "Biotecnologie per la Gestione Ambientale e l'Agricoltura Sostenibile",
      "macro": "SCI"
    },
    {
      "name": "Biotecnologie per la Medicina Traslazionale",
      "macro": "MED"
    },
    {
      "name": "Biotecnologie per la diagnostica medica, farmaceutica e veterinaria",
      "macro": "MED"
    },
    {
      "name": "Biotecnologie per la qualità e la sicurezza dell'alimentazione",
      "macro": "SCI"
    },
    {
      "name": "Biotecnologie per le biorisorse e lo sviluppo ecosostenibile",
      "macro": "SCI"
    },
    {
      "name": "Biotecnologie per l’ambiente e lo sviluppo sostenibile",
      "macro": "SCI"
    },
    {
      "name": "Biotecnologie vegetali",
      "macro": "SCI"
    },
    {
      "name": "Biotecnologie veterinarie",
      "macro": "MED"
    },
    {
      "name": "Building Construction Engineering",
      "macro": "ING"
    },
    {
      "name": "Building Engineering",
      "macro": "ING"
    },
    {
      "name": "Business Administration & Economics",
      "macro": "ECO"
    },
    {
      "name": "Business Administration and Management",
      "macro": "ECO"
    },
    {
      "name": "Business Administration-Gestione d'impresa",
      "macro": "ECO"
    },
    {
      "name": "Business and Economics",
      "macro": "ECO"
    },
    {
      "name": "CAM - Cinema, Arti della scena, Musica e Media",
      "macro": "UMA"
    },
    {
      "name": "Cellular and molecular biology-biologia cellulare e molecolare",
      "macro": "SCI"
    },
    {
      "name": "Chimica",
      "macro": "SCI"
    },
    {
      "name": "Chimica e chimica industriale",
      "macro": "SCI"
    },
    {
      "name": "Chimica e tecnologia farmaceutiche",
      "macro": "SCI"
    },
    {
      "name": "Chimica industriale",
      "macro": "SCI"
    },
    {
      "name": "Chimica per l'industria e l'ambiente",
      "macro": "SCI"
    },
    {
      "name": "Chimica per la manifattura sostenibile",
      "macro": "SCI"
    },
    {
      "name": "CIMS - Culture e industrie dei media e dello spettacolo",
      "macro": "UMA"
    },
    {
      "name": "Cinema, televisione e produzione multimediale",
      "macro": "UMA"
    },
    {
      "name": "Circular economy",
      "macro": "ECO"
    },
    {
      "name": "Civil engineering for infrastructural regeneration",
      "macro": "ING"
    },
    {
      "name": "Civil engineering",
      "macro": "ING"
    },
    {
      "name": "Clinical and experimental biology",
      "macro": "SCI"
    },
    {
      "name": "Communications engineering",
      "macro": "ING"
    },
    {
      "name": "Computer engineering",
      "macro": "ING"
    },
    {
      "name": "Computer science",
      "macro": "MAT"
    },
    {
      "name": "Comunicazione d'impresa e politica delle risorse umane",
      "macro": "ECO"
    },
    {
      "name": "Comunicazione digitale e linguaggi del giornalismo",
      "macro": "UMA"
    },
    {
      "name": "Comunicazione per le imprese e le istituzioni pubbliche",
      "macro": "ECO"
    },
    {
      "name": "Comunicazione, media, tecnologie",
      "macro": "UMA"
    },
    {
      "name": "Comunicazione, relazioni pubbliche e tecnologie digitali",
      "macro": "UMA"
    },
    {
      "name": "Conservazione ed evoluzione",
      "macro": "SCI"
    },
    {
      "name": "Consulente del lavoro e operatore di impresa",
      "macro": "ECO"
    },
    {
      "name": "Consulenza pedagogica",
      "macro": "PSI"
    },
    {
      "name": "Consulenza pedagogica e progettazione dei processi formativi",
      "macro": "PSI"
    },
    {
      "name": "Consulenza professionale alle aziende",
      "macro": "ECO"
    },
    {
      "name": "Control systems and automation engineering",
      "macro": "ING"
    },
    {
      "name": "Coordinamento dei servizi educativi per la prima infanzia e per il disagio sociale",
      "macro": "PSI"
    },
    {
      "name": "Corporate communication, marketing innovation e media digitali",
      "macro": "ECO"
    },
    {
      "name": "CULTURA E SOSTENIBILITà DELLA ENOGASTRONOMIA",
      "macro": "MAT"
    },
    {
      "name": "Culture e pratiche della moda",
      "macro": "UMA"
    },
    {
      "name": "Cybersecurity",
      "macro": "MAT"
    },
    {
      "name": "Cellular and Molecular Biotechnology",
      "macro": "SCI"
    },
    {
      "name": "Chemical Nano-Engineering",
      "macro": "ING"
    },
    {
      "name": "Chemical and Process Engineering",
      "macro": "ING"
    },
    {
      "name": "Chemical engineering for industrial sustainability",
      "macro": "ING"
    },
    {
      "name": "Chemical innovation and regulation",
      "macro": "SCI"
    },
    {
      "name": "Chimica Analitica",
      "macro": "SCI"
    },
    {
      "name": "Chimica Applicata",
      "macro": "SCI"
    },
    {
      "name": "Chimica Clinica, Forense e dello Sport",
      "macro": "SCI"
    },
    {
      "name": "Chimica Sostenibile per l'Industria, l'Ambiente e l'Energia",
      "macro": "SCI"
    },
    {
      "name": "Chimica con Elementi di Intelligenza Artificiale",
      "macro": "MAT"
    },
    {
      "name": "Chimica dell'Ambiente",
      "macro": "SCI"
    },
    {
      "name": "Chimica e Chimica dei Materiali",
      "macro": "SCI"
    },
    {
      "name": "Chimica e Tecnologie Chimiche",
      "macro": "SCI"
    },
    {
      "name": "Chimica e Tecnologie Sostenibili",
      "macro": "SCI"
    },
    {
      "name": "Chimica e Tecnologie per l'Ambiente e per i Materiali",
      "macro": "SCI"
    },
    {
      "name": "Chimica per la Sostenibilità",
      "macro": "SCI"
    },
    {
      "name": "Chimica per le Scienze Agroalimentari",
      "macro": "SCI"
    },
    {
      "name": "Chimica verde",
      "macro": "SCI"
    },
    {
      "name": "Chimica verde e sostenibile",
      "macro": "SCI"
    },
    {
      "name": "Cinema, musiche, teatro",
      "macro": "UMA"
    },
    {
      "name": "Cittadinanza, istituzioni e politiche europee",
      "macro": "UMA"
    },
    {
      "name": "Civil Engineering for Mitigation of Risk from Natural Hazards",
      "macro": "ING"
    },
    {
      "name": "Civil and Environmental Engineering",
      "macro": "ING"
    },
    {
      "name": "Civiltà e Lingue Straniere Moderne",
      "macro": "UMA"
    },
    {
      "name": "Civiltà letteraria dell'Italia medievale e moderna",
      "macro": "UMA"
    },
    {
      "name": "Classics",
      "macro": "UMA"
    },
    {
      "name": "Clinical, social and intercultural psychology",
      "macro": "PSI"
    },
    {
      "name": "Coastal and Marine Biology and Ecology",
      "macro": "SCI"
    },
    {
      "name": "Cognitive Forensic Sciences",
      "macro": "PSI"
    },
    {
      "name": "Cognitive Neuroscience and Clinical Neuropsychology",
      "macro": "PSI"
    },
    {
      "name": "Cognitive Science",
      "macro": "PSI"
    },
    {
      "name": "Cognitive psychology in health communication",
      "macro": "PSI"
    },
    {
      "name": "Cognitive science and theory of communication",
      "macro": "PSI"
    },
    {
      "name": "Commercio estero e turismo",
      "macro": "ECO"
    },
    {
      "name": "Communication Engineering",
      "macro": "ING"
    },
    {
      "name": "Communication Technologies and Multimedia - Tecnologie delle comunicazioni e multimedia",
      "macro": "UMA"
    },
    {
      "name": "Comparative, European and International Legal Studies",
      "macro": "GIU"
    },
    {
      "name": "Competenze testuali per l'editoria, l'insegnamento e la promozione turistica",
      "macro": "ECO"
    },
    {
      "name": "Compositi Polimerici",
      "macro": "SCI"
    },
    {
      "name": "Computational Finance",
      "macro": "ECO"
    },
    {
      "name": "Computational Social and Political Science",
      "macro": "MAT"
    },
    {
      "name": "Computer Science and Artificial Intelligence",
      "macro": "MAT"
    },
    {
      "name": "Computer Science and Information Technology",
      "macro": "MAT"
    },
    {
      "name": "Computer Science and Networking",
      "macro": "MAT"
    },
    {
      "name": "Computing for Data Science",
      "macro": "MAT"
    },
    {
      "name": "Comunicazione",
      "macro": "UMA"
    },
    {
      "name": "Comunicazione Digitale",
      "macro": "UMA"
    },
    {
      "name": "Comunicazione Digitale per la Cultura",
      "macro": "UMA"
    },
    {
      "name": "Comunicazione Multimediale e Tecnologie dell'Informazione",
      "macro": "UMA"
    },
    {
      "name": "Comunicazione Scientifica Biomedica",
      "macro": "UMA"
    },
    {
      "name": "Comunicazione d'impresa e relazioni pubbliche",
      "macro": "ECO"
    },
    {
      "name": "Comunicazione del patrimonio culturale",
      "macro": "UMA"
    },
    {
      "name": "Comunicazione della cultura e dello spettacolo",
      "macro": "UMA"
    },
    {
      "name": "Comunicazione digitale e d'impresa",
      "macro": "ECO"
    },
    {
      "name": "Comunicazione digitale e marketing",
      "macro": "ECO"
    },
    {
      "name": "Comunicazione e Intelligenza Artificiale",
      "macro": "MAT"
    },
    {
      "name": "Comunicazione e DAMS",
      "macro": "UMA"
    },
    {
      "name": "Comunicazione e Interpretariato in Lingua dei segni italiana",
      "macro": "UMA"
    },
    {
      "name": "Comunicazione e Media Contemporanei per le Industrie Creative",
      "macro": "UMA"
    },
    {
      "name": "Comunicazione e Pubblicità per le Organizzazioni",
      "macro": "UMA"
    },
    {
      "name": "Comunicazione e culture dei media",
      "macro": "UMA"
    },
    {
      "name": "Comunicazione e culture digitali",
      "macro": "UMA"
    },
    {
      "name": "Comunicazione e società",
      "macro": "UMA"
    },
    {
      "name": "Comunicazione e tecnologie dell'informazione",
      "macro": "UMA"
    },
    {
      "name": "Comunicazione giornalistica, pubblica e d'impresa",
      "macro": "ECO"
    },
    {
      "name": "Comunicazione integrata per le imprese e le organizzazioni",
      "macro": "ECO"
    },
    {
      "name": "Comunicazione interculturale",
      "macro": "UMA"
    },
    {
      "name": "Comunicazione interlinguistica applicata",
      "macro": "UMA"
    },
    {
      "name": "Comunicazione interlinguistica applicata alle professioni giuridiche",
      "macro": "GIU"
    },
    {
      "name": "Comunicazione internazionale e pubblicitaria",
      "macro": "UMA"
    },
    {
      "name": "Comunicazione per l'enogastronomia",
      "macro": "MAT"
    },
    {
      "name": "Comunicazione pubblica e d'impresa",
      "macro": "ECO"
    },
    {
      "name": "Comunicazione pubblica e politica",
      "macro": "UMA"
    },
    {
      "name": "Comunicazione pubblica e professioni dell'informazione",
      "macro": "UMA"
    },
    {
      "name": "Comunicazione pubblica, d'impresa e pubblicità",
      "macro": "ECO"
    },
    {
      "name": "Comunicazione pubblicitaria, storytelling e cultura d'immagine",
      "macro": "UMA"
    },
    {
      "name": "Comunicazione pubblica, sociale e politica",
      "macro": "UMA"
    },
    {
      "name": "Comunicazione, ICT e media",
      "macro": "UMA"
    },
    {
      "name": "Comunicazione, Marketing e Innovazione Digitale",
      "macro": "ECO"
    },
    {
      "name": "Comunicazione, informazione, editoria",
      "macro": "UMA"
    },
    {
      "name": "Comunicazione, innovazione ed experience design",
      "macro": "ING"
    },
    {
      "name": "Comunicazione, innovazione, multimedialità",
      "macro": "UMA"
    },
    {
      "name": "Comunicazione, media digitali, giornalismo",
      "macro": "UMA"
    },
    {
      "name": "Comunicazione, media e pubblicità",
      "macro": "UMA"
    },
    {
      "name": "Comunicazione, tecnologie e culture digitali",
      "macro": "UMA"
    },
    {
      "name": "Conservation Science and Technology for Cultural Heritage",
      "macro": "UMA"
    },
    {
      "name": "Conduzione del mezzo navale",
      "macro": "ING"
    },
    {
      "name": "Conservazione dei beni culturali",
      "macro": "UMA"
    },
    {
      "name": "Conservazione della biodiversità, didattica e comunicazione scientifica",
      "macro": "PSI"
    },
    {
      "name": "Conservazione e Gestione della Natura e dell'Ambiente",
      "macro": "SCI"
    },
    {
      "name": "Conservazione e Restauro dell'Ambiente e delle Foreste",
      "macro": "SCI"
    },
    {
      "name": "Conservazione e gestione dei beni e delle attività culturali",
      "macro": "UMA"
    },
    {
      "name": "Conservazione e restauro dei beni culturali",
      "macro": "UMA"
    },
    {
      "name": "Conservazione e valorizzazione dei sistemi naturali",
      "macro": "SCI"
    },
    {
      "name": "Consulente Giuridico d'Impresa",
      "macro": "GIU"
    },
    {
      "name": "Consulente del Lavoro e Scienze dei servizi giuridici",
      "macro": "GIU"
    },
    {
      "name": "Consulente del lavoro",
      "macro": "ECO"
    },
    {
      "name": "Consulente del lavoro e delle relazioni aziendali",
      "macro": "ECO"
    },
    {
      "name": "Consulente del lavoro e giurista d'impresa",
      "macro": "GIU"
    },
    {
      "name": "Consulenza aziendale e libera professione",
      "macro": "ECO"
    },
    {
      "name": "Consulenza del lavoro e gestione delle risorse umane",
      "macro": "ECO"
    },
    {
      "name": "Consulenza e Gestione di Impresa",
      "macro": "ECO"
    },
    {
      "name": "Consulenza e management aziendale",
      "macro": "ECO"
    },
    {
      "name": "Consulenza pedagogica e coordinamento di interventi formativi",
      "macro": "PSI"
    },
    {
      "name": "Control Engineering",
      "macro": "ING"
    },
    {
      "name": "Control systems engineering",
      "macro": "ING"
    },
    {
      "name": "Controllo di Qualità",
      "macro": "SCI"
    },
    {
      "name": "Controllo di Qualità dei Prodotti per la Salute",
      "macro": "SCI"
    },
    {
      "name": "Controllo e sicurezza degli alimenti",
      "macro": "SCI"
    },
    {
      "name": "Cooperazione internazionale e sviluppo",
      "macro": "UMA"
    },
    {
      "name": "Cooperazione, sviluppo e migrazioni",
      "macro": "UMA"
    },
    {
      "name": "Cooperazione, Sviluppo, Ecologia",
      "macro": "SCI"
    },
    {
      "name": "Coordinamento dei servizi educativi e tecnologie per l'inclusione",
      "macro": "PSI"
    },
    {
      "name": "Coordinamento e gestione dei servizi educativi",
      "macro": "PSI"
    },
    {
      "name": "Coordinatore dei servizi educativi e dei servizi sociali",
      "macro": "PSI"
    },
    {
      "name": "Corso di Laurea in Scienze Motorie e Sportive",
      "macro": "SCI"
    },
    {
      "name": "Cosmetic Industrial Science",
      "macro": "SCI"
    },
    {
      "name": "Costruzioni e Gestione Ambientale e Territoriale",
      "macro": "ING"
    },
    {
      "name": "Costruzioni e gestione del territorio",
      "macro": "ING"
    },
    {
      "name": "Costruzioni, Infrastrutture e Territorio",
      "macro": "ING"
    },
    {
      "name": "Critical Creative Practices",
      "macro": "UMA"
    },
    {
      "name": "Cultural Heritage in the Near and Middle East, and in Africa",
      "macro": "UMA"
    },
    {
      "name": "Cultural Heritage and Creativity for tourism and territorial development",
      "macro": "UMA"
    },
    {
      "name": "Cultural, Intellectual and Visual History",
      "macro": "UMA"
    },
    {
      "name": "Culture antiche e archeologia: Asia, Africa e Mediterraneo",
      "macro": "UMA"
    },
    {
      "name": "Culture digitali e della comunicazione",
      "macro": "UMA"
    },
    {
      "name": "Culture e Religioni",
      "macro": "UMA"
    },
    {
      "name": "Culture e beni musicali",
      "macro": "UMA"
    },
    {
      "name": "Culture e letterature del mondo moderno",
      "macro": "UMA"
    },
    {
      "name": "Culture moderne comparate",
      "macro": "UMA"
    },
    {
      "name": "Culture umanistiche",
      "macro": "UMA"
    },
    {
      "name": "Curating Arts and Heritage in Intercultural Perspectives",
      "macro": "UMA"
    },
    {
      "name": "Dams",
      "macro": "UMA"
    },
    {
      "name": "DAMS - Discipline dell'audiovisivo, dei media e dello spettacolo",
      "macro": "UMA"
    },
    {
      "name": "DAMS - Discipline delle arti, della musica e dello spettacolo",
      "macro": "UMA"
    },
    {
      "name": "DAMS - Produzione audiovisiva e teatrale",
      "macro": "UMA"
    },
    {
      "name": "DAMS Teatro, musica, danza",
      "macro": "UMA"
    },
    {
      "name": "Data science",
      "macro": "MAT"
    },
    {
      "name": "DAMS e Storia dell'arte. Organizzazione e teoria delle arti, della musica e del teatro",
      "macro": "UMA"
    },
    {
      "name": "Data science and artificial intelligence",
      "macro": "MAT"
    },
    {
      "name": "Data science and business informatics",
      "macro": "ECO"
    },
    {
      "name": "Data science applicata",
      "macro": "MAT"
    },
    {
      "name": "Design del prodotto industriale",
      "macro": "ING"
    },
    {
      "name": "Digital intelligence and change management",
      "macro": "ECO"
    },
    {
      "name": "Direzione d'impresa, marketing e strategia",
      "macro": "ECO"
    },
    {
      "name": "Diritto dell'innovazione per l'impresa e le istituzioni",
      "macro": "GIU"
    },
    {
      "name": "Diritto dell'impresa, del lavoro e delle pubbliche amministrazioni",
      "macro": "GIU"
    },
    {
      "name": "Diritto delle organizzazioni pubbliche e private",
      "macro": "GIU"
    },
    {
      "name": "Diritto e gestione dei servizi sanitari",
      "macro": "GIU"
    },
    {
      "name": "Diritto e politiche per le pubbliche amministrazioni",
      "macro": "GIU"
    },
    {
      "name": "DIRITTO PER LE SOSTENIBILITà E LA SICUREZZA",
      "macro": "GIU"
    },
    {
      "name": "Discipline dello spettacolo e della comunicazione",
      "macro": "UMA"
    },
    {
      "name": "Data Analysis per le Scienze Sociali",
      "macro": "PSI"
    },
    {
      "name": "Data Analytics",
      "macro": "MAT"
    },
    {
      "name": "Data Analytics and Artificial Intelligence in Health Sciences",
      "macro": "MAT"
    },
    {
      "name": "Data Analytics for Business and Society",
      "macro": "ECO"
    },
    {
      "name": "Data Analytics for Economics and Management",
      "macro": "ECO"
    },
    {
      "name": "Data Analytics per l'Economia e la Società",
      "macro": "ECO"
    },
    {
      "name": "Data Science and Engineering",
      "macro": "ING"
    },
    {
      "name": "Data Science e Gestione dell'Innovazione",
      "macro": "MAT"
    },
    {
      "name": "Data Science for Economics and Health",
      "macro": "ECO"
    },
    {
      "name": "Data Science for Economics, Business and Finance",
      "macro": "ECO"
    },
    {
      "name": "Data Science for Management",
      "macro": "ECO"
    },
    {
      "name": "Data Science per le Strategie Aziendali",
      "macro": "ECO"
    },
    {
      "name": "Data Science per le scienze umane e sociali",
      "macro": "PSI"
    },
    {
      "name": "Data Science, Business Analytics e Innovazione",
      "macro": "ECO"
    },
    {
      "name": "Data Science, Calcolo scientifico & Intelligenza Artificiale",
      "macro": "MAT"
    },
    {
      "name": "Data analytics, Economia e Tecnologie digitali",
      "macro": "ECO"
    },
    {
      "name": "Dati e metodi per le decisioni economiche e finanziarie",
      "macro": "ECO"
    },
    {
      "name": "Decision Science",
      "macro": "MAT"
    },
    {
      "name": "Dati, metodi e modelli per le scienze linguistiche",
      "macro": "UMA"
    },
    {
      "name": "Dental Hygiene",
      "macro": "MED"
    },
    {
      "name": "Dentistry and Dental Prosthodontics",
      "macro": "MED"
    },
    {
      "name": "Design",
      "macro": "ING"
    },
    {
      "name": "Design Sistema Moda",
      "macro": "ING"
    },
    {
      "name": "Design Sostenibile per il Sistema Alimentare",
      "macro": "ING"
    },
    {
      "name": "Design Navale e Nautico",
      "macro": "ING"
    },
    {
      "name": "Design Tessile e Moda",
      "macro": "ING"
    },
    {
      "name": "Design del Prodotto Nautico",
      "macro": "ING"
    },
    {
      "name": "Design del prodotto e della comunicazione",
      "macro": "ING"
    },
    {
      "name": "Design del prodotto, della comunicazione e degli interni",
      "macro": "ING"
    },
    {
      "name": "Design della moda e arti multimediali",
      "macro": "ING"
    },
    {
      "name": "Design e Arti",
      "macro": "ING"
    },
    {
      "name": "Design e Comunicazione",
      "macro": "ING"
    },
    {
      "name": "Design e discipline della moda",
      "macro": "ING"
    },
    {
      "name": "Design for the Built Environment",
      "macro": "ING"
    },
    {
      "name": "Design for Cultural and Productive Context",
      "macro": "ING"
    },
    {
      "name": "Design of sustainable tourism systems – Progettazione dei sistemi turistici",
      "macro": "ECO"
    },
    {
      "name": "Design per l'Innovazione e la Cultura Digitale",
      "macro": "ING"
    },
    {
      "name": "Design per l'innovazione",
      "macro": "ING"
    },
    {
      "name": "Design per l'innovazione sostenibile",
      "macro": "ING"
    },
    {
      "name": "Design per la comunità",
      "macro": "ING"
    },
    {
      "name": "Design per la moda",
      "macro": "ING"
    },
    {
      "name": "Design per le culture mediterranee. Prodotto|Spazio|Comunicazione",
      "macro": "ING"
    },
    {
      "name": "Design prodotto evento",
      "macro": "ING"
    },
    {
      "name": "Design sistemico",
      "macro": "ING"
    },
    {
      "name": "Design, Comunicazione Visiva e Multimediale",
      "macro": "ING"
    },
    {
      "name": "Design, Sostenibilità, Cultura Digitale per il Territorio",
      "macro": "ING"
    },
    {
      "name": "Diagnostica e materiali per la conservazione e il restauro",
      "macro": "UMA"
    },
    {
      "name": "Didattica dell'Italiano come Lingua Seconda",
      "macro": "PSI"
    },
    {
      "name": "Didattica e Comunicazione delle Scienze",
      "macro": "PSI"
    },
    {
      "name": "Dietistica",
      "macro": "MED"
    },
    {
      "name": "Digital Automation Engineering",
      "macro": "ING"
    },
    {
      "name": "Digital Communication - Society, Business & Culture",
      "macro": "ECO"
    },
    {
      "name": "Digital Economics and Business",
      "macro": "ECO"
    },
    {
      "name": "Digital Education",
      "macro": "PSI"
    },
    {
      "name": "Digital Humanities Sistemi interattivi e media digitali",
      "macro": "UMA"
    },
    {
      "name": "Digital Humanities per l'industria culturale",
      "macro": "UMA"
    },
    {
      "name": "Digital Humanities. Beni Culturali e Materie Letterarie",
      "macro": "UMA"
    },
    {
      "name": "Digital Humanities: Comunicazione, Lingue, Patrimonio Culturale",
      "macro": "UMA"
    },
    {
      "name": "Digital Marketing",
      "macro": "ECO"
    },
    {
      "name": "Digital Management",
      "macro": "ECO"
    },
    {
      "name": "Digital Skills for Sustainable Societal Transitions",
      "macro": "UMA"
    },
    {
      "name": "Digital Society, Social Innovation and Global Citizenship",
      "macro": "UMA"
    },
    {
      "name": "Digital Trasformation e Innovation Management",
      "macro": "ECO"
    },
    {
      "name": "Digital and Public Humanities",
      "macro": "UMA"
    },
    {
      "name": "Digital humanities and digital knowledge",
      "macro": "UMA"
    },
    {
      "name": "Digital transformation management",
      "macro": "ECO"
    },
    {
      "name": "Diplomazia e Cooperazione internazionale",
      "macro": "UMA"
    },
    {
      "name": "Direzione Aziendale",
      "macro": "ECO"
    },
    {
      "name": "Direzione aziendale e della Pubblica Amministrazione - Corporate management and public administration",
      "macro": "ECO"
    },
    {
      "name": "Direzione e Consulenza di Impresa",
      "macro": "ECO"
    },
    {
      "name": "Dirigenza scolastica e pedagogia per l'inclusione",
      "macro": "PSI"
    },
    {
      "name": "Diritti umani, migrazioni e cooperazione internazionale",
      "macro": "UMA"
    },
    {
      "name": "Diritto agroalimentare",
      "macro": "GIU"
    },
    {
      "name": "Diritto dell'Innovazione e della Sostenibilità",
      "macro": "GIU"
    },
    {
      "name": "Diritto dell'ambiente e dell'enegia",
      "macro": "GIU"
    },
    {
      "name": "Diritto dell'economia",
      "macro": "GIU"
    },
    {
      "name": "Diritto della prevenzione, dell'innovazione e della sicurezza per le imprese e l'amministrazione pubblica",
      "macro": "GIU"
    },
    {
      "name": "Diritto delle Nuove Tecnologie",
      "macro": "GIU"
    },
    {
      "name": "Diritto della sicurezza e dell'innovazione tecnologica",
      "macro": "GIU"
    },
    {
      "name": "Diritto dello sviluppo sostenibile",
      "macro": "GIU"
    },
    {
      "name": "Diritto e Management dello Sport",
      "macro": "ECO"
    },
    {
      "name": "Diritto e amministrazione pubblica",
      "macro": "GIU"
    },
    {
      "name": "Diritto e tecnologia",
      "macro": "GIU"
    },
    {
      "name": "Diritto ed economia della proprietà immobiliare",
      "macro": "GIU"
    },
    {
      "name": "Diritto ed economia delle imprese",
      "macro": "GIU"
    },
    {
      "name": "Diritto per l'Innovazione di Imprese e Pubbliche Amministrazioni",
      "macro": "GIU"
    },
    {
      "name": "Diritto per l'impresa nazionale e internazionale",
      "macro": "GIU"
    },
    {
      "name": "Diritto per le imprese e le istituzioni",
      "macro": "GIU"
    },
    {
      "name": "Diritto per le tecnologie e l'innovazione sostenibile",
      "macro": "GIU"
    },
    {
      "name": "Diritto, amministrazione e gestione del patrimonio culturale",
      "macro": "GIU"
    },
    {
      "name": "Diritto, economia e strategia d'impresa",
      "macro": "GIU"
    },
    {
      "name": "Diritto, nuove tecnologie e sicurezza",
      "macro": "GIU"
    },
    {
      "name": "Disaster and Health Crisis Management",
      "macro": "ECO"
    },
    {
      "name": "Discipline della Musica e dello Spettacolo. Storia e Teoria",
      "macro": "UMA"
    },
    {
      "name": "Discipline della musica e del teatro",
      "macro": "UMA"
    },
    {
      "name": "Discipline delle Arti, della Musica e dello Spettacolo",
      "macro": "UMA"
    },
    {
      "name": "Discipline storiche e filosofiche",
      "macro": "UMA"
    },
    {
      "name": "Disegno e gestione degli interventi sociali",
      "macro": "PSI"
    },
    {
      "name": "E-Learning e media education",
      "macro": "PSI"
    },
    {
      "name": "East european and eurasian studies",
      "macro": "UMA"
    },
    {
      "name": "Economia",
      "macro": "ECO"
    },
    {
      "name": "Economia aziendale",
      "macro": "ECO"
    },
    {
      "name": "Economia bancaria e finanziaria",
      "macro": "ECO"
    },
    {
      "name": "Economia aziendale e green economy",
      "macro": "ECO"
    },
    {
      "name": "Economia del turismo",
      "macro": "ECO"
    },
    {
      "name": "Economia dell'ambiente, della cultura e del territorio",
      "macro": "ECO"
    },
    {
      "name": "Economia e amministrazione delle imprese",
      "macro": "ECO"
    },
    {
      "name": "Economia e commercio",
      "macro": "ECO"
    },
    {
      "name": "Economia e cultura dell'alimentazione",
      "macro": "ECO"
    },
    {
      "name": "Economia e diritto per la sostenibilità delle organizzazioni",
      "macro": "GIU"
    },
    {
      "name": "Economia e gestione aziendale",
      "macro": "ECO"
    },
    {
      "name": "Economia e finanza",
      "macro": "ECO"
    },
    {
      "name": "Economia e legislazione dei sistemi logistici",
      "macro": "ECO"
    },
    {
      "name": "Economia e management",
      "macro": "ECO"
    },
    {
      "name": "Economia e strategie per i mercati internazionali",
      "macro": "ECO"
    },
    {
      "name": "Economia e scienze comportamentali",
      "macro": "ECO"
    },
    {
      "name": "Economia, analisi dei dati e management",
      "macro": "ECO"
    },
    {
      "name": "Economia, banca e finanza",
      "macro": "ECO"
    },
    {
      "name": "Economia, consulenza e professioni",
      "macro": "ECO"
    },
    {
      "name": "Economia, finanza e impresa",
      "macro": "ECO"
    },
    {
      "name": "Economia, finanza e mercati",
      "macro": "ECO"
    },
    {
      "name": "Economia, management e finanza",
      "macro": "ECO"
    },
    {
      "name": "Economia, mercati e istituzioni",
      "macro": "ECO"
    },
    {
      "name": "Economics",
      "macro": "ECO"
    },
    {
      "name": "Economic analysis and policy",
      "macro": "ECO"
    },
    {
      "name": "Economics & data science",
      "macro": "ECO"
    },
    {
      "name": "Economics and econometrics",
      "macro": "ECO"
    },
    {
      "name": "Economics and finance with data science",
      "macro": "ECO"
    },
    {
      "name": "Economics and public policy",
      "macro": "ECO"
    },
    {
      "name": "Economics and management of cultural and territories",
      "macro": "ECO"
    },
    {
      "name": "Economics and science for environmental sustainability",
      "macro": "ECO"
    },
    {
      "name": "Economics and technologies for sustainability",
      "macro": "ECO"
    },
    {
      "name": "Economics of innovation for sustainable development",
      "macro": "ECO"
    },
    {
      "name": "Educatore nei servizi per l'infanzia",
      "macro": "PSI"
    },
    {
      "name": "Electronics engineering for automation and sensing",
      "macro": "ING"
    },
    {
      "name": "Educatore sociale e culturale",
      "macro": "PSI"
    },
    {
      "name": "English and american studies",
      "macro": "UMA"
    },
    {
      "name": "Engineering of paper and cardboard",
      "macro": "ING"
    },
    {
      "name": "Esperto in gestione delle risorse umane e consulente del lavoro",
      "macro": "ECO"
    },
    {
      "name": "European studies",
      "macro": "UMA"
    },
    {
      "name": "Evoluzione del comportamento animale e dell'uomo",
      "macro": "SCI"
    },
    {
      "name": "Exploration and applied geophysics",
      "macro": "MAT"
    },
    {
      "name": "Earth Sciences for Sustainable Development",
      "macro": "SCI"
    },
    {
      "name": "Earth System and Global Changes",
      "macro": "SCI"
    },
    {
      "name": "Earth and climate dynamics",
      "macro": "SCI"
    },
    {
      "name": "Eco Design Inclusivo",
      "macro": "ING"
    },
    {
      "name": "Eco-Social Design",
      "macro": "ING"
    },
    {
      "name": "Ecobiologia",
      "macro": "SCI"
    },
    {
      "name": "Ecologia e sostenibilità dei cambiamenti globali",
      "macro": "SCI"
    },
    {
      "name": "Ecologia ed Etologia per la Conservazione della Natura",
      "macro": "SCI"
    },
    {
      "name": "Economia & Management del Mare",
      "macro": "ECO"
    },
    {
      "name": "Economia Manageriale",
      "macro": "ECO"
    },
    {
      "name": "Economia Governo e Amministrazione",
      "macro": "ECO"
    },
    {
      "name": "Economia aziendale, diritto e governance d'impresa",
      "macro": "GIU"
    },
    {
      "name": "Economia aziendale, direzione amministrativa e professione",
      "macro": "ECO"
    },
    {
      "name": "Economia degli Intermediari e dei Mercati Finanziari",
      "macro": "ECO"
    },
    {
      "name": "Economia del Turismo e della Cultura",
      "macro": "UMA"
    },
    {
      "name": "Economia dell'ambiente, della cultura e del turismo",
      "macro": "UMA"
    },
    {
      "name": "Economia dell'ambiente, lavoro e sviluppo sostenibile",
      "macro": "ECO"
    },
    {
      "name": "Economia dell'impresa",
      "macro": "ECO"
    },
    {
      "name": "Economia dell'innovazione",
      "macro": "ECO"
    },
    {
      "name": "Economia delle Aziende Marittime, della Logistica e dei Trasporti",
      "macro": "ECO"
    },
    {
      "name": "Economia delle Imprese Finanziarie",
      "macro": "ECO"
    },
    {
      "name": "Economia e Big Data",
      "macro": "ECO"
    },
    {
      "name": "Economia e Direzione delle Imprese",
      "macro": "ECO"
    },
    {
      "name": "Economia e Diritto",
      "macro": "GIU"
    },
    {
      "name": "Economia e Gestione della Trasformazione Digitale",
      "macro": "ECO"
    },
    {
      "name": "Economia e Informatica per l'Impresa",
      "macro": "ECO"
    },
    {
      "name": "Economia e Management del Made in Italy",
      "macro": "ECO"
    },
    {
      "name": "Economia e Management delle Filiere Alimentari Sostenibili",
      "macro": "ECO"
    },
    {
      "name": "Economia e Mercati Agro-Alimentari",
      "macro": "ECO"
    },
    {
      "name": "Economia e Politiche per la sostenibilità globale",
      "macro": "ECO"
    },
    {
      "name": "Economia e Statistica per le Organizzazioni",
      "macro": "ECO"
    },
    {
      "name": "Economia e amministrazione aziendale",
      "macro": "ECO"
    },
    {
      "name": "Economia e cooperazione internazionale per lo sviluppo sostenibile",
      "macro": "ECO"
    },
    {
      "name": "Economia e gestione degli intermediari finanziari",
      "macro": "ECO"
    },
    {
      "name": "Economia e gestione delle imprese culturali e creative",
      "macro": "ECO"
    },
    {
      "name": "Economia e gestione delle arti e delle attività culturali",
      "macro": "ECO"
    },
    {
      "name": "Economia e innovazione aziendale",
      "macro": "ECO"
    },
    {
      "name": "Economia e governance delle organizzazioni pubbliche",
      "macro": "ECO"
    },
    {
      "name": "Economia e management del turismo",
      "macro": "ECO"
    },
    {
      "name": "Economia e legislazione d'impresa",
      "macro": "ECO"
    },
    {
      "name": "Economia e management dell'innovazione",
      "macro": "ECO"
    },
    {
      "name": "Economia e management marittimo e portuale",
      "macro": "ECO"
    },
    {
      "name": "Economia e management per la creazione di valore",
      "macro": "ECO"
    },
    {
      "name": "Economia e marketing internazionale",
      "macro": "ECO"
    },
    {
      "name": "Economia e marketing per la sostenibilità",
      "macro": "ECO"
    },
    {
      "name": "Economia e politiche del territorio e dell'impresa",
      "macro": "ECO"
    },
    {
      "name": "Economia e politiche pubbliche",
      "macro": "ECO"
    },
    {
      "name": "Economia ed organizzazione aziendale",
      "macro": "ECO"
    },
    {
      "name": "Economia internazionale e mercati finanziari",
      "macro": "ECO"
    },
    {
      "name": "Economia per l'ambiente e la sostenibilità",
      "macro": "ECO"
    },
    {
      "name": "Economia politica",
      "macro": "ECO"
    },
    {
      "name": "Economia sociale e imprese cooperative",
      "macro": "ECO"
    },
    {
      "name": "Economia, Finanza e Analisi dei Dati",
      "macro": "ECO"
    },
    {
      "name": "Economia, Diritto e Finanza d'Impresa",
      "macro": "GIU"
    },
    {
      "name": "Economia, Finanza e Innovazione",
      "macro": "ECO"
    },
    {
      "name": "Economia, Imprese e Mercati Finanziari",
      "macro": "ECO"
    },
    {
      "name": "Economia, Impresa e Sostenibilità",
      "macro": "ECO"
    },
    {
      "name": "Economia, Imprese e Mercati Internazionali",
      "macro": "ECO"
    },
    {
      "name": "Economia, Imprese e Sostenibilità",
      "macro": "ECO"
    },
    {
      "name": "Economia, Management e Governance",
      "macro": "ECO"
    },
    {
      "name": "Economia, Management e Sostenibilità",
      "macro": "ECO"
    },
    {
      "name": "Economia, Politica ed Etica",
      "macro": "ECO"
    },
    {
      "name": "Economia, ambiente e sviluppo",
      "macro": "ECO"
    },
    {
      "name": "Economia, politiche pubbliche e sostenibilità",
      "macro": "ECO"
    },
    {
      "name": "Economics and Entrepreneurship",
      "macro": "ECO"
    },
    {
      "name": "Economics and Finance",
      "macro": "ECO"
    },
    {
      "name": "Economics and communication for management and innovation",
      "macro": "ECO"
    },
    {
      "name": "Economics and political science - Economia e scienza politica",
      "macro": "ECO"
    },
    {
      "name": "Economics of Tourism and Cities",
      "macro": "ECO"
    },
    {
      "name": "Economics with data science",
      "macro": "ECO"
    },
    {
      "name": "Economics, Development and Innovation",
      "macro": "ECO"
    },
    {
      "name": "Economics, Finance and Sustainability",
      "macro": "ECO"
    },
    {
      "name": "Economics, Politics and Social Sciences",
      "macro": "ECO"
    },
    {
      "name": "Economics: Behavior, Data and Policy",
      "macro": "ECO"
    },
    {
      "name": "Ecotossicologia e sostenibilità ambientale",
      "macro": "SCI"
    },
    {
      "name": "Editoria e scrittura",
      "macro": "UMA"
    },
    {
      "name": "Editoria e giornalismo",
      "macro": "UMA"
    },
    {
      "name": "Editoria, culture della comunicazione e della moda",
      "macro": "UMA"
    },
    {
      "name": "Educatore di nido e dei servizi per l'infanzia",
      "macro": "PSI"
    },
    {
      "name": "Educazione al Patrimonio Archeologico e Artistico",
      "macro": "PSI"
    },
    {
      "name": "Educazione professionale",
      "macro": "PSI"
    },
    {
      "name": "Educazione sociale e tecniche dell'intervento educativo",
      "macro": "PSI"
    },
    {
      "name": "Electric vehicle engineering",
      "macro": "ING"
    },
    {
      "name": "Electrical Engineering",
      "macro": "ING"
    },
    {
      "name": "Electrical Engineering for Sustainable Green Energy Transition",
      "macro": "ING"
    },
    {
      "name": "Electrical Engineering for Digital Energy",
      "macro": "ING"
    },
    {
      "name": "Electronic Engineering for Intelligent Vehicles",
      "macro": "ING"
    },
    {
      "name": "Electrical Engineering for Energy Transition",
      "macro": "ING"
    },
    {
      "name": "Electronic and Communications Engineering",
      "macro": "ING"
    },
    {
      "name": "Electronics Engineering",
      "macro": "ING"
    },
    {
      "name": "Electronics and Telecommunications Engineering",
      "macro": "ING"
    },
    {
      "name": "Energy Engineering",
      "macro": "ING"
    },
    {
      "name": "Engineering Management",
      "macro": "ING"
    },
    {
      "name": "Engineering Physics",
      "macro": "ING"
    },
    {
      "name": "Engineering Sciences",
      "macro": "ING"
    },
    {
      "name": "Engineering Technology for Strategy and Security",
      "macro": "ING"
    },
    {
      "name": "Engineering and Management for Health",
      "macro": "ING"
    },
    {
      "name": "Engineering for Historic Building Rehabilitation",
      "macro": "ING"
    },
    {
      "name": "Engineering for Natural Risk Management",
      "macro": "ING"
    },
    {
      "name": "Engineering for the Food Industry",
      "macro": "ING"
    },
    {
      "name": "Engineering for the Energy Transition",
      "macro": "ING"
    },
    {
      "name": "Engineering in Computer Science",
      "macro": "ING"
    },
    {
      "name": "Engineering in Computer Science and Artificial Intelligence",
      "macro": "ING"
    },
    {
      "name": "English and Anglo-American Studies",
      "macro": "UMA"
    },
    {
      "name": "Entrepreneurship and Innovation",
      "macro": "ECO"
    },
    {
      "name": "Environmental Change and Global Sustainability",
      "macro": "SCI"
    },
    {
      "name": "Environmental Conservation, Restoration and Sustainability",
      "macro": "SCI"
    },
    {
      "name": "Environmental Engineering",
      "macro": "ING"
    },
    {
      "name": "Environmental Hazard and Disaster Risk Management",
      "macro": "ECO"
    },
    {
      "name": "Environmental Engineering for Risk Mitigation",
      "macro": "ING"
    },
    {
      "name": "Environmental Humanities",
      "macro": "SCI"
    },
    {
      "name": "Environmental Management of Mountain Areas",
      "macro": "ECO"
    },
    {
      "name": "Environmental Meteorology",
      "macro": "SCI"
    },
    {
      "name": "Environmental Meteorology and Climate Physics",
      "macro": "MAT"
    },
    {
      "name": "Environmental Sciences and Civil Protection",
      "macro": "SCI"
    },
    {
      "name": "Environmental Sustainability and Education",
      "macro": "PSI"
    },
    {
      "name": "Environmental and Food Economics",
      "macro": "ECO"
    },
    {
      "name": "Environmental and Sustainable Building Engineering",
      "macro": "ING"
    },
    {
      "name": "European Economy and Business Law",
      "macro": "GIU"
    },
    {
      "name": "European Languages, Cultures and Societies in Contact",
      "macro": "UMA"
    },
    {
      "name": "European Legal Studies",
      "macro": "GIU"
    },
    {
      "name": "European Master in Business Studies",
      "macro": "ECO"
    },
    {
      "name": "European and Global Studies",
      "macro": "UMA"
    },
    {
      "name": "European and International Studies",
      "macro": "UMA"
    },
    {
      "name": "European policies for digital, ecological and social transitions",
      "macro": "SCI"
    },
    {
      "name": "Evolutionary biology",
      "macro": "SCI"
    },
    {
      "name": "Farmacia",
      "macro": "MED"
    },
    {
      "name": "FILOLOGIA E STORIA DELL'ANTICHITà",
      "macro": "UMA"
    },
    {
      "name": "Filologia moderna",
      "macro": "UMA"
    },
    {
      "name": "Filologia, letteratura e tradizione classica",
      "macro": "UMA"
    },
    {
      "name": "Filologia, letterature e storia",
      "macro": "UMA"
    },
    {
      "name": "Filosofia",
      "macro": "UMA"
    },
    {
      "name": "Filosofia e forme del sapere",
      "macro": "UMA"
    },
    {
      "name": "Filosofia e teoria dei processi comunicativi",
      "macro": "UMA"
    },
    {
      "name": "Finanza aziendale e mercati finanziari",
      "macro": "ECO"
    },
    {
      "name": "Fisica",
      "macro": "MAT"
    },
    {
      "name": "Fisica medica",
      "macro": "MAT"
    },
    {
      "name": "Fisioterapia",
      "macro": "MED"
    },
    {
      "name": "Farmaceutica e Nutraceutica Animale",
      "macro": "SCI"
    },
    {
      "name": "Fashion Communication and Luxury Strategies",
      "macro": "UMA"
    },
    {
      "name": "Fashion Studies",
      "macro": "UMA"
    },
    {
      "name": "Fashion theory and practices",
      "macro": "UMA"
    },
    {
      "name": "Filologia Classica e Moderna",
      "macro": "UMA"
    },
    {
      "name": "Filologia classica",
      "macro": "UMA"
    },
    {
      "name": "Filologia e Scienze dell'antichità",
      "macro": "UMA"
    },
    {
      "name": "Filologia e critica letteraria",
      "macro": "UMA"
    },
    {
      "name": "Filologia e patrimonio culturale",
      "macro": "UMA"
    },
    {
      "name": "Filologia moderna - Francesistica e Italianistica",
      "macro": "UMA"
    },
    {
      "name": "Filologia, letteratura e storia dell'antichità",
      "macro": "UMA"
    },
    {
      "name": "Filologia, letterature e storia del mondo antico",
      "macro": "UMA"
    },
    {
      "name": "Filologia, letterature e civiltà del mondo antico",
      "macro": "UMA"
    },
    {
      "name": "Filologia, letterature e storia dell'antichità",
      "macro": "UMA"
    },
    {
      "name": "Filologia, linguistica e letteratura italiana",
      "macro": "UMA"
    },
    {
      "name": "Filologia, linguistica e tradizioni letterarie",
      "macro": "UMA"
    },
    {
      "name": "Filologie e Letterature Classiche e Moderne",
      "macro": "UMA"
    },
    {
      "name": "Filologie e Letterature medievali e moderne",
      "macro": "UMA"
    },
    {
      "name": "Filosofia contemporanea",
      "macro": "UMA"
    },
    {
      "name": "Filosofia dell'Informazione",
      "macro": "UMA"
    },
    {
      "name": "Filosofia del mondo contemporaneo",
      "macro": "UMA"
    },
    {
      "name": "Filosofia e Comunicazione",
      "macro": "UMA"
    },
    {
      "name": "Filosofia e Intelligenza Artificiale",
      "macro": "MAT"
    },
    {
      "name": "Filosofia e Scienze dell'educazione",
      "macro": "PSI"
    },
    {
      "name": "Filosofia e Scienze e Tecniche psicologiche",
      "macro": "PSI"
    },
    {
      "name": "Filosofia e Storia",
      "macro": "UMA"
    },
    {
      "name": "Filosofia e linguaggi della modernità",
      "macro": "UMA"
    },
    {
      "name": "Filosofia e società contemporanea",
      "macro": "UMA"
    },
    {
      "name": "Filosofia e trasformazione digitale",
      "macro": "UMA"
    },
    {
      "name": "Filosofia ed etica delle relazioni",
      "macro": "UMA"
    },
    {
      "name": "Filosofia, Scienze e Società",
      "macro": "UMA"
    },
    {
      "name": "Filosofia, politica e studi culturali",
      "macro": "UMA"
    },
    {
      "name": "Finance",
      "macro": "ECO"
    },
    {
      "name": "Finance and Banking - Finanza e Banca",
      "macro": "ECO"
    },
    {
      "name": "Finance and Economics",
      "macro": "ECO"
    },
    {
      "name": "Finance and Insurance",
      "macro": "ECO"
    },
    {
      "name": "Finance and risk management - Finanza e gestione del rischio",
      "macro": "ECO"
    },
    {
      "name": "Finanza",
      "macro": "ECO"
    },
    {
      "name": "Finanza Aziendale",
      "macro": "ECO"
    },
    {
      "name": "Finanza e Risk Management",
      "macro": "ECO"
    },
    {
      "name": "Finanza e assicurazioni",
      "macro": "ECO"
    },
    {
      "name": "Finanza e impresa",
      "macro": "ECO"
    },
    {
      "name": "Finanza e management",
      "macro": "ECO"
    },
    {
      "name": "Finanza e mercati",
      "macro": "ECO"
    },
    {
      "name": "Finanza, Intermediari e Mercati",
      "macro": "ECO"
    },
    {
      "name": "Fisica Applicata",
      "macro": "MAT"
    },
    {
      "name": "Fisica dei sistemi complessi",
      "macro": "MAT"
    },
    {
      "name": "Fisica del Sistema Terra",
      "macro": "MAT"
    },
    {
      "name": "Fisica e Astrofisica",
      "macro": "MAT"
    },
    {
      "name": "Fisica e tecnologie avanzate",
      "macro": "MAT"
    },
    {
      "name": "Food Design e Innovazione dei Prodotti Alimentari",
      "macro": "ING"
    },
    {
      "name": "Food Engineering",
      "macro": "ING"
    },
    {
      "name": "Food Health and Environment",
      "macro": "SCI"
    },
    {
      "name": "Food Industry Management",
      "macro": "ECO"
    },
    {
      "name": "Food Safety and Food Risk Management",
      "macro": "ECO"
    },
    {
      "name": "Food Science and Technology",
      "macro": "SCI"
    },
    {
      "name": "Food Sciences for Innovation and Authenticity",
      "macro": "SCI"
    },
    {
      "name": "Food and Beverage Innovation and Management",
      "macro": "ECO"
    },
    {
      "name": "Food and Health",
      "macro": "SCI"
    },
    {
      "name": "Food animal metabolism and management in the circular economy",
      "macro": "ECO"
    },
    {
      "name": "Food industry engineering",
      "macro": "ING"
    },
    {
      "name": "Forest Sciences",
      "macro": "SCI"
    },
    {
      "name": "Forestry and Environmental Sciences",
      "macro": "SCI"
    },
    {
      "name": "Formazione e Sviluppo delle Risorse Umane",
      "macro": "ECO"
    },
    {
      "name": "Formazione, comunicazione e cittadinanza digitale",
      "macro": "UMA"
    },
    {
      "name": "Functional and Sustainable Materials",
      "macro": "SCI"
    },
    {
      "name": "Geografia e processi territoriali",
      "macro": "UMA"
    },
    {
      "name": "Geologia ambientale e gestione del territorio",
      "macro": "SCI"
    },
    {
      "name": "Geology",
      "macro": "SCI"
    },
    {
      "name": "Georisorse e gestione ecosostenibile d'impresa",
      "macro": "ECO"
    },
    {
      "name": "Geotecnologie per le risorse, l'ambiente e i rischi",
      "macro": "SCI"
    },
    {
      "name": "GEOURBANISTICA. Analisi e pianificazione territoriale, urbana, ambientale e valorizzazione del paesaggio",
      "macro": "ING"
    },
    {
      "name": "Gestione dei fenomeni migratori e politiche di integrazione nell'unione europea",
      "macro": "UMA"
    },
    {
      "name": "Gestione dei sistemi aerospaziali per la difesa",
      "macro": "ING"
    },
    {
      "name": "Gestione e innovazione dei servizi sociali, imprenditorialità sociale e management del terzo settore",
      "macro": "PSI"
    },
    {
      "name": "Gestione sostenibile del territorio forestale e montano",
      "macro": "SCI"
    },
    {
      "name": "Giurisprudenza",
      "macro": "GIU"
    },
    {
      "name": "Governance e politiche dell'innovazione digitale",
      "macro": "UMA"
    },
    {
      "name": "Green management e sostenibilità",
      "macro": "ECO"
    },
    {
      "name": "Greening energy market and finance",
      "macro": "ECO"
    },
    {
      "name": "Gender studies, culture e politiche per i media e la comunicazione",
      "macro": "UMA"
    },
    {
      "name": "Genetic Counsellors",
      "macro": "MED"
    },
    {
      "name": "Genetica e Biologia Molecolare",
      "macro": "SCI"
    },
    {
      "name": "Genomica funzionale",
      "macro": "SCI"
    },
    {
      "name": "Genomics",
      "macro": "SCI"
    },
    {
      "name": "Geoengineering",
      "macro": "ING"
    },
    {
      "name": "Geoenvironmental Resources and Risks",
      "macro": "SCI"
    },
    {
      "name": "Geografia e scienze territoriali",
      "macro": "UMA"
    },
    {
      "name": "Geografia, ambiente e territorio",
      "macro": "SCI"
    },
    {
      "name": "Geografie della decolonizzazione: sostenibilità, paesaggi, patrimoni culturali",
      "macro": "ING"
    },
    {
      "name": "Geography, Spatial Management, Heritage for International Cooperation",
      "macro": "ECO"
    },
    {
      "name": "Geologia",
      "macro": "SCI"
    },
    {
      "name": "Geologia Applicata alla protezione e allo sviluppo sostenibile del territorio",
      "macro": "SCI"
    },
    {
      "name": "Geologia ambientale e dinamica della Terra",
      "macro": "SCI"
    },
    {
      "name": "Geologia di esplorazione",
      "macro": "SCI"
    },
    {
      "name": "Geologia e Geofisica",
      "macro": "MAT"
    },
    {
      "name": "Geologia e Tutela dell'Ambiente",
      "macro": "SCI"
    },
    {
      "name": "Geologia per la sostenibilità ambientale",
      "macro": "SCI"
    },
    {
      "name": "Geologia per lo Sviluppo Sostenibile",
      "macro": "SCI"
    },
    {
      "name": "Geologia, Ambiente e Rischi",
      "macro": "SCI"
    },
    {
      "name": "Geology for Energy Resources",
      "macro": "SCI"
    },
    {
      "name": "Geophysical Sciences for Seismic Risk",
      "macro": "MAT"
    },
    {
      "name": "Geophysics",
      "macro": "MAT"
    },
    {
      "name": "Geophysics and geodata",
      "macro": "MAT"
    },
    {
      "name": "Geophysics for natural risks and resources",
      "macro": "MAT"
    },
    {
      "name": "Geopolitica economia e strategie globali",
      "macro": "ECO"
    },
    {
      "name": "Geopolitica, Economia e Strategie Globali",
      "macro": "ECO"
    },
    {
      "name": "Georesources and Geoenergy Engineering",
      "macro": "ING"
    },
    {
      "name": "Georischi e Georisorse",
      "macro": "SCI"
    },
    {
      "name": "Geoscienze",
      "macro": "SCI"
    },
    {
      "name": "Geoscienze e tecnologie per lo studio e la gestione sostenibile del sistema Terra",
      "macro": "SCI"
    },
    {
      "name": "Geoscienze per l'ambiente, le risorse e i rischi naturali",
      "macro": "SCI"
    },
    {
      "name": "Geoscienze per lo sviluppo sostenibile",
      "macro": "SCI"
    },
    {
      "name": "Geoscienze, Georischi e Georisorse",
      "macro": "SCI"
    },
    {
      "name": "Gestione Ambientale e Sviluppo Sostenibile",
      "macro": "SCI"
    },
    {
      "name": "Gestione Strategica e Marketing Digitale",
      "macro": "ECO"
    },
    {
      "name": "Gestione aziendale",
      "macro": "ECO"
    },
    {
      "name": "Gestione degli Animali e delle Produzioni",
      "macro": "SCI"
    },
    {
      "name": "Gestione degli spazi verdi, dei boschi e delle aree protette",
      "macro": "SCI"
    },
    {
      "name": "Gestione dei Servizi Sociali e contrasto alle devianze",
      "macro": "PSI"
    },
    {
      "name": "Gestione dei Sistemi Produttivi Agrari Mediterranei",
      "macro": "SCI"
    },
    {
      "name": "Gestione del Processo Edilizio - Project Management",
      "macro": "ECO"
    },
    {
      "name": "Gestione del progetto e della costruzione",
      "macro": "ING"
    },
    {
      "name": "Gestione del turismo culturale e degli eventi",
      "macro": "UMA"
    },
    {
      "name": "Gestione delle Politiche e dei Servizi Sociali",
      "macro": "PSI"
    },
    {
      "name": "Gestione delle attività turistiche e culturali",
      "macro": "UMA"
    },
    {
      "name": "Gestione delle politiche dei servizi sociali e multiculturalità",
      "macro": "PSI"
    },
    {
      "name": "Gestione e Conservazione dei Documenti digitali",
      "macro": "UMA"
    },
    {
      "name": "Gestione e Valorizzazione delle risorse agrarie e delle aree protette",
      "macro": "SCI"
    },
    {
      "name": "Gestione e protezione delle risorse territoriali e ambientali",
      "macro": "SCI"
    },
    {
      "name": "Gestione e valorizzazione degli archivi e delle biblioteche",
      "macro": "UMA"
    },
    {
      "name": "Gestione e valorizzazione del territorio",
      "macro": "ECO"
    },
    {
      "name": "Gestione sostenibile dell'Ambiente e del Paesaggio",
      "macro": "ING"
    },
    {
      "name": "Gestione sostenibile delle foreste e del verde urbano",
      "macro": "SCI"
    },
    {
      "name": "Giornalismo e Informazione Web",
      "macro": "UMA"
    },
    {
      "name": "Giornalismo, Cultura Editoriale, Comunicazione Ambientale e Multimediale",
      "macro": "SCI"
    },
    {
      "name": "Giurisprudenza italiana e francese",
      "macro": "GIU"
    },
    {
      "name": "Giurisprudenza italiana e tedesca",
      "macro": "GIU"
    },
    {
      "name": "Giurista d'impresa e delle nuove tecnologie",
      "macro": "GIU"
    },
    {
      "name": "Giurista del terzo settore",
      "macro": "GIU"
    },
    {
      "name": "Giurista per le imprese e per la pubblica amministrazione",
      "macro": "GIU"
    },
    {
      "name": "Global Accounting and Finance",
      "macro": "ECO"
    },
    {
      "name": "Global Affairs: Geopolitics and Sustainability",
      "macro": "UMA"
    },
    {
      "name": "Global Cultures",
      "macro": "UMA"
    },
    {
      "name": "Global Development and Entrepreneurship",
      "macro": "ECO"
    },
    {
      "name": "Global Environment and Development",
      "macro": "SCI"
    },
    {
      "name": "Global Food Law: Sustainability Challenges and Innovation",
      "macro": "GIU"
    },
    {
      "name": "Global Governance",
      "macro": "UMA"
    },
    {
      "name": "Global Humanities",
      "macro": "UMA"
    },
    {
      "name": "Global Law Making",
      "macro": "GIU"
    },
    {
      "name": "Global Law and Transnational Legal Studies",
      "macro": "GIU"
    },
    {
      "name": "Global Politics and Euro-Mediterranean Relations",
      "macro": "UMA"
    },
    {
      "name": "Global Politics and Society",
      "macro": "UMA"
    },
    {
      "name": "Global Politics e Relazioni Internazionali",
      "macro": "UMA"
    },
    {
      "name": "Global Studies for Sustainable Local and International Development and Cooperation",
      "macro": "UMA"
    },
    {
      "name": "Global change e gestione sostenibile della natura",
      "macro": "SCI"
    },
    {
      "name": "Governance dell'amministrazione pubblica e delle organizzazioni complesse",
      "macro": "UMA"
    },
    {
      "name": "Global economy and business",
      "macro": "ECO"
    },
    {
      "name": "Governance dell'emergenza",
      "macro": "UMA"
    },
    {
      "name": "Governance e amministrazione d'impresa",
      "macro": "ECO"
    },
    {
      "name": "Governance euro-mediterranea delle politiche migratorie",
      "macro": "UMA"
    },
    {
      "name": "Governo delle amministrazioni pubbliche",
      "macro": "UMA"
    },
    {
      "name": "Governo e Amministrazione",
      "macro": "UMA"
    },
    {
      "name": "Governo e direzione d'impresa",
      "macro": "ECO"
    },
    {
      "name": "Governo, amministrazione e territorio",
      "macro": "UMA"
    },
    {
      "name": "Green Economy and Sustainable Transitions",
      "macro": "ECO"
    },
    {
      "name": "Green Industrial Engineering",
      "macro": "ING"
    },
    {
      "name": "Hospitality for sustainable tourism development",
      "macro": "ECO"
    },
    {
      "name": "Health Biotechnology",
      "macro": "MED"
    },
    {
      "name": "Health Economics",
      "macro": "ECO"
    },
    {
      "name": "Health Informatics",
      "macro": "MAT"
    },
    {
      "name": "Health Professions of Rehabilitation Sciences",
      "macro": "MED"
    },
    {
      "name": "Health economics and management",
      "macro": "ECO"
    },
    {
      "name": "Hospitality Innovation and e-Tourism",
      "macro": "ECO"
    },
    {
      "name": "Hospitality Management",
      "macro": "ECO"
    },
    {
      "name": "Hospitality and Tourism Management",
      "macro": "ECO"
    },
    {
      "name": "Human Rights and Multi-level Governance",
      "macro": "UMA"
    },
    {
      "name": "Human-Centered Artificial Intelligence",
      "macro": "MAT"
    },
    {
      "name": "Human-Computer Interaction",
      "macro": "MAT"
    },
    {
      "name": "ICT Engineering for Smart Societies",
      "macro": "ING"
    },
    {
      "name": "ICT and Internet Engineering - Ingegneria di Internet e delle Tecnologie per l'Informazione e la Comunicazione",
      "macro": "ING"
    },
    {
      "name": "ICT for Internet and multimedia - Ingegneria per le Comunicazioni Multimediali e Internet",
      "macro": "ING"
    },
    {
      "name": "Imprenditorialità e management internazionale",
      "macro": "ECO"
    },
    {
      "name": "Infermieristica",
      "macro": "MED"
    },
    {
      "name": "Informatica",
      "macro": "MAT"
    },
    {
      "name": "Informatica umanistica",
      "macro": "MAT"
    },
    {
      "name": "Informatics for digital health",
      "macro": "MAT"
    },
    {
      "name": "Industrial Safety and Risk Engineering",
      "macro": "ING"
    },
    {
      "name": "Ingegneria aerospaziale",
      "macro": "ING"
    },
    {
      "name": "Ingegneria ambientale",
      "macro": "ING"
    },
    {
      "name": "Ingegneria biomedica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria chimica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria civile",
      "macro": "ING"
    },
    {
      "name": "Ingegneria civile - edile - ambientale",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dei materiali e dei processi sostenibili",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dei materiali e nanotecnologie",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dei veicoli",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dell' informazione: elettronica, informatica e telecomunicazioni",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dell'energia",
      "macro": "ING"
    },
    {
      "name": "Ingegneria della trasformazione digitale",
      "macro": "ING"
    },
    {
      "name": "Ingegneria delle infrastrutture civili e dell'ambiente",
      "macro": "ING"
    },
    {
      "name": "Ingegneria delle telecomunicazioni e delle tecnologie elettroniche",
      "macro": "ING"
    },
    {
      "name": "Ingegneria edile",
      "macro": "ING"
    },
    {
      "name": "Ingegneria edile-architettura",
      "macro": "ING"
    },
    {
      "name": "Ingegneria elettrica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria elettronica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria elettronica e biomedica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria elettronica e delle tecnologie digitali",
      "macro": "ING"
    },
    {
      "name": "Ingegneria energetica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria gestionale",
      "macro": "ING"
    },
    {
      "name": "Ingegneria industriale",
      "macro": "ING"
    },
    {
      "name": "Ingegneria informatica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria informatica e dell'automazione",
      "macro": "ING"
    },
    {
      "name": "Ingegneria meccanica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria meccatronica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria nautica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria per il design industriale",
      "macro": "ING"
    },
    {
      "name": "Ingegneria per l'industria sostenibile",
      "macro": "ING"
    },
    {
      "name": "Ingegneria robotica e dell'automazione",
      "macro": "ING"
    },
    {
      "name": "Ingegneria strutturale e edile",
      "macro": "ING"
    },
    {
      "name": "Innovation development in agri-food systems",
      "macro": "SCI"
    },
    {
      "name": "Innovazione digitale e comunicazione",
      "macro": "UMA"
    },
    {
      "name": "Innovazione sociale, comunicazione, nuove tecnologie",
      "macro": "UMA"
    },
    {
      "name": "Innovazione sostenibile in viticoltura ed enologia",
      "macro": "SCI"
    },
    {
      "name": "Intercultural studies in languages and literatures",
      "macro": "UMA"
    },
    {
      "name": "International economics - economia internazionale",
      "macro": "ECO"
    },
    {
      "name": "International management",
      "macro": "ECO"
    },
    {
      "name": "International relations",
      "macro": "UMA"
    },
    {
      "name": "Interpretariato e traduzione",
      "macro": "UMA"
    },
    {
      "name": "Interpretazione",
      "macro": "UMA"
    },
    {
      "name": "ISTITUZIONI, POLITICA E SOCIETà",
      "macro": "UMA"
    },
    {
      "name": "Italianistica",
      "macro": "UMA"
    },
    {
      "name": "Italianistica e culture letterarie europee",
      "macro": "UMA"
    },
    {
      "name": "Igiene Dentale",
      "macro": "MED"
    },
    {
      "name": "Imprenditorialità e Qualità per il Sistema Agroalimentare",
      "macro": "SCI"
    },
    {
      "name": "Industrial Automation Engineering",
      "macro": "ING"
    },
    {
      "name": "Industrial Bioengineering",
      "macro": "ING"
    },
    {
      "name": "Industrial Engineering Technology",
      "macro": "ING"
    },
    {
      "name": "Industrial Engineering for Sustainable Manufacturing",
      "macro": "ING"
    },
    {
      "name": "Industrial Mechanical Engineering",
      "macro": "ING"
    },
    {
      "name": "Industrial chemistry for circular and bio economy",
      "macro": "ECO"
    },
    {
      "name": "Industrial nanobiotechnologies for pharmaceuticals",
      "macro": "SCI"
    },
    {
      "name": "Infermieristica pediatrica",
      "macro": "MED"
    },
    {
      "name": "Informatica - Computer Science",
      "macro": "MAT"
    },
    {
      "name": "Informatica - Scienza e Tecnologia",
      "macro": "MAT"
    },
    {
      "name": "Informatica Applicata",
      "macro": "MAT"
    },
    {
      "name": "Informatica Applicata e Data Analytics",
      "macro": "MAT"
    },
    {
      "name": "Informatica e Innovazione Digitale",
      "macro": "MAT"
    },
    {
      "name": "Informatica e Management delle Aziende digitali",
      "macro": "ECO"
    },
    {
      "name": "Informatica e Tecnologie dell'Informazione",
      "macro": "MAT"
    },
    {
      "name": "Informatica per il Management",
      "macro": "ECO"
    },
    {
      "name": "Informatica e tecnologie per la produzione del software",
      "macro": "MAT"
    },
    {
      "name": "Informatica musicale",
      "macro": "MAT"
    },
    {
      "name": "Informatica per la Comunicazione Digitale",
      "macro": "MAT"
    },
    {
      "name": "Information Engineering",
      "macro": "ING"
    },
    {
      "name": "Information Engineering for Digital Medicine",
      "macro": "ING"
    },
    {
      "name": "Informazione Scientifica del Farmaco e delle Tecnologie per la Salute",
      "macro": "SCI"
    },
    {
      "name": "Informazione Scientifica sul Farmaco e Scienze del Fitness e dei Prodotti della Salute",
      "macro": "SCI"
    },
    {
      "name": "Informazione digitale",
      "macro": "UMA"
    },
    {
      "name": "Informazione ed Editoria",
      "macro": "UMA"
    },
    {
      "name": "Informazione, culture e organizzazione dei media",
      "macro": "UMA"
    },
    {
      "name": "Informazione, editoria, giornalismo",
      "macro": "UMA"
    },
    {
      "name": "Informazione, media, pubblicità",
      "macro": "UMA"
    },
    {
      "name": "Ingegneria Aerospaziale, Meccanica, Energetica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Ambientale per lo Sviluppo Sostenibile",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Ambientale per lo Sviluppo Sostenibile e la Tutela del Territorio",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Chimica e Biochimica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Chimica e dei Processi Biotecnologici",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Chimica e di Processo",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Chimica per l'Innovazione e la Sostenibilità dei Processi",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Chimica per lo Sviluppo Sostenibile",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Civile Strutturale e Geotecnica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Civile e Ambientale",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Civile e Ambientale per la Mitigazione dei Rischi",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Civile e Ambientale per la Sicurezza del Territorio e la Tutela dell'Ambiente",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Civile e Ambientale per lo sviluppo sostenibile",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Civile e Edile per la sostenibilità",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Civile, Ambientale e Gestionale",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Civile, Edile e Ambientale",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Civile, per l'Ambiente e il Territorio",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Clinica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Edile, Innovazione e Recupero del Costruito",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Elettrica per la E-Mobility",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Elettronica e dell'Informazione",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Elettronica e Informatica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Elettronica e Tecnologie dell'Informazione",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Elettronica e delle Tecnologie Internet",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Elettronica, Informatica e delle Telecomunicazioni",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Energetica e Nucleare",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Fisica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Gestionale delle Costruzioni",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Industriale Meccanica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Industriale e dei Sistemi Navali",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Industriale per la Sostenibilità Ambientale",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Informatica e Automatica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Informatica e Robotica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Informatica e Biomedica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Informatica e dei sistemi per le Telecomunicazioni",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Informatica e dell'Intelligenza Artificiale",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Informatica e delle Tecnologie dell'Informazione",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Informatica e delle Telecomunicazioni",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Informatica ed Elettronica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Informatica per la Transizione Digitale",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Informatica, Biomedica e delle Telecomunicazioni",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Matematica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Meccanica - Energia e Aeronautica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Meccanica - Progettazione e Produzione",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Meccanica e Gestionale",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Meccanica per l'Automazione",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Meccanica per la Progettazione e la Produzione",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Meccanica per la Transizione Verde",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Medica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Navale",
      "macro": "ING"
    },
    {
      "name": "Ingegneria Robotica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria aeronautica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria ambientale e per la sostenibilità degli ambienti di lavoro",
      "macro": "ING"
    },
    {
      "name": "Ingegneria ambientale per la resilienza territoriale",
      "macro": "ING"
    },
    {
      "name": "Ingegneria ambientale per la transizione ecologica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria chimica e alimentare",
      "macro": "ING"
    },
    {
      "name": "Ingegneria chimica e dei processi sostenibili",
      "macro": "ING"
    },
    {
      "name": "Ingegneria chimica e dei materiali",
      "macro": "ING"
    },
    {
      "name": "Ingegneria civile delle acque e dei trasporti",
      "macro": "ING"
    },
    {
      "name": "Ingegneria civile per l'ambiente ed il territorio",
      "macro": "ING"
    },
    {
      "name": "Ingegneria civile per l'idraulica e i trasporti",
      "macro": "ING"
    },
    {
      "name": "Ingegneria civile per la protezione dai rischi naturali",
      "macro": "ING"
    },
    {
      "name": "Ingegneria computazionale e modellistica per materiali, strutture e tecnologie sostenibili",
      "macro": "ING"
    },
    {
      "name": "Ingegneria costiera e marina sostenibile",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dei Materiali",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dei Materiali e Biomateriali",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dei Sistemi Aerospaziali",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dei Sistemi Edilizi",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dei Sistemi Intelligenti",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dei Sistemi Medicali",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dei Sistemi Robotici e Intelligenti",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dei materiali per l'Industria 4.0",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dei sistemi elettronici",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dei sistemi medicali per la persona",
      "macro": "ING"
    },
    {
      "name": "Ingegneria del Cinema e dei Media Digitali",
      "macro": "ING"
    },
    {
      "name": "Ingegneria del Veicolo",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dell'Ambiente per lo Sviluppo Sostenibile",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dell'Automazione",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dell'Automazione Industriale",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dell'Automazione e Robotica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dell'Automazione e dei Sistemi",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dell'Edilizia",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dell'Energia Elettrica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dell'Energia Elettrica per lo Sviluppo Sostenibile",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dell'Energia e delle Fonti Rinnovabili",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dell'Informazione",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dell'Informazione per la Medicina Digitale",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dell'Innovazione Tecnologica e Digitale per l'Ambiente Costruito",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dell'Innovazione del Prodotto",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dell'Innovazione per le Imprese Digitali",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dell'Intelligenza Artificiale e della Sicurezza Informatica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dell'autoveicolo",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dell'energia elettrica e dei sistemi",
      "macro": "ING"
    },
    {
      "name": "Ingegneria della Creatività Digitale",
      "macro": "ING"
    },
    {
      "name": "Ingegneria della Gestione delle Infrastrutture Civili",
      "macro": "ING"
    },
    {
      "name": "Ingegneria della Mobilità Sostenibile",
      "macro": "ING"
    },
    {
      "name": "Ingegneria della Sicurezza e Protezione Civile",
      "macro": "ING"
    },
    {
      "name": "Ingegneria della Sicurezza per il Territorio e il Costruito",
      "macro": "ING"
    },
    {
      "name": "Ingegneria della produzione industriale",
      "macro": "ING"
    },
    {
      "name": "Ingegneria della produzione industriale e dell'innovazione tecnologica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria della sicurezza civile e industriale",
      "macro": "ING"
    },
    {
      "name": "Ingegneria delle Costruzioni Edili",
      "macro": "ING"
    },
    {
      "name": "Ingegneria delle Infrastrutture",
      "macro": "ING"
    },
    {
      "name": "Ingegneria delle Nanotecnologie",
      "macro": "ING"
    },
    {
      "name": "Ingegneria delle Strutture e delle Costruzioni",
      "macro": "ING"
    },
    {
      "name": "Ingegneria delle Tecnologie Aeronautiche e del Trasporto Aereo",
      "macro": "ING"
    },
    {
      "name": "Ingegneria delle Tecnologie Informatiche",
      "macro": "ING"
    },
    {
      "name": "Ingegneria delle Tecnologie dell'Informazione per le Comunicazioni e la Salute",
      "macro": "ING"
    },
    {
      "name": "Ingegneria delle Tecnologie per Internet",
      "macro": "ING"
    },
    {
      "name": "Ingegneria delle Tecnologie per il Mare",
      "macro": "ING"
    },
    {
      "name": "Ingegneria delle Tecnologie per l'Edilizia",
      "macro": "ING"
    },
    {
      "name": "Ingegneria delle Tecnologie per l'Impresa Digitale",
      "macro": "ING"
    },
    {
      "name": "Ingegneria delle Telecomunicazioni",
      "macro": "ING"
    },
    {
      "name": "Ingegneria delle Telecomunicazioni e dei Media Digitali",
      "macro": "ING"
    },
    {
      "name": "Ingegneria delle Telecomunicazioni, Internet e Multimedia",
      "macro": "ING"
    },
    {
      "name": "Ingegneria delle costruzioni",
      "macro": "ING"
    },
    {
      "name": "Ingegneria delle infrastrutture energetiche e della logistica in ambito portuale",
      "macro": "ING"
    },
    {
      "name": "Ingegneria delle infrastrutture viarie e trasporti",
      "macro": "ING"
    },
    {
      "name": "Ingegneria delle tecnologie per l'elettronica e l'automazione",
      "macro": "ING"
    },
    {
      "name": "Ingegneria delle tecnologie per la salute",
      "macro": "ING"
    },
    {
      "name": "Ingegneria delle tecnologie per la sostenibilità energetica e ambientale",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dell’Informazione per Videogame e Realtà Virtuale",
      "macro": "ING"
    },
    {
      "name": "Ingegneria dell’Intelligenza Artificiale",
      "macro": "ING"
    },
    {
      "name": "Ingegneria di Internet",
      "macro": "ING"
    },
    {
      "name": "Ingegneria e Scienze Informatiche",
      "macro": "ING"
    },
    {
      "name": "Ingegneria e Scienze Informatiche per la cybersecurity",
      "macro": "ING"
    },
    {
      "name": "Ingegneria e Tecniche del Costruire",
      "macro": "ING"
    },
    {
      "name": "Ingegneria e Tecnologie Innovative per l'Ambiente",
      "macro": "ING"
    },
    {
      "name": "Ingegneria edile per la sostenibilità",
      "macro": "ING"
    },
    {
      "name": "Ingegneria elettronica e delle telecomunicazioni",
      "macro": "ING"
    },
    {
      "name": "Ingegneria elettronica e telecomunicazioni",
      "macro": "ING"
    },
    {
      "name": "Ingegneria elettronica per l'ICT",
      "macro": "ING"
    },
    {
      "name": "Ingegneria elettronica per l'industria e l'innovazione",
      "macro": "ING"
    },
    {
      "name": "Ingegneria elettronica per l'industria",
      "macro": "ING"
    },
    {
      "name": "Ingegneria fisica e matematica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria gestionale e dell'automazione",
      "macro": "ING"
    },
    {
      "name": "Ingegneria industriale green per lo sviluppo sostenibile",
      "macro": "ING"
    },
    {
      "name": "Ingegneria industriale per l'energia",
      "macro": "ING"
    },
    {
      "name": "Ingegneria informatica e dell'informazione",
      "macro": "ING"
    },
    {
      "name": "Ingegneria informatica, delle comunicazioni ed elettronica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria meccanica e dei materiali",
      "macro": "ING"
    },
    {
      "name": "Ingegneria meccanica per l'energia e l'ambiente",
      "macro": "ING"
    },
    {
      "name": "Ingegneria meccanica per le risorse marine",
      "macro": "ING"
    },
    {
      "name": "Ingegneria per l'Ambiente e il Territorio",
      "macro": "ING"
    },
    {
      "name": "Ingegneria per l'Ambiente e la Sicurezza del Territorio",
      "macro": "ING"
    },
    {
      "name": "Ingegneria per l'Energia e l'Ambiente",
      "macro": "ING"
    },
    {
      "name": "Ingegneria per l'Innovazione dei Materiali e del Prodotto",
      "macro": "ING"
    },
    {
      "name": "Ingegneria per la Sicurezza delle Infrastrutture critiche Industriali e Civili",
      "macro": "ING"
    },
    {
      "name": "Ingegneria per la Sostenibilità Industriale",
      "macro": "ING"
    },
    {
      "name": "Ingegneria per la Tutela dell'Ambiente e del Territorio",
      "macro": "ING"
    },
    {
      "name": "Ingegneria per la Transizione Ecologica",
      "macro": "ING"
    },
    {
      "name": "Ingegneria per la gestione delle costruzioni e della sicurezza",
      "macro": "ING"
    },
    {
      "name": "Ingegneria per la gestione sostenibile dell'ambiente e dell'energia",
      "macro": "ING"
    },
    {
      "name": "Ingegneria per la sicurezza del lavoro e dell'ambiente",
      "macro": "ING"
    },
    {
      "name": "Ingegneria per la sostenibilità e la sicurezza delle costruzioni",
      "macro": "ING"
    },
    {
      "name": "Ingegneria per le Energie Rinnovabili in Ambienti Costieri",
      "macro": "ING"
    },
    {
      "name": "Ingegneria strutturale e geotecnica",
      "macro": "ING"
    },
    {
      "name": "Innovation Management",
      "macro": "ECO"
    },
    {
      "name": "Innovation and International Management",
      "macro": "ECO"
    },
    {
      "name": "Innovation and Management for Culture and Creativity",
      "macro": "ECO"
    },
    {
      "name": "Innovation and Organization of Culture and the Arts",
      "macro": "UMA"
    },
    {
      "name": "Innovation management for sustainable tourism",
      "macro": "ECO"
    },
    {
      "name": "Innovazione Organizzativa, Digitale e Amministrativa della P.A.",
      "macro": "UMA"
    },
    {
      "name": "Innovazione Sociale e Comunicazione",
      "macro": "UMA"
    },
    {
      "name": "Innovazione e servizio sociale",
      "macro": "PSI"
    },
    {
      "name": "Innovazione e sostenibilità nella produzione industriale di alimenti",
      "macro": "SCI"
    },
    {
      "name": "Innovazione sociale",
      "macro": "PSI"
    },
    {
      "name": "Innovazione, Governance e Sostenibilità",
      "macro": "UMA"
    },
    {
      "name": "Innovazioni per le produzioni agrarie mediterranee",
      "macro": "SCI"
    },
    {
      "name": "Integrazione giuridica europea e diritti umani",
      "macro": "GIU"
    },
    {
      "name": "Intelligenza Artificiale",
      "macro": "MAT"
    },
    {
      "name": "Intelligenza Artificiale e Innovazione Digitale",
      "macro": "MAT"
    },
    {
      "name": "Intelligenza Artificiale, Data Science e Big Data",
      "macro": "MAT"
    },
    {
      "name": "Intelligenza Artificiale, impresa e società",
      "macro": "ECO"
    },
    {
      "name": "Intelligenza artificiale e data analytics",
      "macro": "MAT"
    },
    {
      "name": "Intensificazione sostenibile delle produzioni ortofrutticole di qualità",
      "macro": "SCI"
    },
    {
      "name": "Interfacce e tecnologie della comunicazione",
      "macro": "UMA"
    },
    {
      "name": "Intermediari, finanza internazionale e risk management",
      "macro": "ECO"
    },
    {
      "name": "Intermediazione culturale e religiosa",
      "macro": "UMA"
    },
    {
      "name": "International Accounting and Management",
      "macro": "ECO"
    },
    {
      "name": "International Business and Development",
      "macro": "ECO"
    },
    {
      "name": "International Cooperation on Human Rights and Intercultural Heritage",
      "macro": "UMA"
    },
    {
      "name": "International Cybersecurity and Cyberintelligence",
      "macro": "MAT"
    },
    {
      "name": "International Economics and Business",
      "macro": "ECO"
    },
    {
      "name": "International Economics and Commerce",
      "macro": "ECO"
    },
    {
      "name": "International Horticultural Science",
      "macro": "SCI"
    },
    {
      "name": "International Management and Marketing",
      "macro": "ECO"
    },
    {
      "name": "International Marketing, Management and Organization",
      "macro": "ECO"
    },
    {
      "name": "International Medical Doctor Program",
      "macro": "MED"
    },
    {
      "name": "International Politics, Law and Economics",
      "macro": "GIU"
    },
    {
      "name": "International Relations / Relazioni internazionali",
      "macro": "UMA"
    },
    {
      "name": "International Relations, Politics & Trade",
      "macro": "ECO"
    },
    {
      "name": "International Security Studies",
      "macro": "UMA"
    },
    {
      "name": "International Tourism and Destination Management",
      "macro": "ECO"
    },
    {
      "name": "International business and entrepreneurship",
      "macro": "ECO"
    },
    {
      "name": "International politics and economics",
      "macro": "ECO"
    },
    {
      "name": "International studies",
      "macro": "UMA"
    },
    {
      "name": "International, European and Comparative Legal Studies",
      "macro": "GIU"
    },
    {
      "name": "Internet of Things, Big Data, Machine Learning",
      "macro": "PSI"
    },
    {
      "name": "Internet and Multimedia Engineering",
      "macro": "ING"
    },
    {
      "name": "Interpretariato e traduzione in Lingua dei Segni Italiana",
      "macro": "UMA"
    },
    {
      "name": "Interprete di Lingua dei Segni Italiana e di Lingua dei Segni Italiana Tattile",
      "macro": "UMA"
    },
    {
      "name": "Investigazione, criminalità e sicurezza internazionale",
      "macro": "GIU"
    },
    {
      "name": "Istituzioni, Governance and Global Studies",
      "macro": "UMA"
    },
    {
      "name": "Italian Food and Wine",
      "macro": "SCI"
    },
    {
      "name": "Italian medieval and renaissance studies",
      "macro": "UMA"
    },
    {
      "name": "Italiano per l'insegnamento a stranieri",
      "macro": "UMA"
    },
    {
      "name": "Language, society and communication",
      "macro": "UMA"
    },
    {
      "name": "Letteratura, lingua e cultura italiana",
      "macro": "UMA"
    },
    {
      "name": "Letterature moderne, comparate e postcoloniali",
      "macro": "UMA"
    },
    {
      "name": "Lettere",
      "macro": "UMA"
    },
    {
      "name": "Lingua e cultura italiana per stranieri",
      "macro": "UMA"
    },
    {
      "name": "Lingue e culture europee e del resto del mondo",
      "macro": "UMA"
    },
    {
      "name": "Lingue e culture per il turismo",
      "macro": "UMA"
    },
    {
      "name": "Lingue e culture per la comunicazione internazionale",
      "macro": "UMA"
    },
    {
      "name": "Lingue e culture straniere",
      "macro": "UMA"
    },
    {
      "name": "Lingue e letterature moderne",
      "macro": "UMA"
    },
    {
      "name": "Lingue e letterature moderne e traduzione interculturale",
      "macro": "UMA"
    },
    {
      "name": "Lingue e letterature straniere",
      "macro": "UMA"
    },
    {
      "name": "Lingue moderne per la comunicazione e la cooperazione internazionale",
      "macro": "UMA"
    },
    {
      "name": "Lingue per l'interpretariato e la traduzione",
      "macro": "UMA"
    },
    {
      "name": "Lingue per la comunicazione internazionale",
      "macro": "UMA"
    },
    {
      "name": "Lingue per la didattica innovativa e l'interculturalità",
      "macro": "PSI"
    },
    {
      "name": "Lingue per lo sviluppo turistico del territorio",
      "macro": "UMA"
    },
    {
      "name": "Lingue straniere per la comunicazione internazionale",
      "macro": "UMA"
    },
    {
      "name": "Lingue, letterature e comunicazione interculturale",
      "macro": "UMA"
    },
    {
      "name": "Lingue, letterature e filologie euro - americane",
      "macro": "UMA"
    },
    {
      "name": "Linguistica e traduzione",
      "macro": "UMA"
    },
    {
      "name": "LM-13 R - Farmacia e farmacia industriale",
      "macro": "MED"
    },
    {
      "name": "Logica, filosofia delle scienze e metodi della ricerca",
      "macro": "UMA"
    },
    {
      "name": "Language Sciences and Cultural Studies for Special Needs",
      "macro": "UMA"
    },
    {
      "name": "Language Technologies and Digital Humanities",
      "macro": "UMA"
    },
    {
      "name": "Language and Management to China",
      "macro": "ECO"
    },
    {
      "name": "Language and mind: Linguistics and cognitive studies - Mente e linguaggio: linguistica e studi cognitivi",
      "macro": "PSI"
    },
    {
      "name": "Languages for communication in international enterprises and organizations - Lingue per la comunicazione nell'impresa e nelle organizzazioni internazionali",
      "macro": "ECO"
    },
    {
      "name": "Languages, literatures and digital culture",
      "macro": "UMA"
    },
    {
      "name": "Lavoro sociale e Politiche sociali",
      "macro": "PSI"
    },
    {
      "name": "Law and Sustainable Development",
      "macro": "GIU"
    },
    {
      "name": "Legal Studies",
      "macro": "GIU"
    },
    {
      "name": "Law, economics and governance",
      "macro": "ECO"
    },
    {
      "name": "Letteratura Musica Spettacolo",
      "macro": "UMA"
    },
    {
      "name": "Letteratura e Storia dell'Arte",
      "macro": "UMA"
    },
    {
      "name": "Letteratura, Arte, Musica e Spettacolo",
      "macro": "UMA"
    },
    {
      "name": "Letteratura, filologia e linguistica italiana",
      "macro": "UMA"
    },
    {
      "name": "Letterature e Culture Comparate",
      "macro": "UMA"
    },
    {
      "name": "Letterature euroamericane, traduzione e critica letteraria",
      "macro": "UMA"
    },
    {
      "name": "Letterature moderne e spettacolo",
      "macro": "UMA"
    },
    {
      "name": "Letterature, filologie, linguaggi",
      "macro": "UMA"
    },
    {
      "name": "Lettere Classiche",
      "macro": "UMA"
    },
    {
      "name": "Lettere Classiche e Moderne",
      "macro": "UMA"
    },
    {
      "name": "Lettere Moderne",
      "macro": "UMA"
    },
    {
      "name": "Lettere classiche e Storia antica",
      "macro": "UMA"
    },
    {
      "name": "Lettere e Beni Culturali",
      "macro": "UMA"
    },
    {
      "name": "Lettere, Filologia Moderna e Industria Culturale",
      "macro": "UMA"
    },
    {
      "name": "Lettere, arti e archeologia",
      "macro": "UMA"
    },
    {
      "name": "Lifelong well-being and healthy aging",
      "macro": "MED"
    },
    {
      "name": "Lingua e cultura italiana in contesti globali",
      "macro": "UMA"
    },
    {
      "name": "Lingua e Cultura Italiana a Stranieri per l'Accoglienza e l'Internazionalizzazione",
      "macro": "UMA"
    },
    {
      "name": "Lingua e cultura italiana nel mondo digitale",
      "macro": "UMA"
    },
    {
      "name": "Lingua, letteratura, arti italiane in prospettiva internazionale",
      "macro": "UMA"
    },
    {
      "name": "Linguaggi artistici per la formazione",
      "macro": "UMA"
    },
    {
      "name": "Linguaggi della comunicazione e dello spettacolo",
      "macro": "UMA"
    },
    {
      "name": "Linguaggi e competenze per la formazione",
      "macro": "UMA"
    },
    {
      "name": "Linguaggi, cooperazione e diversità",
      "macro": "UMA"
    },
    {
      "name": "Lingue Moderne, Letterature e Traduzione",
      "macro": "UMA"
    },
    {
      "name": "Lingue Straniere Moderne",
      "macro": "UMA"
    },
    {
      "name": "Lingue dell'Asia e dell'Africa mediterranea per l'impresa e la cooperazione internazionale",
      "macro": "ECO"
    },
    {
      "name": "Lingue dell'Asia e dell'Africa per la comunicazione e la cooperazione internazionale",
      "macro": "UMA"
    },
    {
      "name": "Lingue e Civiltà Orientali",
      "macro": "UMA"
    },
    {
      "name": "Lingue e Comunicazione",
      "macro": "UMA"
    },
    {
      "name": "Lingue e Comunicazione Interculturale in area euromediterranea",
      "macro": "UMA"
    },
    {
      "name": "Lingue e Culture Comparate",
      "macro": "UMA"
    },
    {
      "name": "Lingue e Culture Europee",
      "macro": "UMA"
    },
    {
      "name": "Lingue e Culture Moderne",
      "macro": "UMA"
    },
    {
      "name": "Lingue e Culture per la Mediazione linguistica",
      "macro": "UMA"
    },
    {
      "name": "Lingue e Letterature - Studi Interculturali",
      "macro": "UMA"
    },
    {
      "name": "Lingue e Letterature Europee e Americane",
      "macro": "UMA"
    },
    {
      "name": "Lingue e Letterature Straniere per la Mediazione Culturale e la Valorizzazione del Territorio",
      "macro": "UMA"
    },
    {
      "name": "Lingue e Letterature: Interculturalità e Didattica",
      "macro": "PSI"
    },
    {
      "name": "Lingue e civiltà dell'Asia e dell'Africa",
      "macro": "UMA"
    },
    {
      "name": "Lingue e civiltà dell'Asia e dell'Africa mediterranea",
      "macro": "UMA"
    },
    {
      "name": "Lingue e comunicazione interculturale per le istituzioni e le imprese",
      "macro": "ECO"
    },
    {
      "name": "Lingue e comunicazione per l’impresa e il turismo",
      "macro": "UMA"
    },
    {
      "name": "Lingue e culture europee euroamericane ed orientali",
      "macro": "UMA"
    },
    {
      "name": "Lingue e culture per il turismo e il commercio internazionale",
      "macro": "UMA"
    },
    {
      "name": "Lingue e culture per la comunicazione e la cooperazione internazionale",
      "macro": "UMA"
    },
    {
      "name": "Lingue e culture straniere occidentali e orientali",
      "macro": "MED"
    },
    {
      "name": "Lingue e letterature comparate",
      "macro": "UMA"
    },
    {
      "name": "Lingue e letterature europee ed extraeuropee",
      "macro": "UMA"
    },
    {
      "name": "Lingue e letterature europee, americane e postcoloniali",
      "macro": "UMA"
    },
    {
      "name": "Lingue e letterature moderne per l'insegnamento, l'editoria e i media digitali",
      "macro": "UMA"
    },
    {
      "name": "Lingue e letterature moderne per i servizi interculturali, la mediazione linguistica e la cooperazione internazionale",
      "macro": "UMA"
    },
    {
      "name": "Lingue e letterature per il plurilinguismo europeo",
      "macro": "UMA"
    },
    {
      "name": "Lingue e letterature per l'editoria e i media digitali",
      "macro": "UMA"
    },
    {
      "name": "Lingue e letterature per la comunicazione interculturale",
      "macro": "UMA"
    },
    {
      "name": "Lingue e letterature per la didattica e le professioni culturali",
      "macro": "PSI"
    },
    {
      "name": "Lingue e letterature per la formazione, la critica e la traduzione",
      "macro": "UMA"
    },
    {
      "name": "Lingue e letterature straniere moderne",
      "macro": "UMA"
    },
    {
      "name": "Lingue e mediazione linguistico-culturale",
      "macro": "UMA"
    },
    {
      "name": "Lingue e tecnologie per la comunicazione interculturale",
      "macro": "UMA"
    },
    {
      "name": "Lingue e traduzione per i servizi culturali e del territorio",
      "macro": "UMA"
    },
    {
      "name": "Lingue moderne",
      "macro": "UMA"
    },
    {
      "name": "Lingue moderne applicate",
      "macro": "UMA"
    },
    {
      "name": "Lingue moderne e traduzione per le relazioni internazionali",
      "macro": "UMA"
    },
    {
      "name": "Lingue moderne nel turismo e nella cooperazione internazionale",
      "macro": "UMA"
    },
    {
      "name": "Lingue moderne per la comunicazione internazionale",
      "macro": "UMA"
    },
    {
      "name": "Lingue nella Società dell'Informazione",
      "macro": "UMA"
    },
    {
      "name": "Lingue per l'impresa e lo sviluppo",
      "macro": "ECO"
    },
    {
      "name": "Lingue per la comunicazione interculturale e d'impresa",
      "macro": "ECO"
    },
    {
      "name": "Lingue per la cooperazione internazionale",
      "macro": "UMA"
    },
    {
      "name": "Lingue per le professioni nel contesto globale",
      "macro": "UMA"
    },
    {
      "name": "Lingue straniere per l'impresa e la cooperazione internazionale",
      "macro": "ECO"
    },
    {
      "name": "Lingue, Culture, Comunicazione",
      "macro": "UMA"
    },
    {
      "name": "Lingue, Culture, Letterature, Traduzione",
      "macro": "UMA"
    },
    {
      "name": "Lingue, Culture, Turismo",
      "macro": "UMA"
    },
    {
      "name": "Lingue, Letterature Comparate e Traduzione Interculturale",
      "macro": "UMA"
    },
    {
      "name": "Lingue, Letterature e Mediazione culturale",
      "macro": "UMA"
    },
    {
      "name": "Lingue, Letterature straniere e Tecniche della Mediazione Linguistica",
      "macro": "UMA"
    },
    {
      "name": "Lingue, civiltà e scienze del linguaggio",
      "macro": "UMA"
    },
    {
      "name": "Lingue, cultura e comunicazione digitale",
      "macro": "UMA"
    },
    {
      "name": "Lingue, culture e letterature moderne",
      "macro": "UMA"
    },
    {
      "name": "Lingue, culture e letterature moderne europee",
      "macro": "UMA"
    },
    {
      "name": "Lingue, culture e letterature straniere",
      "macro": "UMA"
    },
    {
      "name": "Lingue, culture e traduzione letteraria",
      "macro": "UMA"
    },
    {
      "name": "Lingue, culture e società dell'Asia e dell'Africa mediterranea",
      "macro": "UMA"
    },
    {
      "name": "Lingue, letterature e culture moderne",
      "macro": "UMA"
    },
    {
      "name": "Lingue, letterature e culture dell'Europa e delle Americhe",
      "macro": "UMA"
    },
    {
      "name": "Lingue, letterature e studi interculturali",
      "macro": "UMA"
    },
    {
      "name": "Lingue, letterature straniere e turismo culturale",
      "macro": "UMA"
    },
    {
      "name": "Lingue, mercati e culture dell'Asia e dell'Africa Mediterranea",
      "macro": "ECO"
    },
    {
      "name": "Linguistica",
      "macro": "UMA"
    },
    {
      "name": "Linguistica e didattica dell'italiano nel contesto internazionale",
      "macro": "PSI"
    },
    {
      "name": "Linguistica teorica, applicata e delle lingue moderne",
      "macro": "UMA"
    },
    {
      "name": "Local Development",
      "macro": "ECO"
    },
    {
      "name": "Logica, Filosofia e Storia della Scienza",
      "macro": "UMA"
    },
    {
      "name": "Logopedia",
      "macro": "PSI"
    },
    {
      "name": "Low carbon technologies and sustainable chemistry",
      "macro": "SCI"
    },
    {
      "name": "Management",
      "macro": "ECO"
    },
    {
      "name": "Management dell'informazione e della comunicazione aziendale",
      "macro": "ECO"
    },
    {
      "name": "Management e comunicazione d'impresa",
      "macro": "ECO"
    },
    {
      "name": "Management e controllo dei processi logistici",
      "macro": "ECO"
    },
    {
      "name": "Management e cultura italiana del cibo",
      "macro": "ECO"
    },
    {
      "name": "Management e design dei servizi",
      "macro": "ING"
    },
    {
      "name": "Management engineering - ingegneria gestionale",
      "macro": "ING"
    },
    {
      "name": "Management for business and economics",
      "macro": "ECO"
    },
    {
      "name": "Management, economia e finanza",
      "macro": "ECO"
    },
    {
      "name": "Management, innovazione e finanza",
      "macro": "ECO"
    },
    {
      "name": "Manager e giurista d'impresa",
      "macro": "GIU"
    },
    {
      "name": "Marine biology and aquaculture",
      "macro": "SCI"
    },
    {
      "name": "Marine sciences - scienze marine",
      "macro": "SCI"
    },
    {
      "name": "Marketing e management",
      "macro": "ECO"
    },
    {
      "name": "Marketing e management internazionale",
      "macro": "ECO"
    },
    {
      "name": "Marketing e mercati globali",
      "macro": "ECO"
    },
    {
      "name": "Marketing e organizzazione d'impresa",
      "macro": "ECO"
    },
    {
      "name": "Marketing e ricerche di mercato",
      "macro": "ECO"
    },
    {
      "name": "Marketing, comunicazione aziendale e mercati globali",
      "macro": "ECO"
    },
    {
      "name": "Matematica",
      "macro": "MAT"
    },
    {
      "name": "Materials and nanotechnology",
      "macro": "SCI"
    },
    {
      "name": "Materials science",
      "macro": "SCI"
    },
    {
      "name": "Materials science and nanotechnology",
      "macro": "SCI"
    },
    {
      "name": "Mechanical engineering for sustainability",
      "macro": "ING"
    },
    {
      "name": "Mediazione linguistica e culturale",
      "macro": "UMA"
    },
    {
      "name": "Medicina e chirurgia",
      "macro": "MED"
    },
    {
      "name": "Medicina veterinaria",
      "macro": "MED"
    },
    {
      "name": "Metodologie chimiche per prodotti e processi",
      "macro": "SCI"
    },
    {
      "name": "Monitoraggio ambientale, tutela e ripristino",
      "macro": "SCI"
    },
    {
      "name": "Made in Italy, cibo e ospitalità",
      "macro": "SCI"
    },
    {
      "name": "Management delle Attività Motorie e Sportive",
      "macro": "SCI"
    },
    {
      "name": "Management & Business Analytics",
      "macro": "ECO"
    },
    {
      "name": "Management Digitale",
      "macro": "ECO"
    },
    {
      "name": "Management Engineering for Innovation",
      "macro": "ING"
    },
    {
      "name": "Management Engineering",
      "macro": "ING"
    },
    {
      "name": "Management Pubblico",
      "macro": "ECO"
    },
    {
      "name": "Management and Economics",
      "macro": "ECO"
    },
    {
      "name": "Management and Industrial Systems Engineering",
      "macro": "ING"
    },
    {
      "name": "Management d'impresa",
      "macro": "ECO"
    },
    {
      "name": "Management dei Sistemi Turistici per lo Sviluppo sostenibile",
      "macro": "ECO"
    },
    {
      "name": "Management dei Territori, delle Aziende Pubbliche e del Turismo",
      "macro": "ECO"
    },
    {
      "name": "Management dei beni culturali",
      "macro": "ECO"
    },
    {
      "name": "Management dei servizi educativi e Formazione continua",
      "macro": "PSI"
    },
    {
      "name": "Management del Patrimonio Culturale",
      "macro": "ECO"
    },
    {
      "name": "Management del Turismo",
      "macro": "ECO"
    },
    {
      "name": "Management del Turismo e della Sostenibilità",
      "macro": "ECO"
    },
    {
      "name": "Management del Turismo, dello Sport e degli Eventi",
      "macro": "ECO"
    },
    {
      "name": "Management dell'economia sociale",
      "macro": "ECO"
    },
    {
      "name": "Management della Moda, dell'Arte e del Cibo",
      "macro": "ECO"
    },
    {
      "name": "Management della Pubblica Amministrazione",
      "macro": "ECO"
    },
    {
      "name": "Management della Transizione Digitale",
      "macro": "ECO"
    },
    {
      "name": "Management delle Aziende Sanitarie e del Settore Salute",
      "macro": "MED"
    },
    {
      "name": "Management delle Organizzazioni e del Lavoro",
      "macro": "ECO"
    },
    {
      "name": "Management delle attività sportive e motorie per il benessere sociale",
      "macro": "SCI"
    },
    {
      "name": "Management delle attività sportive innovative e sostenibili",
      "macro": "ECO"
    },
    {
      "name": "Management delle destinazioni e del turismo culturale",
      "macro": "UMA"
    },
    {
      "name": "Management delle imprese internazionali",
      "macro": "ECO"
    },
    {
      "name": "Management delle imprese",
      "macro": "ECO"
    },
    {
      "name": "Management delle imprese per l'economia sostenibile",
      "macro": "ECO"
    },
    {
      "name": "Management delle imprese turistiche",
      "macro": "ECO"
    },
    {
      "name": "Management delle organizzazioni turistiche",
      "macro": "ECO"
    },
    {
      "name": "Management delle scienze gastronomiche per il benessere",
      "macro": "ECO"
    },
    {
      "name": "Management delle sostenibilità e del turismo",
      "macro": "ECO"
    },
    {
      "name": "Management delle tecnologie, innovazione e sostenibilità",
      "macro": "ECO"
    },
    {
      "name": "Management dello Sport",
      "macro": "ECO"
    },
    {
      "name": "Management dello Sport e delle Attività Motorie",
      "macro": "SCI"
    },
    {
      "name": "Management e Governance",
      "macro": "ECO"
    },
    {
      "name": "Management e Marketing",
      "macro": "ECO"
    },
    {
      "name": "Management e consulenza aziendale",
      "macro": "ECO"
    },
    {
      "name": "Management e diritto d'impresa",
      "macro": "GIU"
    },
    {
      "name": "Management e marketing internazionale",
      "macro": "ECO"
    },
    {
      "name": "Management e politiche delle amministrazioni pubbliche",
      "macro": "ECO"
    },
    {
      "name": "Management e sostenibilità",
      "macro": "ECO"
    },
    {
      "name": "Management e strategia d'impresa",
      "macro": "ECO"
    },
    {
      "name": "Management for Energy and Environmental Transition",
      "macro": "ECO"
    },
    {
      "name": "Management for Sustainable Firms",
      "macro": "ECO"
    },
    {
      "name": "Management of Human Resources",
      "macro": "ECO"
    },
    {
      "name": "Management of innovation and entrepreneurship",
      "macro": "ECO"
    },
    {
      "name": "Management per la valorizzazione sostenibile delle aziende e delle risorse ittiche",
      "macro": "ECO"
    },
    {
      "name": "Management pubblico e dei sistemi socio-sanitari",
      "macro": "MED"
    },
    {
      "name": "Management, Controllo e Finanza con IA",
      "macro": "ECO"
    },
    {
      "name": "Management, Finance and Data Analytics",
      "macro": "ECO"
    },
    {
      "name": "Manager degli Itinerari Culturali",
      "macro": "UMA"
    },
    {
      "name": "Marine Biology",
      "macro": "SCI"
    },
    {
      "name": "Marine Biology and Blue Biotechnologies",
      "macro": "SCI"
    },
    {
      "name": "Marine Biology and Ecology",
      "macro": "SCI"
    },
    {
      "name": "Maritime Science and Technology",
      "macro": "ING"
    },
    {
      "name": "Marketing & Digital Communication",
      "macro": "ECO"
    },
    {
      "name": "Marketing Digitale",
      "macro": "ECO"
    },
    {
      "name": "Marketing Management",
      "macro": "ECO"
    },
    {
      "name": "Marketing e Comunicazione d'Impresa",
      "macro": "ECO"
    },
    {
      "name": "Marketing e qualità",
      "macro": "ECO"
    },
    {
      "name": "Marketing e Comunicazione d'azienda",
      "macro": "ECO"
    },
    {
      "name": "Marketing per il Made in Italy",
      "macro": "ECO"
    },
    {
      "name": "Marketing, consumi e comunicazione",
      "macro": "ECO"
    },
    {
      "name": "Matematica Pura e Applicata",
      "macro": "MAT"
    },
    {
      "name": "Matematica applicata",
      "macro": "MAT"
    },
    {
      "name": "Matematica e Applicazioni",
      "macro": "MAT"
    },
    {
      "name": "Matematica per l'Economia, la Finanza e l'Assicurazione",
      "macro": "ECO"
    },
    {
      "name": "Matematica per l'ingegneria",
      "macro": "ING"
    },
    {
      "name": "Materials Engineering",
      "macro": "ING"
    },
    {
      "name": "Materials Science and Technology",
      "macro": "SCI"
    },
    {
      "name": "Materials and chemical engineering for nano, bio, and sustainable technologies",
      "macro": "ING"
    },
    {
      "name": "Mathematical Engineering",
      "macro": "ING"
    },
    {
      "name": "Mathematical Modelling",
      "macro": "MAT"
    },
    {
      "name": "Meccatronica",
      "macro": "ING"
    },
    {
      "name": "Mechanical Engineering",
      "macro": "ING"
    },
    {
      "name": "Mechanical Engineering for Product Innovation",
      "macro": "ING"
    },
    {
      "name": "Mechatronic Engineering",
      "macro": "ING"
    },
    {
      "name": "Mechatronics and Smart Technology Engineering",
      "macro": "ING"
    },
    {
      "name": "Media Education per le Discipline letterarie e l'Editoria",
      "macro": "PSI"
    },
    {
      "name": "Media e Società digitale",
      "macro": "UMA"
    },
    {
      "name": "Media e industrie culturali",
      "macro": "UMA"
    },
    {
      "name": "Media, Arti, Culture e Spettacolo",
      "macro": "UMA"
    },
    {
      "name": "Media, Comunicazione e Società",
      "macro": "UMA"
    },
    {
      "name": "Media, comunicazione digitale e giornalismo",
      "macro": "UMA"
    },
    {
      "name": "Mediazione Culturale",
      "macro": "UMA"
    },
    {
      "name": "Mediazione Linguistica",
      "macro": "UMA"
    },
    {
      "name": "Mediazione linguistica e comunicazione interculturale",
      "macro": "UMA"
    },
    {
      "name": "Mediazione linguistica e culturale applicata all'ambito economico, giuridico e sociale",
      "macro": "GIU"
    },
    {
      "name": "Mediazione linguistica e interculturale",
      "macro": "UMA"
    },
    {
      "name": "Mediazione linguistica per l'impresa internazionale e i media digitali",
      "macro": "ECO"
    },
    {
      "name": "Mediazione, interpretariato e comunicazione interculturale",
      "macro": "UMA"
    },
    {
      "name": "Medical Biotechnologies",
      "macro": "MED"
    },
    {
      "name": "Medical Biotechnology and Molecular Medicine - Biotecnologie mediche e medicina molecolare",
      "macro": "MED"
    },
    {
      "name": "Medical Engineering",
      "macro": "ING"
    },
    {
      "name": "Medical and Pharmaceutical Biotechnologies",
      "macro": "MED"
    },
    {
      "name": "Medical bioinformatics",
      "macro": "SCI"
    },
    {
      "name": "Medical-Pharmaceutical Biotechnology",
      "macro": "MED"
    },
    {
      "name": "Medicina delle Piante",
      "macro": "SCI"
    },
    {
      "name": "Medicina e Chirurgia ad indirizzo tecnologico",
      "macro": "MED"
    },
    {
      "name": "Medicina e Chirurgia a Indirizzo Biotecnologico",
      "macro": "MED"
    },
    {
      "name": "Medicine and Surgery",
      "macro": "MED"
    },
    {
      "name": "Mediterranean Archaeology",
      "macro": "UMA"
    },
    {
      "name": "Mediterranean Food Science and Technology",
      "macro": "SCI"
    },
    {
      "name": "MedTech",
      "macro": "MED"
    },
    {
      "name": "Metodi Quantitativi per l'Economia e la Finanza",
      "macro": "ECO"
    },
    {
      "name": "Metodi Quantitativi per le Valutazioni Economiche e Finanziarie",
      "macro": "ECO"
    },
    {
      "name": "Metodi Statistici e Data Analytics",
      "macro": "MAT"
    },
    {
      "name": "Metodi Statistici ed Economici per le Decisioni",
      "macro": "ECO"
    },
    {
      "name": "Metodi e Modelli per Data Science",
      "macro": "MAT"
    },
    {
      "name": "Metodi e tecnologie per il patrimonio culturale",
      "macro": "UMA"
    },
    {
      "name": "Metodi e tecnologie per la storia dell'arte",
      "macro": "UMA"
    },
    {
      "name": "Metodologia, organizzazione e valutazione dei servizi sociali",
      "macro": "PSI"
    },
    {
      "name": "Metodologie e innovazione didattica per le biogeoscienze e per la chimica",
      "macro": "PSI"
    },
    {
      "name": "Metodologie filosofiche",
      "macro": "UMA"
    },
    {
      "name": "Metodologie per la Conservazione e il restauro dei beni culturali",
      "macro": "UMA"
    },
    {
      "name": "Metodologie per prodotto e processo",
      "macro": "ING"
    },
    {
      "name": "Migration Studies and New Societies",
      "macro": "UMA"
    },
    {
      "name": "Migration, Rights, Integration",
      "macro": "UMA"
    },
    {
      "name": "Moda",
      "macro": "UMA"
    },
    {
      "name": "Mobilità sostenibile e connessioni intelligenti in ambienti marini e costieri",
      "macro": "SCI"
    },
    {
      "name": "Moda e cultura d'impresa",
      "macro": "ECO"
    },
    {
      "name": "Moda e industrie creative",
      "macro": "UMA"
    },
    {
      "name": "Molecular Biology",
      "macro": "SCI"
    },
    {
      "name": "Molecular Biology and Genetics",
      "macro": "SCI"
    },
    {
      "name": "Molecular Biology of the Cell - Biologia molecolare della cellula",
      "macro": "SCI"
    },
    {
      "name": "Molecular Biology, Medicinal Chemistry and Computer Science for Pharmaceutical Applications",
      "macro": "MED"
    },
    {
      "name": "Molecular Biotechnology",
      "macro": "SCI"
    },
    {
      "name": "Molecular and Cell Biology",
      "macro": "SCI"
    },
    {
      "name": "Molecular and medical biotechnology",
      "macro": "MED"
    },
    {
      "name": "Molecular biotechnology and Bioinformatics - Biotecnologie molecolari e bioinformatica",
      "macro": "SCI"
    },
    {
      "name": "Monitoraggio e Riqualificazione Ambientale",
      "macro": "SCI"
    },
    {
      "name": "Musica e Spettacolo",
      "macro": "UMA"
    },
    {
      "name": "Musica, Culture, Media, Performance",
      "macro": "UMA"
    },
    {
      "name": "Musicologia",
      "macro": "UMA"
    },
    {
      "name": "Musicologia e Scienze dello spettacolo",
      "macro": "UMA"
    },
    {
      "name": "Neuroscience",
      "macro": "PSI"
    },
    {
      "name": "Nuclear engineering",
      "macro": "ING"
    },
    {
      "name": "Nanotechnologies for ICTs",
      "macro": "SCI"
    },
    {
      "name": "Nanotechnology and physics for sustainability",
      "macro": "MAT"
    },
    {
      "name": "Neurobiologia",
      "macro": "SCI"
    },
    {
      "name": "Neuropsicobiologia",
      "macro": "PSI"
    },
    {
      "name": "Neuropsicologia clinica e sperimentale",
      "macro": "PSI"
    },
    {
      "name": "Neuropsicologia e neuroscienze cognitive",
      "macro": "PSI"
    },
    {
      "name": "Neuroscienze Cognitive e Riabilitazione Psicologica",
      "macro": "PSI"
    },
    {
      "name": "Neuroscienze e riabilitazione neuropsicologica",
      "macro": "PSI"
    },
    {
      "name": "Nuovi turismi",
      "macro": "ECO"
    },
    {
      "name": "Nutrizione e biosicurezza degli alimenti",
      "macro": "SCI"
    },
    {
      "name": "Nutrizione umana, benessere e salute",
      "macro": "SCI"
    },
    {
      "name": "Odontoiatria e protesi dentaria",
      "macro": "MED"
    },
    {
      "name": "Optometry and vision science",
      "macro": "MED"
    },
    {
      "name": "Ortottica ed assistenza oftalmologica (abilitante alla professione sanitaria di ortottista ed assistente di oftalmologia)",
      "macro": "MED"
    },
    {
      "name": "Odontoiatria LM-46",
      "macro": "MED"
    },
    {
      "name": "Offshore Engineering for Energy Transition",
      "macro": "ING"
    },
    {
      "name": "Operatore Giuridico d'Impresa",
      "macro": "GIU"
    },
    {
      "name": "Operatore dei Beni Culturali",
      "macro": "UMA"
    },
    {
      "name": "Organizzazione delle amministrazioni pubbliche e private",
      "macro": "UMA"
    },
    {
      "name": "Organizzazione e Gestione delle Risorse Umane",
      "macro": "ECO"
    },
    {
      "name": "Organizzazione e gestione dei servizi per lo sport e le attività motorie",
      "macro": "SCI"
    },
    {
      "name": "Organizzazione e marketing per la comunicazione d'impresa",
      "macro": "ECO"
    },
    {
      "name": "Organizzazione, società e tecnologia",
      "macro": "PSI"
    },
    {
      "name": "Organizzazione, valutazione e supervisione dei servizi sociali",
      "macro": "PSI"
    },
    {
      "name": "Ortottica ed assistenza oftalmologica",
      "macro": "MED"
    },
    {
      "name": "Osteopatia",
      "macro": "MED"
    },
    {
      "name": "Ostetricia",
      "macro": "MED"
    },
    {
      "name": "Ottica e Optometria",
      "macro": "MED"
    },
    {
      "name": "Patrimonio e turismo culturale",
      "macro": "UMA"
    },
    {
      "name": "Pedagogia",
      "macro": "PSI"
    },
    {
      "name": "Physical sciences for innovative technologies",
      "macro": "MAT"
    },
    {
      "name": "PIANIFICAZIONE DELLA CITTà, DEL TERRITORIO E DEL PAESAGGIO",
      "macro": "ING"
    },
    {
      "name": "Planet life design",
      "macro": "ING"
    },
    {
      "name": "Politica, amministrazione e organizzazione",
      "macro": "UMA"
    },
    {
      "name": "Produzione multimediale",
      "macro": "UMA"
    },
    {
      "name": "Progettazione di servizi sociali e interventi educativi",
      "macro": "PSI"
    },
    {
      "name": "Progettazione e gestione dei sistemi turistici e degli eventi",
      "macro": "ECO"
    },
    {
      "name": "Progettazione e gestione del verde urbano e del paesaggio",
      "macro": "ING"
    },
    {
      "name": "Progettazione e gestione dell'intervento educativo nel disagio sociale",
      "macro": "PSI"
    },
    {
      "name": "Psicologia",
      "macro": "PSI"
    },
    {
      "name": "Psicologia clinica",
      "macro": "PSI"
    },
    {
      "name": "Psicologia clinica e della salute",
      "macro": "PSI"
    },
    {
      "name": "Psicologia clinica e della salute e neuropsicologia",
      "macro": "PSI"
    },
    {
      "name": "Psicologia clinica e scienze comportamentali",
      "macro": "PSI"
    },
    {
      "name": "Psicologia dei processi di apprendimento e di inclusione",
      "macro": "PSI"
    },
    {
      "name": "Psicologia del ciclo di vita e dei contesti",
      "macro": "PSI"
    },
    {
      "name": "Psicologia del lavoro e dell'organizzazione",
      "macro": "PSI"
    },
    {
      "name": "Psicologia per lo sport e l'attivita' motoria",
      "macro": "SCI"
    },
    {
      "name": "Psicologia scolastica",
      "macro": "PSI"
    },
    {
      "name": "PUBBLICITà, COMUNICAZIONE DIGITALE E CREATIVITà D'IMPRESA",
      "macro": "ECO"
    },
    {
      "name": "Paesaggio, Innovazione e Sostenibilità",
      "macro": "ING"
    },
    {
      "name": "Paesaggio, ambiente e verde urbano",
      "macro": "ING"
    },
    {
      "name": "Patrimonio Culturale, Storia delle Arti e Museologia",
      "macro": "UMA"
    },
    {
      "name": "Patrimonio culturale, territorio, turismo sostenibile",
      "macro": "UMA"
    },
    {
      "name": "Patrimonio digitale. Musei, Archivi, Biblioteche",
      "macro": "UMA"
    },
    {
      "name": "Pedagogia e progettazione socio-educativa",
      "macro": "PSI"
    },
    {
      "name": "Pharmaceutical Biotechnologies - Biotecnologie farmaceutiche",
      "macro": "SCI"
    },
    {
      "name": "Pharmacy",
      "macro": "MED"
    },
    {
      "name": "Philosophical Knowledge: Foundations, Methods, Applications",
      "macro": "UMA"
    },
    {
      "name": "Philosophy, International and Economic Studies",
      "macro": "ECO"
    },
    {
      "name": "Photochemistry and molecular materials",
      "macro": "SCI"
    },
    {
      "name": "Physical and Astrophysical Sciences",
      "macro": "MAT"
    },
    {
      "name": "Physics",
      "macro": "MAT"
    },
    {
      "name": "Physics of Complex Systems",
      "macro": "MAT"
    },
    {
      "name": "Physics of Data",
      "macro": "MAT"
    },
    {
      "name": "Pianificazione e gestione del territorio e del verde",
      "macro": "ING"
    },
    {
      "name": "Pianificazione e politiche per la città, l'ambiente e il paesaggio",
      "macro": "ING"
    },
    {
      "name": "Pianificazione e progettazione per la sostenibilità urbana e territoriale",
      "macro": "ING"
    },
    {
      "name": "Pianificazione territoriale, urbanistica e paesaggistico-ambientale",
      "macro": "ING"
    },
    {
      "name": "Pianificazione urbanistica e territoriale",
      "macro": "ING"
    },
    {
      "name": "Planetary Sciences",
      "macro": "SCI"
    },
    {
      "name": "Planning and Management of Tourism Systems",
      "macro": "ECO"
    },
    {
      "name": "Plant Biotechnology for Food and Global Health",
      "macro": "MED"
    },
    {
      "name": "Plant Science - Biologia Vegetale",
      "macro": "SCI"
    },
    {
      "name": "Pluralismo culturale, mutamento sociale e migrazioni",
      "macro": "UMA"
    },
    {
      "name": "Plurilinguismo, traduzione e interpretazione",
      "macro": "UMA"
    },
    {
      "name": "Podologia",
      "macro": "MED"
    },
    {
      "name": "Politica Società Economia Internzionali",
      "macro": "ECO"
    },
    {
      "name": "Politica, Istituzioni e Mercato",
      "macro": "UMA"
    },
    {
      "name": "Politiche Territoriali e Cooperazione Internazionale",
      "macro": "UMA"
    },
    {
      "name": "Politiche e Servizi Sociali",
      "macro": "PSI"
    },
    {
      "name": "Politiche e management per il welfare",
      "macro": "PSI"
    },
    {
      "name": "Politiche e programmazione dei servizi alla persona",
      "macro": "UMA"
    },
    {
      "name": "Politiche internazionali e della sostenibilità",
      "macro": "UMA"
    },
    {
      "name": "Politiche per la Sicurezza Globale: Ambiente, Energia e Conflitti",
      "macro": "SCI"
    },
    {
      "name": "Politiche sociali e servizio sociale",
      "macro": "PSI"
    },
    {
      "name": "Politiche per la sostenibilità e l'innovazione digitale",
      "macro": "UMA"
    },
    {
      "name": "Politiche pubbliche e Governance innovativa",
      "macro": "UMA"
    },
    {
      "name": "Politiche sociali, sistemi di welfare e terzo settore",
      "macro": "PSI"
    },
    {
      "name": "Politiche, Amministrazioni e Innovazione",
      "macro": "UMA"
    },
    {
      "name": "Politiche, cooperazione e sviluppo",
      "macro": "UMA"
    },
    {
      "name": "Politiche, governance e informazione dello Sport",
      "macro": "SCI"
    },
    {
      "name": "Politics, Philosophy and Public Affairs",
      "macro": "UMA"
    },
    {
      "name": "Pratiche, linguaggi e culture della comunicazione",
      "macro": "UMA"
    },
    {
      "name": "Precise and sustainable agriculture",
      "macro": "SCI"
    },
    {
      "name": "Product and Service Design",
      "macro": "ING"
    },
    {
      "name": "Precision Livestock Farming",
      "macro": "SCI"
    },
    {
      "name": "Product, Interior, Communication and Eco-social Design",
      "macro": "ING"
    },
    {
      "name": "Produzione e protezione delle piante e dei sistemi del verde",
      "macro": "SCI"
    },
    {
      "name": "Produzione sementiera e vivaismo",
      "macro": "SCI"
    },
    {
      "name": "Produzioni Animali Innovative e Sostenibili",
      "macro": "SCI"
    },
    {
      "name": "Produzioni animali",
      "macro": "SCI"
    },
    {
      "name": "Produzioni biologiche vegetali",
      "macro": "SCI"
    },
    {
      "name": "Professioni Tecniche per l'Edilizia e il Territorio",
      "macro": "ING"
    },
    {
      "name": "Progettazione Sociale per la sostenibilità, l'innovazione e l'inclusione di genere",
      "macro": "PSI"
    },
    {
      "name": "Progettazione del Turismo sostenibile, culturale e naturalistico",
      "macro": "UMA"
    },
    {
      "name": "Progettazione del paesaggio e del territorio",
      "macro": "ING"
    },
    {
      "name": "Progettazione di contesti di vita accessibili ed inclusivi",
      "macro": "PSI"
    },
    {
      "name": "Progettazione e Coordinamento dei Servizi Educativi",
      "macro": "PSI"
    },
    {
      "name": "Progettazione e Gestione dei Sistemi Turistici",
      "macro": "ECO"
    },
    {
      "name": "Progettazione e Gestione dei Sistemi Turistici Patrimoniali",
      "macro": "ECO"
    },
    {
      "name": "Progettazione e Gestione del turismo culturale",
      "macro": "UMA"
    },
    {
      "name": "Progettazione e Gestione di eventi e imprese dell'Arte e dello Spettacolo",
      "macro": "ECO"
    },
    {
      "name": "Progettazione e Management dei sistemi turistici e culturali",
      "macro": "UMA"
    },
    {
      "name": "Progettazione e gestione dei servizi socio-educativi, formativi e per la media education",
      "macro": "PSI"
    },
    {
      "name": "Progettazione e gestione del territorio forestale, del paesaggio e dell'ambiente",
      "macro": "ING"
    },
    {
      "name": "Progettazione e management del turismo",
      "macro": "ECO"
    },
    {
      "name": "Progettazione gestione e valutazione dei servizi sociali",
      "macro": "PSI"
    },
    {
      "name": "Progettazione pedagogica e gestione dei servizi educativi per i minori",
      "macro": "PSI"
    },
    {
      "name": "Progettazione, Gestione e Promozione Turistica di Itinerari della Cultura e dell'Ambiente",
      "macro": "UMA"
    },
    {
      "name": "Progettazione, innovazione e gestione delle destinazioni turistiche",
      "macro": "ECO"
    },
    {
      "name": "Programmazione e Gestione dei Servizi Sociali",
      "macro": "PSI"
    },
    {
      "name": "Programmazione e gestione dei servizi educativi e formativi",
      "macro": "PSI"
    },
    {
      "name": "Programmazione e gestione delle politiche e dei servizi sociali",
      "macro": "PSI"
    },
    {
      "name": "Programmazione, amministrazione e gestione delle politiche e dei servizi sociali",
      "macro": "PSI"
    },
    {
      "name": "Programmazione e gestione di sistemi informatici",
      "macro": "MAT"
    },
    {
      "name": "Promozione e Gestione del Patrimonio Territoriale e delle Destinazioni Turistiche",
      "macro": "UMA"
    },
    {
      "name": "Psicobiologia e Neuroscienze Cognitive",
      "macro": "PSI"
    },
    {
      "name": "Psicologia Clinica dello Sviluppo",
      "macro": "PSI"
    },
    {
      "name": "Psicologia Clinica, della Salute, Giuridica e Forense",
      "macro": "PSI"
    },
    {
      "name": "Psicologia Clinica, dello Sviluppo e Neuropsicologia",
      "macro": "PSI"
    },
    {
      "name": "Psicologia Clinico-Dinamica",
      "macro": "PSI"
    },
    {
      "name": "Psicologia Cognitiva e Neuroscienze",
      "macro": "PSI"
    },
    {
      "name": "Psicologia Comportamentale e Cognitiva Applicata",
      "macro": "PSI"
    },
    {
      "name": "Psicologia Forense e Criminologia Clinica",
      "macro": "PSI"
    },
    {
      "name": "Psicologia Generale, dello Sviluppo, del Genere e del Comportamento Sociale",
      "macro": "PSI"
    },
    {
      "name": "Psicologia Giuridica e Criminologica",
      "macro": "PSI"
    },
    {
      "name": "Psicologia clinica e degli interventi nei contesti sociali e dello sviluppo",
      "macro": "PSI"
    },
    {
      "name": "Psicologia clinica e della salute nel ciclo di vita",
      "macro": "PSI"
    },
    {
      "name": "Psicologia clinica e della salute per i contesti sanitari",
      "macro": "PSI"
    },
    {
      "name": "Psicologia clinica, applicata e degli interventi",
      "macro": "PSI"
    },
    {
      "name": "Psicologia cognitiva applicata",
      "macro": "PSI"
    },
    {
      "name": "Psicologia criminologica e forense",
      "macro": "PSI"
    },
    {
      "name": "Psicologia dei Processi Cognitivi",
      "macro": "PSI"
    },
    {
      "name": "Psicologia del ciclo di vita",
      "macro": "PSI"
    },
    {
      "name": "Psicologia dell'Intervento Clinico e Sociale",
      "macro": "PSI"
    },
    {
      "name": "Psicologia dell'intervento nei contesti clinici, sportivi e formativi",
      "macro": "PSI"
    },
    {
      "name": "Psicologia dell'intervento nei contesti relazionali e sociali",
      "macro": "PSI"
    },
    {
      "name": "Psicologia della Comunicazione e del Marketing",
      "macro": "PSI"
    },
    {
      "name": "Psicologia delle risorse umane, del lavoro e delle organizzazioni",
      "macro": "PSI"
    },
    {
      "name": "Psicologia dello sviluppo e dei processi educativi",
      "macro": "PSI"
    },
    {
      "name": "Psicologia dello sviluppo e dell'educazione",
      "macro": "PSI"
    },
    {
      "name": "Psicologia dello sviluppo tipico e atipico",
      "macro": "PSI"
    },
    {
      "name": "Psicologia di comunità, della promozione del benessere e del cambiamento sociale",
      "macro": "PSI"
    },
    {
      "name": "Psicologia e Neuroscienze Cognitive",
      "macro": "PSI"
    },
    {
      "name": "Psicologia e Salute",
      "macro": "PSI"
    },
    {
      "name": "Psicologia e Salute Mentale nel Ciclo di Vita",
      "macro": "PSI"
    },
    {
      "name": "Psicologia e processi sociali",
      "macro": "PSI"
    },
    {
      "name": "Psicologia forense e Criminologica",
      "macro": "PSI"
    },
    {
      "name": "Psicologia giuridica, forense e criminologica",
      "macro": "PSI"
    },
    {
      "name": "Psicologia in Sanità",
      "macro": "PSI"
    },
    {
      "name": "Psicologia per la formazione",
      "macro": "PSI"
    },
    {
      "name": "Psicologia scolastica e di comunità",
      "macro": "PSI"
    },
    {
      "name": "Psicologia sociale e cognitiva applicata",
      "macro": "PSI"
    },
    {
      "name": "Psicologia sociale, del lavoro e della comunicazione",
      "macro": "PSI"
    },
    {
      "name": "Psicologia sociale, del lavoro e delle organizzazioni",
      "macro": "PSI"
    },
    {
      "name": "Psicologia sociale, economica e delle decisioni",
      "macro": "PSI"
    },
    {
      "name": "Psicologia sociale, forense e delle organizzazioni",
      "macro": "PSI"
    },
    {
      "name": "Psicologia: risorse umane, ergonomia cognitiva, neuroscienze cognitive",
      "macro": "PSI"
    },
    {
      "name": "Psicopatologia dinamica e relazione clinica nell'età evolutiva e nell'adulto",
      "macro": "PSI"
    },
    {
      "name": "Psychological Science",
      "macro": "PSI"
    },
    {
      "name": "Psychology of well-being and performance",
      "macro": "PSI"
    },
    {
      "name": "Psychology of wellbeing and social inclusivity",
      "macro": "PSI"
    },
    {
      "name": "Psychology, Neuroscience and Human Sciences",
      "macro": "PSI"
    },
    {
      "name": "Public and Cultural Diplomacy",
      "macro": "UMA"
    },
    {
      "name": "Public and Health Economics",
      "macro": "ECO"
    },
    {
      "name": "Quantitative finance and data science for economics",
      "macro": "ECO"
    },
    {
      "name": "Quantitative finance and insurance - finanza quantitativa e assicurazioni",
      "macro": "ECO"
    },
    {
      "name": "Qualità e Approvvigionamento di Materie Prime per l'Agro-Alimentare",
      "macro": "SCI"
    },
    {
      "name": "Qualità e sicurezza dei prodotti alimentari",
      "macro": "SCI"
    },
    {
      "name": "Quantitative Finance",
      "macro": "ECO"
    },
    {
      "name": "Quantitative and Computational Biology",
      "macro": "MAT"
    },
    {
      "name": "Quantitative and Computational Biosciences",
      "macro": "MAT"
    },
    {
      "name": "Quantitative biology",
      "macro": "SCI"
    },
    {
      "name": "Quantum Engineering",
      "macro": "ING"
    },
    {
      "name": "Quantum Science and Engineering",
      "macro": "ING"
    },
    {
      "name": "Quaternario, preistoria e archeologia",
      "macro": "UMA"
    },
    {
      "name": "Relazioni internazionali e studi europei",
      "macro": "UMA"
    },
    {
      "name": "Religioni storie culture",
      "macro": "UMA"
    },
    {
      "name": "Ricerca, innovazione sociale e politiche di inclusione",
      "macro": "UMA"
    },
    {
      "name": "Relazioni Economiche e Finanziarie Internazionali",
      "macro": "ECO"
    },
    {
      "name": "Relazioni Internazionali",
      "macro": "UMA"
    },
    {
      "name": "Relazioni Internazionali e Cooperazione allo Sviluppo",
      "macro": "UMA"
    },
    {
      "name": "Relazioni Internazionali e Diplomazia",
      "macro": "UMA"
    },
    {
      "name": "Relazioni Internazionali e Istituzioni Sovranazionali",
      "macro": "UMA"
    },
    {
      "name": "Relazioni di lavoro",
      "macro": "ECO"
    },
    {
      "name": "Relazioni e Organizzazioni Internazionali",
      "macro": "UMA"
    },
    {
      "name": "Relazioni e istituzioni dell'Asia e dell'Africa",
      "macro": "UMA"
    },
    {
      "name": "Relazioni internazionali comparate",
      "macro": "UMA"
    },
    {
      "name": "Relazioni internazionali, studi sull'Integrazione europea e per la sostenibilità",
      "macro": "UMA"
    },
    {
      "name": "Relazioni pubbliche",
      "macro": "UMA"
    },
    {
      "name": "Religioni e culture",
      "macro": "UMA"
    },
    {
      "name": "Religioni, Culture, Storia",
      "macro": "UMA"
    },
    {
      "name": "Reproductive Biotechnologies",
      "macro": "SCI"
    },
    {
      "name": "Resource economics and sustainable development",
      "macro": "ECO"
    },
    {
      "name": "Ricerca Biotecnologica in Medicina",
      "macro": "MED"
    },
    {
      "name": "Ricerca Sociale, Politiche della Sicurezza e Criminalità",
      "macro": "UMA"
    },
    {
      "name": "Risorse e pericolosità geologiche del territorio",
      "macro": "SCI"
    },
    {
      "name": "Risorse umane, scienze del lavoro e innovazione",
      "macro": "ECO"
    },
    {
      "name": "Robotics Engineering",
      "macro": "ING"
    },
    {
      "name": "Robotics and Automation Engineering",
      "macro": "ING"
    },
    {
      "name": "Robotics, Automation and Electrical Engineering",
      "macro": "ING"
    },
    {
      "name": "Science of climate",
      "macro": "SCI"
    },
    {
      "name": "Scientific and data-intensive computing",
      "macro": "MAT"
    },
    {
      "name": "Scienza dei materiali",
      "macro": "SCI"
    },
    {
      "name": "Scienza e nanotecnologia dei materiali",
      "macro": "SCI"
    },
    {
      "name": "Scienza e tecnica dello sport",
      "macro": "SCI"
    },
    {
      "name": "Scienze agrarie",
      "macro": "SCI"
    },
    {
      "name": "Scienze agrarie e ambientali",
      "macro": "SCI"
    },
    {
      "name": "Scienze ambientali",
      "macro": "SCI"
    },
    {
      "name": "Scienze biologiche",
      "macro": "SCI"
    },
    {
      "name": "Scienze biosanitarie",
      "macro": "MED"
    },
    {
      "name": "Scienze biotecnologiche, degli alimenti e della nutrizione umana",
      "macro": "SCI"
    },
    {
      "name": "Scienze chimiche",
      "macro": "SCI"
    },
    {
      "name": "Scienze degli alimenti",
      "macro": "SCI"
    },
    {
      "name": "Scienze dei beni culturali",
      "macro": "UMA"
    },
    {
      "name": "Scienze dei beni culturali. turismo, arte, archeologia",
      "macro": "UMA"
    },
    {
      "name": "Scienze dei prodotti erboristici e della salute",
      "macro": "SCI"
    },
    {
      "name": "Scienze dei servizi giuridici",
      "macro": "GIU"
    },
    {
      "name": "Scienze dei sistemi aerospaziali per la difesa",
      "macro": "ING"
    },
    {
      "name": "Scienze del servizio sociale",
      "macro": "PSI"
    },
    {
      "name": "Scienze del servizio sociale e sociologia",
      "macro": "PSI"
    },
    {
      "name": "Scienze del servizio sociale professionale",
      "macro": "PSI"
    },
    {
      "name": "Scienze del servizio sociale: diritti e inclusione",
      "macro": "PSI"
    },
    {
      "name": "Scienze del turismo",
      "macro": "ECO"
    },
    {
      "name": "Scienze dell'ambiente e del clima",
      "macro": "SCI"
    },
    {
      "name": "Scienze dell'ambiente e della natura",
      "macro": "SCI"
    },
    {
      "name": "Scienze dell'amministrazione digitale",
      "macro": "UMA"
    },
    {
      "name": "Scienze dell'economia",
      "macro": "ECO"
    },
    {
      "name": "Scienze dell'educazione",
      "macro": "PSI"
    },
    {
      "name": "Scienze dell'educazione e della formazione",
      "macro": "PSI"
    },
    {
      "name": "Scienze dell'educazione permanente e della formazione continua",
      "macro": "PSI"
    },
    {
      "name": "Scienze dell'habitat sostenibile",
      "macro": "ING"
    },
    {
      "name": "Scienze della comunicazione",
      "macro": "UMA"
    },
    {
      "name": "Scienze della comunicazione pubblica, sociale e d'impresa",
      "macro": "ECO"
    },
    {
      "name": "Scienze della natura",
      "macro": "SCI"
    },
    {
      "name": "Scienze della natura e dell'ambiente",
      "macro": "SCI"
    },
    {
      "name": "Scienze della nutrizione per la salute umana",
      "macro": "SCI"
    },
    {
      "name": "Scienze della nutrizione umana",
      "macro": "SCI"
    },
    {
      "name": "Scienze della qualitá e sicurezza dei prodotti alimentari",
      "macro": "SCI"
    },
    {
      "name": "Scienze delle amministrazioni",
      "macro": "UMA"
    },
    {
      "name": "Scienze delle attivitá motorie e sportive",
      "macro": "SCI"
    },
    {
      "name": "Scienze delle produzioni agrarie mediterranee",
      "macro": "SCI"
    },
    {
      "name": "Scienze delle religioni",
      "macro": "UMA"
    },
    {
      "name": "SCIENZE E GESTIONE DELLE ATTIVITà MARITTIME",
      "macro": "SCI"
    },
    {
      "name": "Scienze e tecniche delle attività motorie preventive e adattate",
      "macro": "SCI"
    },
    {
      "name": "Scienze e tecniche di psicologia clinica e sperimentale",
      "macro": "PSI"
    },
    {
      "name": "Scienze e tecniche psicologiche",
      "macro": "PSI"
    },
    {
      "name": "Scienze e tecnologie agrarie",
      "macro": "SCI"
    },
    {
      "name": "Scienze e tecnologie agro-alimentari",
      "macro": "SCI"
    },
    {
      "name": "Scienze e tecnologie alimentari",
      "macro": "SCI"
    },
    {
      "name": "Scienze e tecnologie alimentari e gastronomiche",
      "macro": "MAT"
    },
    {
      "name": "Scienze e tecnologie cosmetiche e dei prodotti del benessere",
      "macro": "SCI"
    },
    {
      "name": "Scienze e tecnologie delle produzioni animali",
      "macro": "SCI"
    },
    {
      "name": "Scienze e tecnologie geologiche",
      "macro": "SCI"
    },
    {
      "name": "Scienze e tecnologie per l'ambiente",
      "macro": "SCI"
    },
    {
      "name": "Scienze e tecnologie per l'ambiente e il territorio",
      "macro": "SCI"
    },
    {
      "name": "Scienze e tecnologie per la montagna",
      "macro": "SCI"
    },
    {
      "name": "Scienze economico-aziendali",
      "macro": "ECO"
    },
    {
      "name": "Scienze filosofiche",
      "macro": "UMA"
    },
    {
      "name": "Scienze forestali e ambientali",
      "macro": "SCI"
    },
    {
      "name": "Scienze gastronomiche mediterranee",
      "macro": "MAT"
    },
    {
      "name": "Scienze geologiche",
      "macro": "SCI"
    },
    {
      "name": "Scienze giuridiche",
      "macro": "GIU"
    },
    {
      "name": "Scienze giuridiche della sicurezza",
      "macro": "GIU"
    },
    {
      "name": "Scienze investigative",
      "macro": "GIU"
    },
    {
      "name": "Scienze marittime e navali",
      "macro": "SCI"
    },
    {
      "name": "Scienze motorie",
      "macro": "SCI"
    },
    {
      "name": "Scienze motorie per lo sport e la salute",
      "macro": "SCI"
    },
    {
      "name": "Scienze motorie preventive e adattative",
      "macro": "SCI"
    },
    {
      "name": "Scienze motorie, sport e salute",
      "macro": "SCI"
    },
    {
      "name": "Scienze naturali ed ambientali",
      "macro": "SCI"
    },
    {
      "name": "Scienze nutraceutiche",
      "macro": "SCI"
    },
    {
      "name": "Scienze pedagogiche",
      "macro": "PSI"
    },
    {
      "name": "Scienze pedagogiche e della progettazione educativa",
      "macro": "PSI"
    },
    {
      "name": "Scienze per la pace: cooperazione internazionale e trasformazione dei conflitti",
      "macro": "UMA"
    },
    {
      "name": "Scienze per la pace: trasformazione dei conflitti e cooperazione allo sviluppo",
      "macro": "UMA"
    },
    {
      "name": "Scienze politiche",
      "macro": "UMA"
    },
    {
      "name": "Scienze politiche e delle relazioni internazionali",
      "macro": "UMA"
    },
    {
      "name": "Scienze politiche e giuridiche per l amministrazione",
      "macro": "GIU"
    },
    {
      "name": "Scienze politiche e sociali",
      "macro": "UMA"
    },
    {
      "name": "Scienze politiche, economiche e amministrative",
      "macro": "ECO"
    },
    {
      "name": "Scienze politiche, sicurezza internazionale e criminalità",
      "macro": "UMA"
    },
    {
      "name": "Scienze psicosociali della comunicazione",
      "macro": "UMA"
    },
    {
      "name": "Scienze statistiche",
      "macro": "MAT"
    },
    {
      "name": "Scienze statistiche e attuariali",
      "macro": "MAT"
    },
    {
      "name": "Scienze statistiche ed economiche",
      "macro": "ECO"
    },
    {
      "name": "Scienze statistiche, finanziarie e attuariali",
      "macro": "ECO"
    },
    {
      "name": "Scienze strategiche",
      "macro": "UMA"
    },
    {
      "name": "Scienze strategiche e della sicurezza",
      "macro": "UMA"
    },
    {
      "name": "Scienze strategiche e militari",
      "macro": "UMA"
    },
    {
      "name": "Scienze zootecniche",
      "macro": "SCI"
    },
    {
      "name": "Scritture e progetti per le arti visive e performative",
      "macro": "UMA"
    },
    {
      "name": "Scritture, immagini, media digitali",
      "macro": "UMA"
    },
    {
      "name": "Semiotica",
      "macro": "UMA"
    },
    {
      "name": "Service management",
      "macro": "ECO"
    },
    {
      "name": "Servizi giuridici",
      "macro": "GIU"
    },
    {
      "name": "Servizio sociale",
      "macro": "PSI"
    },
    {
      "name": "Sicurezza, devianza e gestione dei rischi",
      "macro": "GIU"
    },
    {
      "name": "Sicurezza, qualita' e sostenibilita' delle produzioni animali",
      "macro": "SCI"
    },
    {
      "name": "Sistemi agricoli innovativi",
      "macro": "SCI"
    },
    {
      "name": "Sistemi agricoli sostenibili",
      "macro": "SCI"
    },
    {
      "name": "Sistemi biotecnologici per lo sviluppo sostenibile",
      "macro": "SCI"
    },
    {
      "name": "Sistemi industriali e dell'informazione",
      "macro": "ING"
    },
    {
      "name": "Sistemi zootecnici sostenibili",
      "macro": "SCI"
    },
    {
      "name": "Sociologia",
      "macro": "PSI"
    },
    {
      "name": "Sociologia e ricerca sociale",
      "macro": "PSI"
    },
    {
      "name": "Sostenibilitá integrata dei sistemi agricoli",
      "macro": "SCI"
    },
    {
      "name": "Statistica e gestione delle informazioni",
      "macro": "MAT"
    },
    {
      "name": "Statistica e metodi per l'economia e la finanza",
      "macro": "ECO"
    },
    {
      "name": "Statistica per le assicurazioni e la finanza",
      "macro": "ECO"
    },
    {
      "name": "Statistica, economia e impresa",
      "macro": "ECO"
    },
    {
      "name": "Statistica, finanza e assicurazioni",
      "macro": "ECO"
    },
    {
      "name": "Statistical sciences",
      "macro": "MAT"
    },
    {
      "name": "Stochastics and data science",
      "macro": "MAT"
    },
    {
      "name": "Storia",
      "macro": "UMA"
    },
    {
      "name": "Storia dell'arte",
      "macro": "UMA"
    },
    {
      "name": "STORIA E CIVILTà",
      "macro": "UMA"
    },
    {
      "name": "Storia e culture contemporanee",
      "macro": "UMA"
    },
    {
      "name": "Strategia, management e controllo",
      "macro": "ECO"
    },
    {
      "name": "Studi dell'africa e dell'asia",
      "macro": "UMA"
    },
    {
      "name": "Studi orientali ed egittologici",
      "macro": "UMA"
    },
    {
      "name": "Sviluppo e cooperazione internazionale",
      "macro": "UMA"
    },
    {
      "name": "Sviluppo e innovazione sociale",
      "macro": "PSI"
    },
    {
      "name": "Sviluppo economico e relazioni internazionali",
      "macro": "ECO"
    },
    {
      "name": "Sviluppo locale e globale",
      "macro": "UMA"
    },
    {
      "name": "Safe Transport and Logistics Engineering",
      "macro": "ING"
    },
    {
      "name": "Safety Assessment of Xenobiotics and Biotechnological Products - Valutazione della sicurezza di xenobiotici e prodotti biotecnologici",
      "macro": "SCI"
    },
    {
      "name": "Salute e sport",
      "macro": "SCI"
    },
    {
      "name": "Saperi umanistici e tecnologie digitali",
      "macro": "UMA"
    },
    {
      "name": "Science and Technologies for Agriculture and Mountain Areas",
      "macro": "SCI"
    },
    {
      "name": "Science and Technology of bio and nanomaterials",
      "macro": "SCI"
    },
    {
      "name": "Science for the Conservation-Restoration of Cultural Heritage",
      "macro": "UMA"
    },
    {
      "name": "Scienza dei sistemi forestali e dell'ambiente",
      "macro": "SCI"
    },
    {
      "name": "Scienza del movimento per la salute ed il benessere",
      "macro": "SCI"
    },
    {
      "name": "Scienza dell'attività fisica per il benessere",
      "macro": "SCI"
    },
    {
      "name": "Scienza della Nutrizione",
      "macro": "SCI"
    },
    {
      "name": "Scienza e Cultura del Cibo",
      "macro": "SCI"
    },
    {
      "name": "Scienza e Innovazione del Cibo",
      "macro": "SCI"
    },
    {
      "name": "Scienza e Tecnica della Mediazione Linguistica",
      "macro": "UMA"
    },
    {
      "name": "Scienza e Tecnologia dei Materiali",
      "macro": "SCI"
    },
    {
      "name": "Scienza e Tecnologia dell'Industria Cosmetica",
      "macro": "SCI"
    },
    {
      "name": "Scienza e tecniche psicologiche",
      "macro": "PSI"
    },
    {
      "name": "Scienza ed economia del cibo",
      "macro": "ECO"
    },
    {
      "name": "Scienza, tecnica e didattica dello sport",
      "macro": "SCI"
    },
    {
      "name": "Scienze Agrarie e Forestali",
      "macro": "SCI"
    },
    {
      "name": "Scienze Agrarie e del Territorio",
      "macro": "SCI"
    },
    {
      "name": "Scienze Agrarie, forestali e ambientali",
      "macro": "SCI"
    },
    {
      "name": "Scienze Agro-Ambientali e Territoriali",
      "macro": "SCI"
    },
    {
      "name": "Scienze Ambientali Marine e Terrestri",
      "macro": "SCI"
    },
    {
      "name": "Scienze Ambientali e Naturali",
      "macro": "SCI"
    },
    {
      "name": "Scienze Animali",
      "macro": "SCI"
    },
    {
      "name": "Scienze Antropologiche e Geografiche per i Patrimoni Culturali e la Valorizzazione dei Territori",
      "macro": "UMA"
    },
    {
      "name": "Scienze Archeologiche",
      "macro": "UMA"
    },
    {
      "name": "Scienze Biologiche per l'Ambiente",
      "macro": "SCI"
    },
    {
      "name": "Scienze Biomediche Traslazionali",
      "macro": "MED"
    },
    {
      "name": "Scienze Biomolecolari, Genomiche e Cellulari",
      "macro": "SCI"
    },
    {
      "name": "Scienze Chimiche e Cosmetiche",
      "macro": "SCI"
    },
    {
      "name": "Scienze Cognitive Computazionali",
      "macro": "PSI"
    },
    {
      "name": "Scienze Cognitive della Comunicazione e dell'Azione",
      "macro": "PSI"
    },
    {
      "name": "Scienze Computazionali",
      "macro": "MAT"
    },
    {
      "name": "Scienze Criminologiche per l'investigazione e la sicurezza",
      "macro": "GIU"
    },
    {
      "name": "Scienze Economiche",
      "macro": "ECO"
    },
    {
      "name": "Scienze Economiche e Aziendali",
      "macro": "ECO"
    },
    {
      "name": "Scienze Economiche e Finanziarie",
      "macro": "ECO"
    },
    {
      "name": "Scienze Economiche per la Finanza, le Aziende e la Sostenibilità",
      "macro": "ECO"
    },
    {
      "name": "Scienze Enogastronomiche di Montagna",
      "macro": "MAT"
    },
    {
      "name": "Scienze Enologiche",
      "macro": "SCI"
    },
    {
      "name": "Scienze Farmaceutiche Applicate",
      "macro": "SCI"
    },
    {
      "name": "Scienze Farmaceutiche Applicate-Controllo Qualità",
      "macro": "SCI"
    },
    {
      "name": "Scienze Faunistiche",
      "macro": "SCI"
    },
    {
      "name": "Scienze Fisiche",
      "macro": "MAT"
    },
    {
      "name": "Scienze Gastronomiche",
      "macro": "MAT"
    },
    {
      "name": "Scienze Geologiche Ambientali",
      "macro": "SCI"
    },
    {
      "name": "Scienze Geologiche Applicate alla Sostenibilità Ambientale",
      "macro": "SCI"
    },
    {
      "name": "Scienze Geologiche e Tecnologie per l'Ambiente",
      "macro": "SCI"
    },
    {
      "name": "Scienze Geologiche per la Gestione dei Rischi ambientali e le Georisorse",
      "macro": "SCI"
    },
    {
      "name": "Scienze Giuridiche dell'innovazione e della sostenibilità",
      "macro": "GIU"
    },
    {
      "name": "Scienze Giuridiche per il Lavoro e per la Pubblica Amministrazione",
      "macro": "GIU"
    },
    {
      "name": "Scienze Giuridiche per l'Innovazione organizzativa e la Coesione sociale",
      "macro": "GIU"
    },
    {
      "name": "Scienze Giuridiche per l'immigrazione e l'interculturalità nelle Pubbliche Amministrazioni",
      "macro": "GIU"
    },
    {
      "name": "Scienze Giuridiche per l'internazionalizzazione e l'innovazione dell'impresa",
      "macro": "GIU"
    },
    {
      "name": "Scienze Informatiche",
      "macro": "MAT"
    },
    {
      "name": "Scienze Internazionali e Diplomatiche",
      "macro": "UMA"
    },
    {
      "name": "Scienze Linguistiche per l'intercultura e la formazione",
      "macro": "UMA"
    },
    {
      "name": "Scienze Motorie e Diritto dello Sport",
      "macro": "SCI"
    },
    {
      "name": "Scienze Motorie e dello Sport",
      "macro": "SCI"
    },
    {
      "name": "Scienze Motorie e Sportive",
      "macro": "SCI"
    },
    {
      "name": "Scienze Naturali",
      "macro": "SCI"
    },
    {
      "name": "Scienze Naturali e Ambientali",
      "macro": "SCI"
    },
    {
      "name": "Scienze Nutraceutiche e Alimenti Funzionali",
      "macro": "SCI"
    },
    {
      "name": "Scienze Pedagogiche e Neuroscienze Cognitive",
      "macro": "PSI"
    },
    {
      "name": "Scienze Pedagogiche e Progettazione Educativa",
      "macro": "PSI"
    },
    {
      "name": "Scienze Pedagogiche e dei Processi Formativi",
      "macro": "PSI"
    },
    {
      "name": "Scienze Pedagogiche per la comunicazione inclusiva mediata dalla LIS",
      "macro": "PSI"
    },
    {
      "name": "Scienze Politiche e dell'Amministrazione",
      "macro": "UMA"
    },
    {
      "name": "Scienze Politiche, Amministrazione e Servizi",
      "macro": "UMA"
    },
    {
      "name": "Scienze Psicologiche",
      "macro": "PSI"
    },
    {
      "name": "Scienze Riabilitative delle Professioni Sanitarie",
      "macro": "MED"
    },
    {
      "name": "Scienze Statistiche per le Decisioni",
      "macro": "MAT"
    },
    {
      "name": "Scienze Storiche",
      "macro": "UMA"
    },
    {
      "name": "Scienze Strategiche e Giuridiche della Difesa e della Sicurezza",
      "macro": "GIU"
    },
    {
      "name": "Scienze Tossicologiche e Controllo di Qualità",
      "macro": "SCI"
    },
    {
      "name": "Scienze Vivaistiche e Progettazione degli Spazi Verdi",
      "macro": "SCI"
    },
    {
      "name": "Scienze agrarie per la sostenibilità",
      "macro": "SCI"
    },
    {
      "name": "Scienze agro-zootecniche",
      "macro": "SCI"
    },
    {
      "name": "Scienze alimentari ed enogastronomiche",
      "macro": "MAT"
    },
    {
      "name": "Scienze ambientali e politiche per la sostenibilità",
      "macro": "SCI"
    },
    {
      "name": "Scienze amministrative e giuridiche delle organizzazioni pubbliche e private",
      "macro": "GIU"
    },
    {
      "name": "Scienze amministrative, politiche ed economiche",
      "macro": "ECO"
    },
    {
      "name": "Scienze archivistiche e biblioteconomiche",
      "macro": "ECO"
    },
    {
      "name": "Scienze attuariali e finanziarie",
      "macro": "ECO"
    },
    {
      "name": "Scienze aziendali",
      "macro": "ECO"
    },
    {
      "name": "Scienze biologiche ambientali",
      "macro": "SCI"
    },
    {
      "name": "Scienze biotecnologiche mediche, veterinarie e forensi",
      "macro": "MED"
    },
    {
      "name": "Scienze biotecnologiche veterinarie",
      "macro": "MED"
    },
    {
      "name": "Scienze cognitive e processi decisionali",
      "macro": "PSI"
    },
    {
      "name": "Scienze criminologiche, investigative e di contrasto ai crimini informatici",
      "macro": "GIU"
    },
    {
      "name": "Scienze degli Alimenti e della Nutrizione Umana",
      "macro": "SCI"
    },
    {
      "name": "Scienze degli alimenti e della nutrizione",
      "macro": "SCI"
    },
    {
      "name": "Scienze dei prodotti naturali per la salute",
      "macro": "SCI"
    },
    {
      "name": "Scienze dei sistemi naturali",
      "macro": "SCI"
    },
    {
      "name": "Scienze del Corpo e della Mente",
      "macro": "PSI"
    },
    {
      "name": "Scienze del Turismo Ambientale",
      "macro": "ECO"
    },
    {
      "name": "Scienze del governo",
      "macro": "UMA"
    },
    {
      "name": "Scienze del governo e Politiche pubbliche",
      "macro": "UMA"
    },
    {
      "name": "Scienze del libro e del documento",
      "macro": "UMA"
    },
    {
      "name": "Scienze del libro, del documento, del patrimonio culturale",
      "macro": "UMA"
    },
    {
      "name": "Scienze del linguaggio",
      "macro": "UMA"
    },
    {
      "name": "Scienze del movimento e dello sport",
      "macro": "SCI"
    },
    {
      "name": "Scienze del patrimonio audiovisivo e dell'educazione ai media",
      "macro": "PSI"
    },
    {
      "name": "Scienze del servizio sociale e del non profit",
      "macro": "PSI"
    },
    {
      "name": "Scienze del testo per le professioni digitali",
      "macro": "UMA"
    },
    {
      "name": "Scienze del turismo ad indirizzo manageriale",
      "macro": "ECO"
    },
    {
      "name": "Scienze del turismo e comunità locale",
      "macro": "ECO"
    },
    {
      "name": "Scienze del turismo e dei servizi turistici",
      "macro": "ECO"
    },
    {
      "name": "Scienze del turismo per il management e i beni culturali",
      "macro": "UMA"
    },
    {
      "name": "Scienze del turismo sostenibile",
      "macro": "ECO"
    },
    {
      "name": "Scienze del turismo, della cultura e dell'impresa",
      "macro": "UMA"
    },
    {
      "name": "Scienze del turismo: impresa, cultura e territorio",
      "macro": "UMA"
    },
    {
      "name": "Scienze dell'Alimentazione",
      "macro": "SCI"
    },
    {
      "name": "Scienze dell'Alimentazione e Nutrizione Umana",
      "macro": "SCI"
    },
    {
      "name": "Scienze dell'Alimentazione, Salute e Benessere dell'Uomo",
      "macro": "SCI"
    },
    {
      "name": "Scienze dell'Amministrazione",
      "macro": "UMA"
    },
    {
      "name": "Scienze dell'Amministrazione e dell'Organizzazione",
      "macro": "UMA"
    },
    {
      "name": "Scienze dell'Amministrazione e delle Relazioni Internazionali",
      "macro": "UMA"
    },
    {
      "name": "Scienze dell'Architettura",
      "macro": "ING"
    },
    {
      "name": "Scienze dell'Architettura per il Patrimonio",
      "macro": "ING"
    },
    {
      "name": "Scienze dell'Educazione e dei Processi Formativi",
      "macro": "PSI"
    },
    {
      "name": "Scienze dell'Informazione: Tecniche giornalistiche e Social Media",
      "macro": "UMA"
    },
    {
      "name": "Scienze dell'Esercizio Fisico per il Benessere",
      "macro": "SCI"
    },
    {
      "name": "Scienze dell'Organizzazione",
      "macro": "ECO"
    },
    {
      "name": "Scienze dell'alimentazione e salute",
      "macro": "SCI"
    },
    {
      "name": "Scienze dell'amministrazione e della politica",
      "macro": "UMA"
    },
    {
      "name": "Scienze dell'antichità",
      "macro": "UMA"
    },
    {
      "name": "Scienze dell'antichità: archeologia, letterature e storia",
      "macro": "UMA"
    },
    {
      "name": "Scienze dell'architettura e del progetto",
      "macro": "ING"
    },
    {
      "name": "Scienze dell'educazione degli adulti e della formazione continua",
      "macro": "PSI"
    },
    {
      "name": "Scienze dell'educazione per il nido e le professioni socio-pedagogiche",
      "macro": "PSI"
    },
    {
      "name": "Scienze dell'educazione per Educatori e Formatori",
      "macro": "PSI"
    },
    {
      "name": "Scienze dell'esercizio fisico per il benessere e la salute",
      "macro": "SCI"
    },
    {
      "name": "Scienze della Alimentazione e della Nutrizione Umana",
      "macro": "SCI"
    },
    {
      "name": "Scienze della Comunicazione e Cultura",
      "macro": "UMA"
    },
    {
      "name": "Scienze della Mediazione Interlinguistica e Interculturale",
      "macro": "UMA"
    },
    {
      "name": "Scienze della Mediazione linguistica",
      "macro": "UMA"
    },
    {
      "name": "Scienze della Montagna e dell'Agricoltura",
      "macro": "SCI"
    },
    {
      "name": "Scienze della Natura e dell'Uomo",
      "macro": "SCI"
    },
    {
      "name": "Scienze della Nutrizione e dell'Alimentazione",
      "macro": "SCI"
    },
    {
      "name": "Scienze della Politica e Istituzioni Internazionali",
      "macro": "UMA"
    },
    {
      "name": "Scienze della Politica e Sicurezza Internazionale",
      "macro": "UMA"
    },
    {
      "name": "Scienze della Pubblica Amministrazione e del Lavoro",
      "macro": "UMA"
    },
    {
      "name": "Scienze della Storia e del Documento",
      "macro": "UMA"
    },
    {
      "name": "Scienze della Terra e dell'Ambiente",
      "macro": "SCI"
    },
    {
      "name": "Scienze della Terra per la Gestione dei Rischi e dell'Ambiente",
      "macro": "SCI"
    },
    {
      "name": "Scienze della comunicazione, Marketing e digital media",
      "macro": "ECO"
    },
    {
      "name": "Scienze della difesa e della sicurezza ( L/DS )",
      "macro": "UMA"
    },
    {
      "name": "Scienze della formazione e della comunicazione",
      "macro": "PSI"
    },
    {
      "name": "Scienze della formazione primaria",
      "macro": "PSI"
    },
    {
      "name": "Scienze della moda e del costume",
      "macro": "UMA"
    },
    {
      "name": "Scienze della politica e della comunicazione istituzionale",
      "macro": "UMA"
    },
    {
      "name": "Scienze della politica, della sicurezza internazionale e della comunicazione pubblica",
      "macro": "UMA"
    },
    {
      "name": "Scienze della produzione e protezione delle piante",
      "macro": "SCI"
    },
    {
      "name": "Scienze della ristorazione e distribuzione degli alimenti",
      "macro": "SCI"
    },
    {
      "name": "Scienze della società e del servizio sociale",
      "macro": "PSI"
    },
    {
      "name": "Scienze della terra",
      "macro": "SCI"
    },
    {
      "name": "Scienze della valutazione motorio-sportiva e tecniche di analisi e progettazione dello sport per disabili",
      "macro": "SCI"
    },
    {
      "name": "Scienze delle Attività Motorie Preventive ed Adattate",
      "macro": "SCI"
    },
    {
      "name": "Scienze delle Attività Motorie e Sportive",
      "macro": "SCI"
    },
    {
      "name": "Scienze delle Attività Motorie, Sportive e dell’Educazione Psicomotoria",
      "macro": "SCI"
    },
    {
      "name": "Scienze delle Investigazioni",
      "macro": "GIU"
    },
    {
      "name": "Scienze delle Politiche e dei Servizi Sociali",
      "macro": "PSI"
    },
    {
      "name": "Scienze delle Produzioni e delle Risorse del Mare",
      "macro": "SCI"
    },
    {
      "name": "Scienze delle Produzioni e delle Tecnologie Agrarie",
      "macro": "SCI"
    },
    {
      "name": "Scienze delle Professioni Sanitarie Tecniche Assistenziali",
      "macro": "MED"
    },
    {
      "name": "Scienze delle Professioni Sanitarie Tecniche Diagnostiche",
      "macro": "MED"
    },
    {
      "name": "Scienze delle Pubbliche Amministrazioni",
      "macro": "UMA"
    },
    {
      "name": "Scienze delle amministrazioni e delle organizzazioni complesse",
      "macro": "UMA"
    },
    {
      "name": "Scienze delle amministrazioni, consulenza del lavoro e innovazione sociale",
      "macro": "ECO"
    },
    {
      "name": "Scienze delle attività motorie preventive e adattate",
      "macro": "SCI"
    },
    {
      "name": "Scienze delle attività motorie preventive e adattate per la salute",
      "macro": "SCI"
    },
    {
      "name": "Scienze delle attività motorie, sportive e dell'educazione psicomotoria",
      "macro": "SCI"
    },
    {
      "name": "Scienze delle comunicazioni, media e tecnologie digitali",
      "macro": "UMA"
    },
    {
      "name": "Scienze delle produzioni animali sostenibili",
      "macro": "SCI"
    },
    {
      "name": "Scienze delle produzioni zootecniche",
      "macro": "SCI"
    },
    {
      "name": "Scienze delle professioni sanitarie della prevenzione",
      "macro": "MED"
    },
    {
      "name": "Scienze dello Spettacolo e della Produzione audiovisiva",
      "macro": "UMA"
    },
    {
      "name": "Scienze dello spettacolo",
      "macro": "UMA"
    },
    {
      "name": "Scienze dello spettacolo e della produzione multimediale",
      "macro": "UMA"
    },
    {
      "name": "Scienze dello sport e della prestazione fisica",
      "macro": "SCI"
    },
    {
      "name": "Scienze dello sviluppo e della cooperazione internazionale",
      "macro": "UMA"
    },
    {
      "name": "Scienze e Culture Enogastronomiche",
      "macro": "MAT"
    },
    {
      "name": "Scienze e Culture Gastronomiche",
      "macro": "MAT"
    },
    {
      "name": "Scienze e Didattica dei Sistemi Naturali",
      "macro": "PSI"
    },
    {
      "name": "Scienze e Gestione della Natura",
      "macro": "SCI"
    },
    {
      "name": "Scienze e Nanotecnologie per la Sostenibilità",
      "macro": "SCI"
    },
    {
      "name": "Scienze e Tecniche Psicologiche dei Processi Cognitivi",
      "macro": "PSI"
    },
    {
      "name": "Scienze e Tecniche Psicologiche per le Sfide Contemporanee",
      "macro": "PSI"
    },
    {
      "name": "Scienze e Tecniche dell'Attività Motoria Preventiva e Adattata",
      "macro": "SCI"
    },
    {
      "name": "Scienze e Tecniche dell'Attività Sportiva",
      "macro": "SCI"
    },
    {
      "name": "Scienze e Tecniche dell'Edilizia",
      "macro": "ING"
    },
    {
      "name": "Scienze e Tecniche delle Attività Motorie Preventive e Adattate e delle Attività sportive",
      "macro": "SCI"
    },
    {
      "name": "Scienze e Tecniche dello Sport",
      "macro": "SCI"
    },
    {
      "name": "Scienze e Tecniche di Psicologia Cognitiva",
      "macro": "PSI"
    },
    {
      "name": "Scienze e Tecnologie Agrarie e degli Alimenti",
      "macro": "SCI"
    },
    {
      "name": "Scienze e Tecnologie Agrarie per la Transizione Ecologica",
      "macro": "SCI"
    },
    {
      "name": "Scienze e Tecnologie Agroalimentari",
      "macro": "SCI"
    },
    {
      "name": "Scienze e Tecnologie Agroingegneristiche e Forestali",
      "macro": "ING"
    },
    {
      "name": "Scienze e Tecnologie Alimentari e Food Design",
      "macro": "ING"
    },
    {
      "name": "Scienze e Tecnologie Chimiche",
      "macro": "SCI"
    },
    {
      "name": "Scienze e Tecnologie Cosmetiche",
      "macro": "SCI"
    },
    {
      "name": "Scienze e Tecnologie Erboristiche",
      "macro": "SCI"
    },
    {
      "name": "Scienze e Tecnologie Forestali e Ambientali",
      "macro": "SCI"
    },
    {
      "name": "Scienze e Tecnologie Informatiche",
      "macro": "MAT"
    },
    {
      "name": "Scienze e Tecnologie Naturalistiche e Ambientali",
      "macro": "SCI"
    },
    {
      "name": "Scienze e Tecnologie Sostenibili per l'Ambiente",
      "macro": "SCI"
    },
    {
      "name": "Scienze e Tecnologie animali",
      "macro": "SCI"
    },
    {
      "name": "Scienze e Tecnologie degli Alimenti",
      "macro": "SCI"
    },
    {
      "name": "Scienze e Tecnologie dei Trasporti",
      "macro": "ING"
    },
    {
      "name": "Scienze e Tecnologie dei sistemi alimentari",
      "macro": "SCI"
    },
    {
      "name": "Scienze e Tecnologie della Comunicazione",
      "macro": "UMA"
    },
    {
      "name": "Scienze e Tecnologie per i Beni Culturali",
      "macro": "UMA"
    },
    {
      "name": "Scienze e Tecnologie per i Media",
      "macro": "UMA"
    },
    {
      "name": "Scienze e Tecnologie per l'Ambiente e le Risorse",
      "macro": "SCI"
    },
    {
      "name": "Scienze e Tecnologie per la Conservazione dei Beni Culturali",
      "macro": "UMA"
    },
    {
      "name": "Scienze e Tecnologie per la Sostenibilità Ambientale",
      "macro": "SCI"
    },
    {
      "name": "Scienze e Tecnologie per le Attività Motorie e Sportive",
      "macro": "SCI"
    },
    {
      "name": "Scienze e Tecnologie viticole ed enologiche",
      "macro": "SCI"
    },
    {
      "name": "Scienze e cultura della gastronomia",
      "macro": "MAT"
    },
    {
      "name": "Scienze e culture agroalimentari del Mediterraneo",
      "macro": "SCI"
    },
    {
      "name": "Scienze e culture gastronomiche per la sostenibilità",
      "macro": "MAT"
    },
    {
      "name": "Scienze e gestione delle risorse faunistico-ambientali",
      "macro": "SCI"
    },
    {
      "name": "Scienze e lingue per la comunicazione",
      "macro": "UMA"
    },
    {
      "name": "Scienze e logistica del trasporto marittimo ed aereo",
      "macro": "ECO"
    },
    {
      "name": "Scienze e management dello sport e delle attività motorie",
      "macro": "SCI"
    },
    {
      "name": "Scienze e materiali per la conservazione e il restauro",
      "macro": "UMA"
    },
    {
      "name": "Scienze e politiche per l'ambiente",
      "macro": "SCI"
    },
    {
      "name": "Scienze e tecniche del servizio sociale",
      "macro": "PSI"
    },
    {
      "name": "Scienze e tecniche del turismo culturale",
      "macro": "UMA"
    },
    {
      "name": "Scienze e tecniche della comunicazione",
      "macro": "UMA"
    },
    {
      "name": "Scienze e tecniche delle amministrazioni pubbliche",
      "macro": "UMA"
    },
    {
      "name": "Scienze e tecniche delle attività motorie a curvatura biomedica",
      "macro": "SCI"
    },
    {
      "name": "Scienze e tecniche delle attività motorie e sportive",
      "macro": "SCI"
    },
    {
      "name": "Scienze e tecniche dello sport e delle attività motorie preventive e adattate",
      "macro": "SCI"
    },
    {
      "name": "Scienze e tecniche psicologiche cliniche e preventive",
      "macro": "PSI"
    },
    {
      "name": "Scienze e tecnologie biologiche",
      "macro": "SCI"
    },
    {
      "name": "Scienze e tecnologie biomolecolari",
      "macro": "SCI"
    },
    {
      "name": "Scienze e tecnologie dei sistemi forestali",
      "macro": "SCI"
    },
    {
      "name": "Scienze e tecnologie della chimica industriale",
      "macro": "SCI"
    },
    {
      "name": "Scienze e tecnologie della navigazione",
      "macro": "ING"
    },
    {
      "name": "Scienze e tecnologie forestali ed ambientali",
      "macro": "SCI"
    },
    {
      "name": "Scienze e tecnologie geografiche per l'ambiente e la salute",
      "macro": "SCI"
    },
    {
      "name": "Scienze e tecnologie per alimenti sostenibili",
      "macro": "SCI"
    },
    {
      "name": "Scienze e tecnologie per il verde e il paesaggio",
      "macro": "ING"
    },
    {
      "name": "Scienze e tecnologie per l'ambiente e la natura",
      "macro": "SCI"
    },
    {
      "name": "Scienze e tecnologie per la difesa e la conservazione del Suolo",
      "macro": "SCI"
    },
    {
      "name": "Scienze economiche e bancarie",
      "macro": "ECO"
    },
    {
      "name": "Scienze economiche, del lavoro e dei sistemi socio-sanitari",
      "macro": "MED"
    },
    {
      "name": "Scienze erboristiche e nutraceutiche",
      "macro": "SCI"
    },
    {
      "name": "Scienze filosofiche e storiche",
      "macro": "UMA"
    },
    {
      "name": "Scienze geologiche applicate",
      "macro": "SCI"
    },
    {
      "name": "Scienze geologiche per i rischi, le risorse e l'ambiente",
      "macro": "SCI"
    },
    {
      "name": "Scienze geologiche, georisorse e territorio",
      "macro": "SCI"
    },
    {
      "name": "Scienze giuridiche del lavoro e della sicurezza",
      "macro": "GIU"
    },
    {
      "name": "Scienze giuridiche della prevenzione e della sicurezza",
      "macro": "GIU"
    },
    {
      "name": "Scienze giuridiche della sicurezza e della prevenzione",
      "macro": "GIU"
    },
    {
      "name": "Scienze giuridiche e criminologiche per la sicurezza e l'intelligence",
      "macro": "GIU"
    },
    {
      "name": "Scienze giuridiche e innovazione",
      "macro": "GIU"
    },
    {
      "name": "Scienze giuridiche in Diritto, Banca e Finanza",
      "macro": "GIU"
    },
    {
      "name": "Scienze giuridiche per le nuove tecnologie",
      "macro": "GIU"
    },
    {
      "name": "Scienze infermieristiche e ostetriche",
      "macro": "MED"
    },
    {
      "name": "Scienze internazionali",
      "macro": "UMA"
    },
    {
      "name": "Scienze internazionali e istituzioni europee",
      "macro": "UMA"
    },
    {
      "name": "Scienze internazionali, dello sviluppo e della cooperazione",
      "macro": "UMA"
    },
    {
      "name": "Scienze letterarie e dei beni culturali",
      "macro": "UMA"
    },
    {
      "name": "Scienze linguistiche",
      "macro": "UMA"
    },
    {
      "name": "Scienze linguistiche e comunicazione interculturale",
      "macro": "UMA"
    },
    {
      "name": "Scienze linguistiche, letterarie e della traduzione",
      "macro": "UMA"
    },
    {
      "name": "Scienze matematiche per l'intelligenza artificiale",
      "macro": "MAT"
    },
    {
      "name": "Scienze motorie per la prevenzione ed il benessere",
      "macro": "SCI"
    },
    {
      "name": "Scienze motorie per la salute e l'invecchiamento attivo (Healthy Ageing)",
      "macro": "SCI"
    },
    {
      "name": "Scienze motorie preventive ed adattate",
      "macro": "SCI"
    },
    {
      "name": "Scienze motorie, sport e benessere",
      "macro": "SCI"
    },
    {
      "name": "Scienze motorie, sportive e benessere dell'uomo",
      "macro": "SCI"
    },
    {
      "name": "Scienze motorie, sportive e della salute",
      "macro": "SCI"
    },
    {
      "name": "Scienze nautiche, aeronautiche e meteo-oceanografiche",
      "macro": "ING"
    },
    {
      "name": "Scienze nutraceutiche e della salute alimentare",
      "macro": "SCI"
    },
    {
      "name": "Scienze pedagogiche e management della formazione per lo sviluppo sostenibile",
      "macro": "PSI"
    },
    {
      "name": "Scienze pedagogiche e scienze dell'educazione degli adulti e della formazione continua",
      "macro": "PSI"
    },
    {
      "name": "Scienze pedagogiche per la consulenza e la progettazione educativa",
      "macro": "PSI"
    },
    {
      "name": "Scienze pedagogiche per la progettazione, la consulenza e il coordinamento dei percorsi educativi",
      "macro": "PSI"
    },
    {
      "name": "Scienze per i Servizi Giuridici",
      "macro": "GIU"
    },
    {
      "name": "Scienze per il paesaggio",
      "macro": "ING"
    },
    {
      "name": "Scienze per l'Ambiente e la Natura",
      "macro": "SCI"
    },
    {
      "name": "Scienze per l'ambiente marino e costiero",
      "macro": "SCI"
    },
    {
      "name": "Scienze per l'investigazione e la sicurezza",
      "macro": "GIU"
    },
    {
      "name": "Scienze per la Cooperazione Internazionale",
      "macro": "UMA"
    },
    {
      "name": "Scienze per la Natura e per l'Ambiente",
      "macro": "SCI"
    },
    {
      "name": "Scienze per la Valorizzazione del patrimonio Gastronomico",
      "macro": "MAT"
    },
    {
      "name": "Scienze per la conservazione e la diagnostica dei beni culturali",
      "macro": "UMA"
    },
    {
      "name": "Scienze per la formazione e la consulenza pedagogica nelle organizzazioni",
      "macro": "PSI"
    },
    {
      "name": "Scienze politiche e Relazioni internazionali",
      "macro": "UMA"
    },
    {
      "name": "Scienze politiche e di governo",
      "macro": "UMA"
    },
    {
      "name": "Scienze politiche e strategie globali",
      "macro": "UMA"
    },
    {
      "name": "Scienze politiche e studi internazionali",
      "macro": "UMA"
    },
    {
      "name": "Scienze politiche, Relazioni internazionali, Diritti umani",
      "macro": "UMA"
    },
    {
      "name": "Scienze politiche, amministrazione e relazioni internazionali",
      "macro": "UMA"
    },
    {
      "name": "Scienze politiche, diplomatiche e governo delle amministrazioni",
      "macro": "UMA"
    },
    {
      "name": "Scienze politiche, economiche e del governo",
      "macro": "ECO"
    },
    {
      "name": "Scienze politiche, sociali e internazionali",
      "macro": "UMA"
    },
    {
      "name": "Scienze psicologiche cognitive e psicobiologiche",
      "macro": "PSI"
    },
    {
      "name": "Scienze psicologiche dello sviluppo, della personalità e delle relazioni interpersonali",
      "macro": "PSI"
    },
    {
      "name": "Scienze psicologiche per la formazione",
      "macro": "PSI"
    },
    {
      "name": "Scienze psicologiche per la prevenzione e la cura",
      "macro": "PSI"
    },
    {
      "name": "Scienze psicologiche sociali e del lavoro",
      "macro": "PSI"
    },
    {
      "name": "Scienze sociali per la globalizzazione",
      "macro": "UMA"
    },
    {
      "name": "Scienze sociali per la sostenibilità e la cooperazione internazionale",
      "macro": "UMA"
    },
    {
      "name": "Scienze sociologiche",
      "macro": "PSI"
    },
    {
      "name": "Scienze statistiche per la Finanza",
      "macro": "ECO"
    },
    {
      "name": "Scienze storiche e del Patrimonio culturale",
      "macro": "UMA"
    },
    {
      "name": "Scienze storiche e filosofiche",
      "macro": "UMA"
    },
    {
      "name": "Scienze storiche e orientalistiche",
      "macro": "UMA"
    },
    {
      "name": "Scienze storiche e sociali",
      "macro": "UMA"
    },
    {
      "name": "Scienze storiche. Medioevo, età moderna, età contemporanea",
      "macro": "UMA"
    },
    {
      "name": "Scienze storiche: Società, culture e istituzioni d'Europa",
      "macro": "UMA"
    },
    {
      "name": "Scienze strategiche marittimo-portuali",
      "macro": "SCI"
    },
    {
      "name": "Scienze tecnico assistenziali veterinarie",
      "macro": "MED"
    },
    {
      "name": "Scienze umane per l'ambiente",
      "macro": "SCI"
    },
    {
      "name": "Scienze umanistiche per la comunicazione",
      "macro": "UMA"
    },
    {
      "name": "Scienze umanistiche. Discipline letterarie, artistiche e filosofiche.",
      "macro": "UMA"
    },
    {
      "name": "Scienze viticole ed enologiche",
      "macro": "SCI"
    },
    {
      "name": "Scienze, culture e politiche gastronomiche per il benessere",
      "macro": "MAT"
    },
    {
      "name": "Scienze, metodi e didattiche delle attività sportive",
      "macro": "SCI"
    },
    {
      "name": "Scienze, tecnologie e sicurezza delle produzioni animali",
      "macro": "SCI"
    },
    {
      "name": "Scritture e produzioni dello spettacolo e dei media",
      "macro": "UMA"
    },
    {
      "name": "Security and human rights",
      "macro": "UMA"
    },
    {
      "name": "Security, Intelligence and Strategic Studies",
      "macro": "UMA"
    },
    {
      "name": "Servizi Giuridici per l'Impresa",
      "macro": "GIU"
    },
    {
      "name": "Servizi giuridici per Lavoro, Pubblica Amministrazione, Sport e Terzo Settore",
      "macro": "GIU"
    },
    {
      "name": "Servizi giuridici per imprese, amministrazioni e no-profit",
      "macro": "GIU"
    },
    {
      "name": "Servizi giuridici per l'innovazione digitale",
      "macro": "GIU"
    },
    {
      "name": "Servizi legali all'impresa e alla pubblica amministrazione",
      "macro": "GIU"
    },
    {
      "name": "Servizio Sociale e Innovazione",
      "macro": "PSI"
    },
    {
      "name": "Servizio Sociale e Politiche Sociali",
      "macro": "PSI"
    },
    {
      "name": "Servizio Sociale e Politiche Sociali per il contrasto alle vulnerabilità",
      "macro": "PSI"
    },
    {
      "name": "Servizio sociale e Sociologia",
      "macro": "PSI"
    },
    {
      "name": "Servizio sociale in ambiti complessi",
      "macro": "PSI"
    },
    {
      "name": "Servizio sociale in contesti disagiati e criminogeni",
      "macro": "PSI"
    },
    {
      "name": "Servizio sociale, comunità e vulnerabilità",
      "macro": "PSI"
    },
    {
      "name": "Servizio sociale, diseguaglianze e vulnerabilità sociale",
      "macro": "PSI"
    },
    {
      "name": "Servizio sociale, politiche sociali e studi sociologici e ricerca sociale",
      "macro": "PSI"
    },
    {
      "name": "Servizio sociale, politiche sociali, programmazione e gestione dei servizi",
      "macro": "PSI"
    },
    {
      "name": "Sicurezza Alimentare",
      "macro": "SCI"
    },
    {
      "name": "Sicurezza Informatica",
      "macro": "MAT"
    },
    {
      "name": "Sicurezza Informatica e Tecnologie Cloud",
      "macro": "MAT"
    },
    {
      "name": "Sicurezza degli Alimenti di Origine Animale e Salute",
      "macro": "SCI"
    },
    {
      "name": "Sicurezza dei sistemi e delle reti informatiche",
      "macro": "MAT"
    },
    {
      "name": "Sicurezza dei sistemi software",
      "macro": "MAT"
    },
    {
      "name": "Sicurezza, qualità e sostenibilità delle produzioni animali",
      "macro": "SCI"
    },
    {
      "name": "Sistemi agrari",
      "macro": "SCI"
    },
    {
      "name": "Sistemi agricoli mediterranei",
      "macro": "SCI"
    },
    {
      "name": "Sistemi digitali in agricoltura",
      "macro": "SCI"
    },
    {
      "name": "Sistemi forestali Mediterranei",
      "macro": "SCI"
    },
    {
      "name": "Small Business Management in International Markets",
      "macro": "ECO"
    },
    {
      "name": "Smart Industry Engineering",
      "macro": "ING"
    },
    {
      "name": "Smart Sustainable Agriculture Systems in Mountain Areas",
      "macro": "SCI"
    },
    {
      "name": "Smart Technologies for Sports and Health",
      "macro": "SCI"
    },
    {
      "name": "Social sciences and digital data",
      "macro": "PSI"
    },
    {
      "name": "Social sciences for global challenges",
      "macro": "UMA"
    },
    {
      "name": "Sociologia Digitale e Analisi del Web",
      "macro": "PSI"
    },
    {
      "name": "Sociologia del Cambiamento Ambientale e Digitale",
      "macro": "PSI"
    },
    {
      "name": "Sociologia delle reti, dell' informazione e dell' innovazione",
      "macro": "PSI"
    },
    {
      "name": "Sociologia e Criminologia",
      "macro": "PSI"
    },
    {
      "name": "Sociologia e Servizio Sociale",
      "macro": "PSI"
    },
    {
      "name": "Sociologia e sfide globali",
      "macro": "PSI"
    },
    {
      "name": "Sociologia per la sostenibilità e analisi dei processi globali",
      "macro": "PSI"
    },
    {
      "name": "Sociology and Social Research",
      "macro": "PSI"
    },
    {
      "name": "Software: Science and Technology",
      "macro": "MAT"
    },
    {
      "name": "Software Engineering",
      "macro": "ING"
    },
    {
      "name": "Sostenibilità ambientale, territorio e transizione ecologica",
      "macro": "SCI"
    },
    {
      "name": "Sostenibilità sociale e management del welfare",
      "macro": "PSI"
    },
    {
      "name": "Space and astronautical engineering",
      "macro": "ING"
    },
    {
      "name": "Spatial Planning",
      "macro": "ING"
    },
    {
      "name": "Specialized translation",
      "macro": "UMA"
    },
    {
      "name": "Sport Management",
      "macro": "ECO"
    },
    {
      "name": "Sport and Health Promotion",
      "macro": "SCI"
    },
    {
      "name": "Sport, benessere e attività motoria in ambiente naturale",
      "macro": "SCI"
    },
    {
      "name": "Statistica",
      "macro": "MAT"
    },
    {
      "name": "Statistica Matematica e Trattamento Informatico dei Dati",
      "macro": "MAT"
    },
    {
      "name": "Statistica e Data Science",
      "macro": "MAT"
    },
    {
      "name": "Statistica e Tecnologie per l'Analisi dei Dati",
      "macro": "MAT"
    },
    {
      "name": "Statistica e informatica per l'azienda, la finanza e le assicurazioni",
      "macro": "ECO"
    },
    {
      "name": "Statistica gestionale",
      "macro": "MAT"
    },
    {
      "name": "Statistica per Data Science",
      "macro": "MAT"
    },
    {
      "name": "Statistica per i Big Data",
      "macro": "MAT"
    },
    {
      "name": "Statistica per l'Economia e l'Impresa",
      "macro": "ECO"
    },
    {
      "name": "Statistica per l'assicurazione e business analytics",
      "macro": "ECO"
    },
    {
      "name": "Statistica per le Tecnologie e le Scienze",
      "macro": "MAT"
    },
    {
      "name": "Statistica, Economia e Scienze Sociali",
      "macro": "ECO"
    },
    {
      "name": "Statistica, Finanza e Scienze attuariali",
      "macro": "ECO"
    },
    {
      "name": "Statistical Methods and Applications",
      "macro": "MAT"
    },
    {
      "name": "Storia dell'arte e beni culturali",
      "macro": "UMA"
    },
    {
      "name": "Storia dell'arte e studi museali",
      "macro": "UMA"
    },
    {
      "name": "Storia dell'arte e valorizzazione del patrimonio artistico",
      "macro": "UMA"
    },
    {
      "name": "Storia delle arti",
      "macro": "UMA"
    },
    {
      "name": "Storia delle arti e conservazione dei beni artistici",
      "macro": "UMA"
    },
    {
      "name": "Storia e Critica delle Arti e dello Spettacolo",
      "macro": "UMA"
    },
    {
      "name": "Storia e Filosofia",
      "macro": "UMA"
    },
    {
      "name": "Storia e Società",
      "macro": "UMA"
    },
    {
      "name": "Storia e Storie del Mondo Contemporaneo",
      "macro": "UMA"
    },
    {
      "name": "Storia e Tutela dei beni artistici e musicali",
      "macro": "UMA"
    },
    {
      "name": "Storia e civiltà europee",
      "macro": "UMA"
    },
    {
      "name": "Storia e critica dell'arte",
      "macro": "UMA"
    },
    {
      "name": "Storia e cultura dei paesi mediterranei",
      "macro": "UMA"
    },
    {
      "name": "Storia e tutela dei beni archeologici, artistici, archivistici e librari",
      "macro": "UMA"
    },
    {
      "name": "Storia e valorizzazione dei beni culturali",
      "macro": "UMA"
    },
    {
      "name": "Storia globale delle civiltà e dei territori",
      "macro": "UMA"
    },
    {
      "name": "Storia, Antropologia, Religioni",
      "macro": "UMA"
    },
    {
      "name": "Storia, Critica e Linguaggi delle Arti e dello Spettacolo",
      "macro": "UMA"
    },
    {
      "name": "Storia, Società e Culture del Mediterraneo",
      "macro": "UMA"
    },
    {
      "name": "Storia, politica e relazioni internazionali",
      "macro": "UMA"
    },
    {
      "name": "Storia, territorio e società globale",
      "macro": "UMA"
    },
    {
      "name": "Strategia e governance dell'impresa",
      "macro": "ECO"
    },
    {
      "name": "Strategia, consulenza e logistica aziendale",
      "macro": "ECO"
    },
    {
      "name": "Strategic Communication",
      "macro": "UMA"
    },
    {
      "name": "Strategie culturali per la cooperazione e lo sviluppo",
      "macro": "UMA"
    },
    {
      "name": "Strategie d'impresa e management",
      "macro": "ECO"
    },
    {
      "name": "Strategie di comunicazione",
      "macro": "UMA"
    },
    {
      "name": "Strategie di comunicazione nella società digitale",
      "macro": "UMA"
    },
    {
      "name": "Strategie e tecniche della comunicazione",
      "macro": "UMA"
    },
    {
      "name": "Studi Diplomatici, Internazionali e sulla Sicurezza Globale",
      "macro": "UMA"
    },
    {
      "name": "Studi Filosofici",
      "macro": "UMA"
    },
    {
      "name": "Studi Filosofici e Storici",
      "macro": "UMA"
    },
    {
      "name": "Studi Globali e UE",
      "macro": "UMA"
    },
    {
      "name": "Studi Globali. Storia, politiche, culture",
      "macro": "UMA"
    },
    {
      "name": "Studi Internazionali",
      "macro": "UMA"
    },
    {
      "name": "Studi Italiani, Classici e Storia Europea",
      "macro": "UMA"
    },
    {
      "name": "Studi Umanistici",
      "macro": "UMA"
    },
    {
      "name": "Studi geopolitici e internazionali",
      "macro": "UMA"
    },
    {
      "name": "Studi letterari e culturali",
      "macro": "UMA"
    },
    {
      "name": "Studi letterari e filosofici",
      "macro": "UMA"
    },
    {
      "name": "Studi storici e filologico-letterari",
      "macro": "UMA"
    },
    {
      "name": "Studi storici e patrimonio scrittorio dall'antichità all'età contemporanea",
      "macro": "UMA"
    },
    {
      "name": "Studi storici, antropologici e geografici",
      "macro": "UMA"
    },
    {
      "name": "Studi storici. Dall'Antico al Contemporaneo",
      "macro": "UMA"
    },
    {
      "name": "Studi storici: età medievale, moderna, contemporanea",
      "macro": "UMA"
    },
    {
      "name": "Studi storico-artistici",
      "macro": "UMA"
    },
    {
      "name": "Studi strategici e politiche della sicurezza",
      "macro": "UMA"
    },
    {
      "name": "Studi strategici per la sicurezza e le politiche internazionali",
      "macro": "UMA"
    },
    {
      "name": "Studi transmediterranei: migrazione, cooperazione e sviluppo",
      "macro": "UMA"
    },
    {
      "name": "Supply Chain Management",
      "macro": "ECO"
    },
    {
      "name": "Sustainability Management and Circular Economy",
      "macro": "ECO"
    },
    {
      "name": "Sustainable Blue Economy",
      "macro": "ECO"
    },
    {
      "name": "Sustainable Building Engineering",
      "macro": "ING"
    },
    {
      "name": "Sustainable Business for Societal Challenges",
      "macro": "ECO"
    },
    {
      "name": "Sustainable Industrial Engineering",
      "macro": "ING"
    },
    {
      "name": "Sustainable Industrial Pharmaceutical Biotechnology",
      "macro": "SCI"
    },
    {
      "name": "Sustainable Territorial Development – Climate Change, diversity, cooperation",
      "macro": "SCI"
    },
    {
      "name": "Sustainable agriculture",
      "macro": "SCI"
    },
    {
      "name": "Sustainable and Resilient Pavement Engineering",
      "macro": "ING"
    },
    {
      "name": "Sustainable chemistry and technologies for circular economy",
      "macro": "ECO"
    },
    {
      "name": "Sustainable food systems",
      "macro": "SCI"
    },
    {
      "name": "Sustainable industrial chemistry",
      "macro": "SCI"
    },
    {
      "name": "Sustainable natural resource management",
      "macro": "ECO"
    },
    {
      "name": "Sustainable polymer and process chemistry",
      "macro": "SCI"
    },
    {
      "name": "Sviluppo Sostenibile, Cooperazione e Gestione dei Conflitti",
      "macro": "UMA"
    },
    {
      "name": "Sviluppo Turistico e Territori Digitali",
      "macro": "ECO"
    },
    {
      "name": "Tecniche dell'edilizia",
      "macro": "ING"
    },
    {
      "name": "Tecniche della prevenzione nell’ambiente e nei luoghi di lavoro",
      "macro": "SCI"
    },
    {
      "name": "Tecniche della protezione civile e sicurezza del territorio",
      "macro": "ING"
    },
    {
      "name": "Tecniche di allevamento animale ed educazione cinofila",
      "macro": "PSI"
    },
    {
      "name": "Tecniche di assistenza veterinaria",
      "macro": "MED"
    },
    {
      "name": "Tecniche di radiologia medica, per immagini e radioterapia",
      "macro": "MED"
    },
    {
      "name": "Tecniche industriali di prodotto e di processo",
      "macro": "ING"
    },
    {
      "name": "Tecnologie digitali per le costruzioni",
      "macro": "ING"
    },
    {
      "name": "Tecnologie e biotecnologie degli alimenti",
      "macro": "SCI"
    },
    {
      "name": "Tecnologie e diagnostica per i beni culturali",
      "macro": "UMA"
    },
    {
      "name": "Tecnologie eco-sostenibili e tossicologia ambientale",
      "macro": "SCI"
    },
    {
      "name": "Traduzione, didattica e relazioni culturali per le lingue e le letterature moderne",
      "macro": "PSI"
    },
    {
      "name": "Transportation engineering and mobility",
      "macro": "ING"
    },
    {
      "name": "Teatro e Arti Performative",
      "macro": "UMA"
    },
    {
      "name": "Teatro, Arti, Letterature. Studi internazionali sull’intermedialità",
      "macro": "UMA"
    },
    {
      "name": "Teatro, Cinema, Media",
      "macro": "UMA"
    },
    {
      "name": "Techniques and methods in psychological science",
      "macro": "PSI"
    },
    {
      "name": "Tecnica della riabilitazione psichiatrica",
      "macro": "MED"
    },
    {
      "name": "Tecniche Erboristiche",
      "macro": "SCI"
    },
    {
      "name": "Tecniche audiometriche",
      "macro": "MED"
    },
    {
      "name": "Tecniche audioprotesiche",
      "macro": "MED"
    },
    {
      "name": "Tecniche della Costruzione e Gestione del Territorio",
      "macro": "ING"
    },
    {
      "name": "Tecniche dell'edilizia e del territorio",
      "macro": "ING"
    },
    {
      "name": "Tecniche della prevenzione nell'ambiente e nei luoghi di lavoro",
      "macro": "SCI"
    },
    {
      "name": "Tecniche di fisiopatologia cardiocircolatoria e perfusione cardiovascolare",
      "macro": "MED"
    },
    {
      "name": "Tecniche di neurofisiopatologia",
      "macro": "MED"
    },
    {
      "name": "Tecniche di laboratorio biomedico",
      "macro": "MED"
    },
    {
      "name": "Tecniche digitali per la gestione sostenibile delle costruzioni, dell'ambiente e del territorio",
      "macro": "ING"
    },
    {
      "name": "Tecniche e Tecnologie per le Costruzioni e il Territorio",
      "macro": "ING"
    },
    {
      "name": "Tecniche ortopediche",
      "macro": "MED"
    },
    {
      "name": "Tecniche per l'agricoltura sostenibile",
      "macro": "SCI"
    },
    {
      "name": "Tecniche per l'edilizia e il territorio",
      "macro": "ING"
    },
    {
      "name": "Tecniche per la Bioedilizia",
      "macro": "ING"
    },
    {
      "name": "Tecniche per la meccanica e la produzione",
      "macro": "ING"
    },
    {
      "name": "Tecniche per le Costruzioni Civili e la Gestione del Territorio",
      "macro": "ING"
    },
    {
      "name": "Tecniche per le Costruzioni e il Territorio",
      "macro": "ING"
    },
    {
      "name": "Tecniche, Patrimonio, Territori dell'Industria - Techniques, Patrimoine, Territoires de l'Industrie",
      "macro": "UMA"
    },
    {
      "name": "Tecnico del benessere animale e delle produzioni",
      "macro": "SCI"
    },
    {
      "name": "Tecnologie Alimentari",
      "macro": "SCI"
    },
    {
      "name": "Tecnologie Alimentari ed Enologiche",
      "macro": "SCI"
    },
    {
      "name": "Tecnologie agrarie",
      "macro": "SCI"
    },
    {
      "name": "Tecnologie Digitali e Comunicazione per le Industrie Creative",
      "macro": "UMA"
    },
    {
      "name": "Tecnologie Industriali",
      "macro": "ING"
    },
    {
      "name": "Tecnologie Industriali per la Transizione Energetica e Digitale",
      "macro": "ING"
    },
    {
      "name": "Tecnologie Viticole, Enologiche, Alimentari",
      "macro": "SCI"
    },
    {
      "name": "Tecnologie agrarie e gestione sostenibile degli agroecosistemi",
      "macro": "SCI"
    },
    {
      "name": "Tecnologie dei sistemi informatici",
      "macro": "MAT"
    },
    {
      "name": "Tecnologie del Legno",
      "macro": "ING"
    },
    {
      "name": "Tecnologie del Mare e della Navigazione",
      "macro": "ING"
    },
    {
      "name": "Tecnologie digitali per il patrimonio culturale",
      "macro": "UMA"
    },
    {
      "name": "Tecnologie digitali per l'Architettura",
      "macro": "ING"
    },
    {
      "name": "Tecnologie digitali per l'edilizia e il territorio",
      "macro": "ING"
    },
    {
      "name": "Tecnologie digitali per le costruzioni, l'ambiente e il territorio",
      "macro": "ING"
    },
    {
      "name": "Tecnologie e Diagnostica per la Conservazione del Patrimonio Culturale",
      "macro": "UMA"
    },
    {
      "name": "Tecnologie e Gestione dell'Impresa Casearia",
      "macro": "ECO"
    },
    {
      "name": "Tecnologie e trasformazioni avanzate per il settore legno arredo edilizia",
      "macro": "ING"
    },
    {
      "name": "Tecnologie forestali e ambientali",
      "macro": "SCI"
    },
    {
      "name": "Tecnologie per il territorio e l'ambiente agro-forestale",
      "macro": "SCI"
    },
    {
      "name": "Tecnologie per l'Energia e l'Ambiente",
      "macro": "SCI"
    },
    {
      "name": "Tecnologie per l'Industria Intelligente",
      "macro": "ING"
    },
    {
      "name": "Tecnologie per l'edilizia e il territorio",
      "macro": "ING"
    },
    {
      "name": "Tecnologie per l'industria digitale",
      "macro": "ING"
    },
    {
      "name": "Tecnologie per l'industria manifatturiera",
      "macro": "ING"
    },
    {
      "name": "Tecnologie per la Conservazione e il Restauro dei Beni Culturali",
      "macro": "UMA"
    },
    {
      "name": "Tecnologie per la Transizione Ecologica in Agricoltura",
      "macro": "SCI"
    },
    {
      "name": "Tecnologie per la gestione sostenibile dei sistemi zootecnici",
      "macro": "SCI"
    },
    {
      "name": "Tecnologie per l’Ambiente, le Costruzioni e il Territorio",
      "macro": "ING"
    },
    {
      "name": "Telecommunication Engineering",
      "macro": "ING"
    },
    {
      "name": "Telecommunication Engineering: Smart Sensing, Computing and Networking",
      "macro": "ING"
    },
    {
      "name": "Telecommunications Engineering - Ingegneria delle Telecomunicazioni",
      "macro": "ING"
    },
    {
      "name": "Telecommunications Engineering: Advanced Technologies and Services",
      "macro": "ING"
    },
    {
      "name": "Telecommunications and Internet Technologies Engineering",
      "macro": "ING"
    },
    {
      "name": "Televisione, cinema e new media",
      "macro": "UMA"
    },
    {
      "name": "Teoria e storia delle arti e dell'immagine",
      "macro": "UMA"
    },
    {
      "name": "Teoria e tecnologia della comunicazione",
      "macro": "UMA"
    },
    {
      "name": "Teorie e metodologie del digital learning",
      "macro": "PSI"
    },
    {
      "name": "Teorie e tecniche della mediazione interlinguistica",
      "macro": "UMA"
    },
    {
      "name": "Teorie, culture e tecniche per il Servizio sociale",
      "macro": "PSI"
    },
    {
      "name": "Terapia della neuro e psicomotricità dell'età evolutiva",
      "macro": "MED"
    },
    {
      "name": "Terapia occupazionale",
      "macro": "MED"
    },
    {
      "name": "Text Sciences and Culture Enhancement in the Digital Age",
      "macro": "UMA"
    },
    {
      "name": "The Ancient Mediterranean World. History, Archaeology and Art",
      "macro": "UMA"
    },
    {
      "name": "Tossicologia Chimica e Ambientale",
      "macro": "SCI"
    },
    {
      "name": "Tossicologia per la Sicurezza umana e ambientale",
      "macro": "SCI"
    },
    {
      "name": "Tourism Economics and Management",
      "macro": "ECO"
    },
    {
      "name": "Tourism Management and Sustainability",
      "macro": "ECO"
    },
    {
      "name": "Tourism Strategy, Cultural Heritage and Made in Italy",
      "macro": "UMA"
    },
    {
      "name": "Tourism systems and hospitality management",
      "macro": "ECO"
    },
    {
      "name": "Trade e Consumer Marketing",
      "macro": "ECO"
    },
    {
      "name": "Tradizione classica e archeologia del Mediterraneo",
      "macro": "UMA"
    },
    {
      "name": "Tradizione e interpretazione dei testi letterari",
      "macro": "UMA"
    },
    {
      "name": "Traduzione",
      "macro": "UMA"
    },
    {
      "name": "Traduzione Tecnico-scientifica e Interpretariato",
      "macro": "UMA"
    },
    {
      "name": "Traduzione e Interpretariato",
      "macro": "UMA"
    },
    {
      "name": "Traduzione e Mediazione culturale",
      "macro": "UMA"
    },
    {
      "name": "Traduzione e interpretazione",
      "macro": "UMA"
    },
    {
      "name": "Traduzione specialistica",
      "macro": "UMA"
    },
    {
      "name": "Traduzione specialistica e interpretazione di conferenza",
      "macro": "UMA"
    },
    {
      "name": "Traduzione, interpretariato e comunicazione digitale",
      "macro": "UMA"
    },
    {
      "name": "Transnational German Studies",
      "macro": "UMA"
    },
    {
      "name": "Transnational and European Legal Studies",
      "macro": "GIU"
    },
    {
      "name": "Transport Systems Engineering",
      "macro": "ING"
    },
    {
      "name": "Trasformazione Digitale",
      "macro": "ECO"
    },
    {
      "name": "Tropical and Subtropical Agriculture",
      "macro": "SCI"
    },
    {
      "name": "Turismo Enogastronomico",
      "macro": "UMA"
    },
    {
      "name": "Turismo e spettacolo",
      "macro": "ECO"
    },
    {
      "name": "Turismo e valorizzazione del territorio",
      "macro": "ECO"
    },
    {
      "name": "Turismo sostenibile",
      "macro": "ECO"
    },
    {
      "name": "Turismo, Territori e Imprese",
      "macro": "ECO"
    },
    {
      "name": "Turismo, cultura, sostenibilità",
      "macro": "UMA"
    },
    {
      "name": "Turismo, management e cultura",
      "macro": "UMA"
    },
    {
      "name": "Turismo, territorio e sviluppo locale",
      "macro": "ECO"
    },
    {
      "name": "Tutela e Benessere Animale",
      "macro": "SCI"
    },
    {
      "name": "Unione europea, processi globali e sostenibilità dello sviluppo",
      "macro": "UMA"
    },
    {
      "name": "Urban Design per la Città in Transizione",
      "macro": "ING"
    },
    {
      "name": "Urbanistica Sostenibile",
      "macro": "ING"
    },
    {
      "name": "Urbanistica e Pianificazione del Territorio",
      "macro": "ING"
    },
    {
      "name": "Urbanistica. Progetto ambientale della città e del territorio",
      "macro": "ING"
    },
    {
      "name": "Valorization and Sustainable Development of Mountain Areas",
      "macro": "SCI"
    },
    {
      "name": "Valorizzazione dei territori e Turismi sostenibili",
      "macro": "ECO"
    },
    {
      "name": "Valorizzazione del patrimonio culturale materiale e immateriale",
      "macro": "UMA"
    },
    {
      "name": "Valorizzazione e tutela dell'ambiente e del territorio montano",
      "macro": "SCI"
    },
    {
      "name": "Valutazione del funzionamento individuale in psicologia clinica e della salute",
      "macro": "PSI"
    },
    {
      "name": "Veterinary Medicine",
      "macro": "MED"
    },
    {
      "name": "Viticoltura ed Enologia",
      "macro": "SCI"
    },
    {
      "name": "Viticoltura, Enologia ed Enomarketing",
      "macro": "ECO"
    },
    {
      "name": "Viticoltura, enologia e mercati vitivinicoli",
      "macro": "ECO"
    },
    {
      "name": "Viticulture, enology and wine marketing",
      "macro": "ECO"
    },
    {
      "name": "Volcanology",
      "macro": "SCI"
    },
    {
      "name": "Water and geological risk engineering",
      "macro": "ING"
    },
    {
      "name": "Welfare management e innovazione sociale",
      "macro": "PSI"
    },
    {
      "name": "Welfare, società e lavoro sociale",
      "macro": "PSI"
    },
    {
      "name": "Wellness, sport and health",
      "macro": "SCI"
    },
    {
      "name": "Wildlife Management, Conservation, and Control",
      "macro": "ECO"
    },
    {
      "name": "Work, organizational and personnel psychology",
      "macro": "PSI"
    },
    {
      "name": "World Politics and International Relations",
      "macro": "UMA"
    },
    {
      "name": "Yacht Design",
      "macro": "ING"
    }
  ]
};

/* Prezzi e link aggiornati presi dal prodotto Shopify (campo adc.modale_prezzi).
   Se il campo è vuoto o manca, la modale usa i dati qui sopra, come prima. */
(function () {
  var el = document.getElementById("adc-modale-prezzi");
  var dati = window.MODALE_SELEZIONE_CORSO_DATI;
  if (!el || !dati || !dati.catalog) return;
  var prezzi;
  try { prezzi = JSON.parse(el.textContent); } catch (e) { return; }
  if (!prezzi || typeof prezzi !== "object") return;
  dati.catalog.forEach(function (c) {
    var chiave = [c.name, c.payoff, c.tier, c.level, c.commitment, c.macro].map(function (x) { return x || ""; }).join("|");
    var p = prezzi[chiave];
    if (!p) return;
    ["priceFull", "priceDiscounted", "buyFullLink", "buyInstallmentsLink"].forEach(function (campo) {
      if (campo in p) c[campo] = p[campo];
    });
  });
})();
